<template>
  <!--:style="'background-image: url(' + ExpoHallBackgroundImage + ');'"-->
  <div
    @click="onClickHandler"
    id="divTop"
    :class="
      !mobileView
        ? 'desktop-view booth-wrapper expoDiv'
        : 'boothpage-lite-wrapper substitute-booth-page'
    "
    :style="!mobileView ? '' : ''"
  >
    <div class="booth-empodium-hld" v-if="isPodiumEnabled">
      <img src="../assets/Images/booth-empodium.png" />
      <div class="empodium-top">
        <h5>Upcoming<br />Events</h5>
      </div>
      <div class="empodium-description">
        <h5 v-if="podiumTitle">{{ podiumTitle }}</h5>
        <p v-if="podiumDescription">
          {{ podiumDescription }}
        </p>
      </div>
      <div class="empodium-bottom-buttons">
        <a
          class="single-bottom-buttons"
          v-if="knowMoreLink"
          :href="knowMoreLink"
          target="_blank"
          >KNOW MORE
          <v-icon color="#ffffff" size="25px">mdi-arrow-right</v-icon></a
        >
        <v-btn
          :loading="registering"
          class="single-bottom-buttons"
          @click="
            Register(ExhibitorData[0].id, ExhibitorData[0].Name, podiumTitle)
          "
        >
          REGISTER
          <v-icon color="#ffffff" size="25px">mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </div>
    <div
      v-if="!protectNav && !mobileView && $store.state.totalExpoBoothCount > 1"
      class="expo-menu pl-2"
      style="
        position: absolute;
        top: 3%;
        left: 3%;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.4);
      "
    >
      <ul style="margin: 0; padding: 0">
        <li style="none; display: block;">
          <router-link
            v-if="showAerialView == false && showBirdView == false"
            class="tab-link"
            v-on:click.prevent="clearRefresh"
            v-bind:to="{ name: 'ExhibitorsHall' }"
            style="
              display: flex;
              justify-content: flex-start;
              align-items: center;
              padding: 10px 18px;
              border-bottom: 1px solid #dfdfdf;
              color: #16171d;
              font-weight: 600;
              font-size: 14px;
              font-family: 'Poppins', sans-serif !important;
            "
          >
            <span style="margin-right: 10px">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <defs></defs>
                <path
                  id="expo-hall.svg"
                  class="cls-1"
                  d="M1840,1102h8v8h-8v-8Zm10,0h8v8h-8v-8Zm-10,10h8v8h-8v-8Zm10,0h8v8h-8v-8Z"
                  transform="translate(-1840 -1102)"
                />
              </svg>
            </span>
            <span id="sphallName">Exhibitors</span>
          </router-link>

          <router-link
            v-else-if="showBirdView == true && showAerialView == false"
            class="tab-link"
            v-on:click.prevent="clearRefresh"
            v-bind:to="{ name: 'Expohallbird' }"
            style="
              display: flex;
              justify-content: flex-start;
              align-items: center;
              padding: 10px 18px;
              border-bottom: 1px solid #dfdfdf;
              color: #16171d;
              font-weight: 600;
              font-size: 14px;
              font-family: 'Poppins', sans-serif !important;
            "
          >
            <span style="margin-right: 10px">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <defs></defs>
                <path
                  id="expo-hall.svg"
                  class="cls-1"
                  d="M1840,1102h8v8h-8v-8Zm10,0h8v8h-8v-8Zm-10,10h8v8h-8v-8Zm10,0h8v8h-8v-8Z"
                  transform="translate(-1840 -1102)"
                />
              </svg>
            </span>
            <span id="sphallName"></span>
          </router-link>

          <router-link
            v-else
            class="tab-link"
            v-on:click.prevent="clearRefresh"
            v-bind:to="{ name: 'Expohallariel' }"
            style="
              display: flex;
              justify-content: flex-start;
              align-items: center;
              padding: 10px 18px;
              border-bottom: 1px solid #dfdfdf;
              color: #16171d;
              font-weight: 600;
              font-size: 14px;
              font-family: 'Poppins', sans-serif !important;
            "
          >
            <span style="margin-right: 10px">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <defs></defs>
                <path
                  id="expo-hall.svg"
                  class="cls-1"
                  d="M1840,1102h8v8h-8v-8Zm10,0h8v8h-8v-8Zm-10,10h8v8h-8v-8Zm10,0h8v8h-8v-8Z"
                  transform="translate(-1840 -1102)"
                />
              </svg>
            </span>
            <span id="sphallName"></span>
          </router-link>
        </li>
        <li id="liPrv" style="none; display: block;">
          <a
            href="#"
            @click.prevent="LoadNext(prv)"
            :data-tag="'exibitorview/' + prv + '/LeftArrow'"
            style="
              display: flex;
              justify-content: flex-start;
              align-items: center;
              padding: 10px 18px;
              border-bottom: 1px solid #dfdfdf;
              color: #16171d;
              font-weight: 600;
              font-size: 14px;
              font-family: 'Poppins', sans-serif !important;
            "
          >
            <span style="margin-right: 10px">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="16"
                viewBox="0 0 12 16"
              >
                <defs></defs>
                <path
                  id="previous-booth.svg"
                  class="cls-1"
                  d="M1995,1103v16l-12-8Z"
                  transform="translate(-1983 -1103)"
                />
              </svg>
            </span>
            {{ $t("expoview.prv") }}
          </a>
        </li>
        <li id="liNxt" style="none; display: block;">
          <a
            @click.prevent="LoadNext(nxt)"
            :data-tag="'exibitorview/' + prv + '/RightArrow'"
            style="
              display: flex;
              justify-content: flex-start;
              align-items: center;
              padding: 10px 18px;
              color: #16171d;
              font-weight: 600;
              font-size: 14px;
              font-family: 'Poppins', sans-serif !important;
            "
          >
            <span style="margin-right: 10px">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="16"
                viewBox="0 0 12 16"
              >
                <defs></defs>
                <path
                  id="next-booth.svg"
                  class="cls-1"
                  d="M2233,1103v16l12-8Z"
                  transform="translate(-2233 -1103)"
                />
              </svg>
            </span>
            {{ $t("expoview.nxt") }}
          </a>
        </li>
      </ul>
    </div>

    <div v-if="!mobileView" class="businesscard-exchange-wrapper">
      <div
        id="divBusinessCard"
        v-show="allowBusinessCardExchange"
        :class="
          !roomId
            ? 'exchange-card-section include-appointment'
            : 'exchange-card-section'
        "
      >
        <p
          id="btnBusinessCard"
          v-on:click="showDiv('dvexchangeCard')"
          class="mr-2"
        >
          {{ $t("expoview.exchangecard") }}
        </p>

        <v-btn
          id="btnAppointment"
          class="expo-details-appo-btn"
          @click="openSchedulePopup('meeting')"
          color="#1a73e8"
        >
          Appointments
        </v-btn>

        <!--v-if="roomId"-->
        <v-btn
          color="#288aef"
          v-if="roomId"
          id="btnJoinChat"
          class="expo-details-join-chat-btn mr-2"
          style="cursor: pointer"
          @click="joinExpoBoothSepcificChat(roomId)"
        >
          Chat
        </v-btn>
        <v-menu
          offset-y
          open-on-hover
          nudge-bottom="1"
          v-if="showBoothEditButton"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              v-bind="attrs"
              v-on="on"
              class="edit-expo-btn"
              width="194px"
              height="40px"
              color="#000000"
              ><v-icon color="#fff" size="20px" class="mr-0"
                >mdi-arrow-down</v-icon
              >
              Booth Admin
              <label class="drop-toggle"></label>
            </v-btn>
          </template>

          <v-list>
            <v-list-item dense>
              <span
                class="px-3 cursor-pointer"
                @click="editBooth()"
                v-if="!disableEditBtn"
              >
                <v-icon color="#333" size="20px" class="mr-1"
                  >mdi-pencil-outline</v-icon
                >
                Edit Booth
              </span>
            </v-list-item>

            <v-list-item dense>
              <span class="px-3 cursor-pointer" @click="downloadAnalytics()">
                <v-icon color="#333" size="20px" class="mr-1"
                  >mdi-tray-arrow-down</v-icon
                >
                Download Analytics
              </span>
            </v-list-item>
          </v-list>
        </v-menu>

        <div class="business-card-dropdown" id="dvexchangeCard">
          <div class="bznscard-msgbox-top">
            <h4>{{ $t("expoview.leavemsg") }}</h4>
            <a
              href="javascript: void(0);"
              class="close-butn"
              v-on:click="closeDiv('dvexchangeCard')"
              >x</a
            >
          </div>
          <div class="message-area">
            <textarea
              cols="5"
              rows="5"
              value
              id="txtMsgArea"
              placeholder="Your message"
            ></textarea>
            <div class="message-area-bottom">
              <p class="messege-txt">
                {{ $t("expoview.exchangemsg") }}
              </p>
              <v-btn
                :loading="businessCardSending"
                :data-tag="'Exchange Bussiness Card -  Exhibitor -' + BoothName"
                @click="ExchangeBusinessCard"
              >
                {{ $t("expoview.send") }}
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!mobileView"
      class="expo-round-table-sec page-effect"
      style="visibility: hidden"
      id="dvMainRoundTable"
      :data-tag="'exhibitorview/' + BoothName + '/joinRoundtablevideo'"
    >
      <section class="new-round-table">
        <div
          class="container-fluid clsRoundtableSpl p-0"
          :data-tag="'exhibitorview/' + BoothName + '/joinRoundtablevideo'"
        >
          <div
            class="row d-md-flex table-list justify-content-center round-tableexpo"
            id="lstTables"
            :data-tag="'exhibitorview/' + BoothName + '/joinRoundtablevideo'"
          >
            <div
              v-if="tableTopic && tableTopic.TopicId"
              :id="tableTopic.TopicId"
              class="rt-comp"
              style="
                margin-top: 6px;
                height: 240px;
                width: 160px;
                cursor: pointer;
              "
              @click="
                GoToTRList(tableTopic.ExhibitorId, tableTopic.ExhibitorName)
              "
            >
              <div class="rt-comp-header">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <h5 v-on="on">{{ tableTopic.TopicName }}</h5>
                  </template>
                  <span class="v-tooltip-content v-tooltip-top">{{
                    tableTopic.TopicName
                  }}</span>
                </v-tooltip>
                <p class="m-0">Be the first to join</p>
              </div>
              <div class="rt-comp-body">
                <v-img
                  src="../assets/Images/rt-seat.jpg"
                  class="rt-comp-chair"
                ></v-img>
                <div class="rt-comp-logo">
                  <v-img
                    v-if="tableTopic.TopicLogo"
                    :src="getCDNUrl(tableTopic.TopicLogo)"
                  ></v-img>
                  <v-img v-else src="../assets/Images/rt-logo.png"></v-img>
                </div>
              </div>
              <div class="rt-comp-footer">
                <a href="javascript:void(0);">
                  {{ "Grab A Seat" }}
                </a>
              </div>
            </div>
            <RoundTable
              v-else
              v-for="table in allRoundTables"
              :key="'rt_' + table.TableId"
              pageId="exrt"
              :table="table"
              @JoinRT="JoinRT"
              style="margin-top: 6px; height: 240px; width: 160px"
            >
            </RoundTable>
            <!--<div
              v-for="roundtable in allRoundTables"
              v-bind:key="roundtable.id"
              v-bind:class="
                'col-lg-12 col-md-4 col-6 exhibitors-box-hld edit-table-btn ' +
                roundtable.id
              "
              v-show="roundtable.IsVisible"
            >
              <div
                class="new-exhibitors-box"
                :data-tag="'exibitorview/' + roundtable.hostId + '/Roundtable'"
                v-on:click="
                  JoinTable(
                    roundtable.hostId,
                    GlobalKeysData.videoParamsEncryptURL,
                    GlobalKeysData.IsBroadcastInNewTab,
                    roundtable.id,
                    roundtable.Name,
                    '0',
                    roundtable.ChannelPrefix,
                    roundtable.BroadcastID,
                    roundtable.BroadcastCertificate,
                    roundtable.BroadcastSpeakerApiUrl,
                    roundtable.BroadcastAttendeeApiUrl,
                    roundtable.BroadcastvalidityHours,
                    roundtable.UserID,
                    eventId2,
                    roundtable.BroadcastStartURL,
                    roundtable.BroadcastViewURL,
                    roundtable.IsHost,
                    roundtable.IsMappedasAttendee,
                    roundtable.PreAssigned,
                    roundtable.SpectatorEnabled,
                    roundtable.Capacity,
                    roundtable.Occupied,
                    roundtable.IsVisible,
                    roundtable.IsTableFull,
                    GlobalKeysData.IsOpenInternalPlayer,
                    roundtable.StreamingClient,
                    roundtable.Zoom_Detail
                  )
                "
              >
                <a>
                  <h3
                    :data-tag="
                      'exhibitorview/' + BoothName + '/joinRoundtablevideo'
                    "
                  >
                    {{ roundtable.Name }}
                  </h3>
                  <div
                    class="img-hld"
                    :data-tag="
                      'exhibitorview/' + BoothName + '/joinRoundtablevideo'
                    "
                  >
                    <img
                      v-bind:src="roundtable.imgsrc"
                      :data-tag="
                        'exhibitorview/' + BoothName + '/joinRoundtablevideo'
                      "
                      v-bind:alt="roundtable.Name"
                    />
                  </div>
                </a>
                <h4
                  v-bind:class="roundtable.LabelCss"
                  :data-tag="
                    'exhibitorview/' + BoothName + '/joinRoundtablevideo'
                  "
                >
                  <a
                    href="#"
                    :data-tag="
                      'exhibitorview/' + BoothName + '/joinRoundtablevideo'
                    "
                    >{{ roundtable.tableLabel }}</a
                  >
                </h4>
              </div>
            </div>-->
          </div>
        </div>
        <div
          class="modal fade modal-container"
          id="modalOpenBroadcast"
          role="dialog"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <button
                v-on:click="CloseModal()"
                type="button"
                class="close"
                title="Close"
                data-tag="roundtableVideoClose"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18.03"
                  height="18.031"
                  viewBox="0 0 18.03 18.031"
                >
                  <path
                    id="close.svg"
                    fill="#ffffff"
                    d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                    transform="translate(-1412 -516)"
                  />
                </svg>
              </button>
              <div class="modal-body">
                <iframe
                  id="iframeBroadcast"
                  src
                  height="100%"
                  width="100%"
                  allow="camera;microphone"
                ></iframe>
              </div>
            </div>
          </div>

          <!-- <b-modal ref="my-modal" hide-footer title="Using Component Methods">
            <div class="d-block text-center"></div>
            <b-button class="mt-3" variant="outline-danger" block @click="hideModal" data-tag="BroadcastClise">
              {{ $t("expoview.closeme") }}</b-button>
            <b-button class="mt-2" variant="outline-warning" block @click="toggleModal" data-tag="BroadcastToogle">
              {{ $t("expoview.toggleme") }}</b-button>
          </b-modal> -->
        </div>
        <div
          v-if="allRoundTables.length > 0 || (tableTopic && tableTopic.TopicId)"
          style="visiblity: hidden"
          :data-tag="'exhibitorview/' + BoothName + '/joinRoundtablevideo'"
          v-on:click="onClickHandler"
          class="round-table-tooltip"
        >
          <p>{{ $t("expoview.joinroom") }}</p>
        </div>
      </section>
    </div>
    <div
      v-if="
        !mobileView &&
        ScavengerHuntEnabled &&
        ScavengerHuntGameLoaded &&
        scavengerHuntShowMe
      "
      class="scavenger-hunt"
      :class="
        scavengerHuntRight && !turnONOFFContactsEmailChat
          ? 'scavenger-hunt-right'
          : ''
      "
    >
      <h3 v-if="ScavengerHuntGamePlayed">Game<br />Played!</h3>
      <h3 v-else>Play {{ ScavengerHuntName }} Game</h3>

      <v-btn
        v-if="visitor"
        color="transparent"
        class="p-0 mt-3"
        height="48px"
        width="163px"
        @click="registerAttendee"
      >
        <div
          :class="
            ScavengerHuntGamePlayed
              ? 'reveal-code revealed-code'
              : 'reveal-code'
          "
        >
          <p
            class="m-0 d-flex align-items-center justify-space-between"
            style="min-width: 130px"
          >
            {{ ScavengerHuntGamePlayed ? "View Code" : "Reveal Code" }}
            <span class="ml-1">
              <v-icon color="#f62689">mdi-arrow-right</v-icon>
            </span>
          </p>
        </div>
      </v-btn>
      <v-dialog
        v-else
        :key="scavengerHuntDialogKey"
        v-model="scavengerHuntDialog"
        transition="dialog-top-transition"
        max-width="356"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="transparent"
            v-bind="attrs"
            v-on="on"
            class="p-0 mt-3"
            height="48px"
            width="163px"
            @click.prevent="resetScavengerHuntDialog"
          >
            <div
              :class="
                ScavengerHuntGamePlayed
                  ? 'reveal-code revealed-code'
                  : 'reveal-code'
              "
            >
              <p
                class="m-0 d-flex align-items-center justify-space-between"
                style="min-width: 130px"
              >
                {{ ScavengerHuntGamePlayed ? "View Code" : "Reveal Code" }}
                <span class="ml-1">
                  <v-icon color="#f62689">mdi-arrow-right</v-icon>
                </span>
              </p>
            </div>
          </v-btn>
        </template>
        <template>
          <v-card
            class="scavenge-body dialog-box-point"
            style="position: relative"
          >
            <div class="dialog-body">
              <vue-scratchable
                v-show="!ScavengerHuntGamePlayed && percentage < 100"
                id="vueScratchableWrapper"
                :brushOptions="brush"
                :hideOptions="hide"
                getPercentageCleared
                @percentage-update="updatePoints"
              >
                <!--<img
                  src="../assets/Images/natural-paper-texture.jpg"
                />-->
                <!--<h1>{{ percentage }}</h1>
                <h1>{{ subline }}</h1>-->
              </vue-scratchable>
              <div
                v-show="blastConfetti"
                id="blastConfetti"
                class="blast-confetti"
              >
                <img src="../assets/4M57.gif" />
              </div>

              <div class="congo-wrap mb-5">
                <v-img
                  height="50px"
                  src="../assets/Images/leaderboard/congratulations.png"
                ></v-img>
              </div>
              <h3>{{ ScavengerHuntMessage }}</h3>
              <v-chip
                v-if="ScavengerHuntCode"
                class="ma-2"
                x-large
                color="#ffffff"
              >
                <b>{{ ScavengerHuntCode }}</b></v-chip
              >

              <div class="point-msg mt-4">
                <p class="m-0">You have received</p>
                <h2 class="my-2">{{ ScavengerHuntScore }}</h2>
                <h5 class="m-0">Points</h5>
              </div>
              <div style="height: 44px">
                <v-btn
                  v-show="
                    ScavengerHuntGamePlayed ||
                    (percentage == 100 && !blastConfetti)
                  "
                  color="#ffffff"
                  large
                  class="mt-4"
                  @click="scavengerHuntDialog = false"
                  ><b>CLOSE</b></v-btn
                >
              </div>
            </div>
          </v-card>
        </template>
      </v-dialog>
    </div>
    <div v-if="!mobileView" class="single-boothwrapper">
      <div
        class="page-effect"
        v-bind:id="item.id"
        v-bind:key="item.id"
        v-for="item in ExhibitorData"
      >
        <div class="inner-booth">
          <img :src="item.HotspotImageUrL" style="height: 100%; width: 100%" />

          <div
            id="dvTemplate"
            style="
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 100%;
            "
          >
            <span v-html="getHtmlCodeWithImage(item)"></span>

            <div
              id="dvSocial"
              class="custom-tool-tip-social single-tooltip-common"
              style="
                z-index: 99 !important;
                min-width: 190px;
                height: 80px;
                top: 63%;
              "
              :data-tag="item.Name + '  Social Links'"
            >
              <div
                class="new-expo-tooltipinner-wrap"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  overflow: auto;
                "
              >
                <div class="new-tool-tiphead" style="margin-bottom: 0">
                  <div class="tool-tip-social-ico" style="width: 100%">
                    <ul
                      class="d-flex justify-content-end align-items-center"
                      v-if="
                        item.SocialLinks &&
                        item.SocialLinks.some((link) => link.value)
                      "
                    >
                      <li v-for="links in item.SocialLinks" :key="links.key">
                        <a
                          v-if="links.value && links.key == 'Facebook'"
                          target="_blank"
                          :href="links.value"
                          :data-tag="
                            'Facebook -' + item.Name + '-' + links.value
                          "
                          style="
                            height: 30px;
                            width: 30px;
                            background: none !important;
                            display: flex;
                            text-align: center;
                            border-radius: 50%;
                            line-height: 25px;
                            margin: 0px 5px;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <img
                            style="height: 30px; width: 30px"
                            :data-tag="
                              'Facebook -' + item.Name + '-' + links.value
                            "
                            src="../assets/Images/facebook.svg"
                          />
                        </a>

                        <a
                          v-else-if="links.value && links.key == 'Twitter'"
                          target="_blank"
                          :href="links.value"
                          :data-tag="
                            'Twitter -' + item.Name + '-' + links.value
                          "
                          style="
                            height: 30px;
                            width: 30px;
                            background: none !important;
                            display: flex;
                            text-align: center;
                            border-radius: 50%;
                            line-height: 25px;
                            margin: 0px 5px;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <img
                            style="height: 30px; width: 30px"
                            :data-tag="
                              'Twitter -' + item.Name + '-' + links.value
                            "
                            src="../assets/Images/x.svg"
                          />
                        </a>

                        <a
                          v-else-if="links.value && links.key == 'LinkedIn'"
                          target="_blank"
                          :href="links.value"
                          :data-tag="
                            'LinkedIn -' + item.Name + '-' + links.value
                          "
                          style="
                            height: 30px;
                            width: 30px;
                            background: none !important;
                            display: flex;
                            text-align: center;
                            border-radius: 50%;
                            line-height: 25px;
                            margin: 0px 5px;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <img
                            style="height: 30px; width: 30px"
                            :data-tag="
                              'LinkedIn -' + item.Name + '-' + links.value
                            "
                            src="../assets/Images/linkedin.svg"
                          />
                        </a>

                        <a
                          v-else-if="links.value && links.key == 'GooglePlus'"
                          target="_blank"
                          :href="links.value"
                          :data-tag="
                            'Instagram -' + item.Name + '-' + links.value
                          "
                          style="
                            height: 30px;
                            width: 30px;
                            background: none !important;
                            display: flex;
                            text-align: center;
                            border-radius: 50%;
                            line-height: 25px;
                            margin: 0px 5px;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <img
                            style="height: 30px; width: 30px"
                            :data-tag="
                              'Instagram -' + item.Name + '-' + links.value
                            "
                            src="../assets/Images/instagram.svg"
                          />
                        </a>
                      </li>
                    </ul>

                    <div
                      v-else
                      style="
                        width: 100%;
                        text-align: center;
                        color: #888;
                        font-size: 15px;
                        padding: 10px 0;
                      "
                    >
                      No social links are available
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="cross-btn-wrap"
                style="position: absolute; top: -10px; right: -10px"
              >
                <button v-on:click="closeDiv('dvDesc')">X</button>
              </div>
            </div>

            <div
              id="dvDesc"
              class="custom-tool-tip-right single-tooltip-common"
              style="z-index: 99 !important"
              :data-tag="item.Name + '  Profile'"
            >
              <div class="new-expo-tooltipinner-wrap">
                <div class="new-tool-tiphead">
                  <div class="head-left">
                    <div
                      class="at-karney-logo"
                      style="
                        height: 60px;
                        width: 120px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border: 1px solid #e8e8e8;
                        margin-right: 20px;
                        overflow: hidden;
                      "
                    >
                      <img :src="item.Logo" alt="Logo" style="width: 100%" />
                    </div>
                    <h3
                      style="
                        font-size: 18px !important;
                        font-weight: 600;
                        color: #333;
                        margin: 0;
                      "
                    >
                      {{ item.Name }}
                    </h3>
                  </div>
                  <div class="tool-tip-social-ico">
                    <!-- <ul class="d-flex justify-content-end align-items-center d-none">
                      <li v-for="links in item.SocialLinks" :key="links.key">
                        <a v-if="links.value && links.key == 'Facebook'" target="_blank" :href="links.value" :data-tag="'Facebook -' + item.Name + '-' + links.value
                          " style="
                            height: 30px;
                            width: 30px;
                            background: #046ee5;
                            display: inline-block;
                            text-align: center;
                            border-radius: 50%;
                            line-height: 30px;
                            margin: 0 5px;
                          ">
                          <img style="height: 20px; width: 20px" :data-tag="'Facebook -' + item.Name + '-' + links.value
                            " src="../assets/Images/facebook.svg" />
                        </a>
                        <a v-else-if="links.value && links.key == 'Twitter'" target="_blank" :href="links.value"
                          :data-tag="'Twitter -' + item.Name + '-' + links.value
                            " style="
                            height: 30px;
                            width: 30px;
                            background: #046ee5;
                            display: inline-block;
                            text-align: center;
                            border-radius: 50%;
                            line-height: 30px;
                            margin: 0 5px;
                          ">
                          <img style="height: 20px; width: 20px" :data-tag="'Twitter -' + item.Name + '-' + links.value
                            " src="../assets/Images/x.svg" />
                        </a>
                        <a v-else-if="links.value && links.key == 'LinkedIn'" target="_blank" :href="links.value"
                          :data-tag="'LinkenIn -' + item.Name + '-' + links.value
                            " style="
                            height: 30px;
                            width: 30px;
                            background: #046ee5;
                            display: inline-block;
                            text-align: center;
                            border-radius: 50%;
                            line-height: 25px;
                            margin: 0 5px;
                          ">
                          <img style="height: 20px; width: 20px" :data-tag="'LinkenIn -' + item.Name + '-' + links.value
                            " src="../assets/Images/linkedin_new.svg" />
                        </a>
                        <a v-else-if="links.value && links.key == 'GooglePlus'" target="_blank" :href="links.value"
                          :data-tag="'Instagram -' + item.Name + '-' + links.value
                            " style="
                            height: 30px;
                            width: 30px;
                            background: #046ee5;
                            display: inline-block;
                            text-align: center;
                            border-radius: 50%;
                            line-height: 25px;
                            margin: 0 5px;
                          ">
                          <img style="height: 20px; width: 20px" :data-tag="'Instagram -' + item.Name + '-' + links.value
                            " src="../assets/Images/instagram.svg" />
                        </a>
                      </li>
                    </ul> -->
                  </div>
                </div>
                <div class="tool-tip-desc-info-box">
                  <p
                    style="
                      font-size: 14px !important;
                      font-weight: 400;
                      color: #333;
                      line-height: 18px;
                      margin: 0 0 20px;
                    "
                  >
                    <span v-html="item.Profile"></span>
                    <!-- <a
                      @click.prevent="loadView(item.id)"
                      style="font-weight:bold;color:#0c1de7!important;text-decoration: none;"
                    >Explore more >></a>-->
                  </p>
                  <ul>
                    <li>
                      <a
                        :href="'mailto:' + item.Email"
                        target="_blank"
                        v-if="item.Email"
                        :data-tag="'Email -' + item.Name + '-' + item.Email"
                        style="
                          display: inline-block;
                          font-size: 16px;
                          font-weight: 400;
                          color: #333;
                          margin-right: 20px;
                        "
                      >
                        <img
                          style="height: 20px; width: 20px"
                          src="../assets/Images/envelope.svg"
                          :data-tag="'Email -' + item.Name + '-' + item.Email"
                        />
                        {{ item.Email }}
                      </a>
                    </li>
                    <li>
                      <a
                        :href="'tel:' + item.Phone"
                        :data-tag="'Phone -' + item.Name + '-' + item.Phone"
                        v-if="item.Phone"
                        style="
                          display: inline-block;
                          font-size: 16px;
                          font-weight: 400;
                          color: #333;
                          margin-right: 20px;
                        "
                      >
                        <img
                          style="height: 20px; width: 20px"
                          src="../assets/Images/contact.svg"
                          :data-tag="'Phone -' + item.Name + '-' + item.Phone"
                        />
                        {{ item.Phone }}
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        :href="item.Website"
                        :data-tag="'Website -' + item.Name + '-' + item.Website"
                        v-if="item.Website !== ''"
                        style="
                          display: inline-block;
                          font-size: 16px;
                          font-weight: 400;
                          color: #333;
                          margin-right: 20px;
                        "
                      >
                        <img
                          style="height: 20px; width: 20px"
                          src="../assets/Images/web.svg"
                          :data-tag="
                            'Website -' + item.Name + '-' + item.Website
                          "
                        />
                        {{ item.Website }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="cross-btn-wrap">
                <button v-on:click="closeDiv('dvDesc')">X</button>
              </div>
            </div>

            <div
              v-show="showcaseVideoUrl"
              id="dvVideo"
              autoplay="autoplay"
              class="custom-tool-tip-left"
              style="z-index: 99 !important"
              :data-tag="item.id + '/' + item.Name + ' -Video'"
              @click="showcaseVideoUrl ? onClickHandler : ''"
            >
              <div class="video-wrapper">
                <iframe
                  v-if="showcaseVideoUrl"
                  id="frmVideo"
                  width="560"
                  height="315"
                  :src="showcaseVideoUrl"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  :data-tag="item.id + '/' + item.Name + ' -Video'"
                ></iframe>
                <div
                  v-else
                  class="position-relative d-flex justify-content-center align-items-center"
                  style="height: 100%; width: 100%"
                >
                  <p
                    v-if="item.Website"
                    class="m-0"
                    style="
                      font-family: 'poppins', sans-serif;
                      font-size: 18px;
                      color: #333;
                      font-weight: 500;
                      text-align: center;
                    "
                  >
                    No Video to Play here! <br />
                    Visit
                    <a
                      target="_blank"
                      :href="item.Website"
                      :data-tag="'Website -' + item.Name + '-' + item.Website"
                    >
                      {{ item.Website }}
                    </a>
                    for more info
                  </p>
                  <p
                    v-else
                    class="m-0"
                    style="
                      font-family: 'poppins', sans-serif;
                      font-size: 18px;
                      color: #333;
                      font-weight: 500;
                    "
                  >
                    No Video to Play here!
                  </p>
                </div>
              </div>
              <div class="cross-btn-wrap">
                <button v-on:click="closeDiv('dvVideo')">X</button>
              </div>
            </div>
            <div
              id="dvContacts"
              class="custom-tool-tip-left contact-tooltip"
              style="z-index: 99 !important"
              :data-tag="item.id + '/' + item.Name + '  Contact'"
            >
              <div class="at-karney-wrap">
                <div class="contect-person-inner" style="padding: 25px">
                  <div class="company-reps-intro-desc">
                    <div class="resps-head">
                      <h4>
                        {{ item.Name }}
                        <span
                          >- {{ $t("expoview.reps") }} ({{
                            item.MappedContacts.length
                          }})</span
                        >
                      </h4>
                    </div>
                    <div class="company-greetings">
                      <p
                        style="margin-bottom: 10px"
                        v-html="JoinTheConversationText"
                      >
                        <!-- Welcome to {{ item.Name }}! Our Reps are here to assist
                        you. You can also contact us on
                        <a :href="'tel:' + item.Phone">{{ item.Phone }}</a> or
                        visit
                        <a :href="item.Website">{{ item.Website }}</a> -->
                        <!-- <p>Welcome to {BoothName} Our Reps are here to assist you. You can also contact us on {phone} or visit {BoothWebsite}</p> -->
                      </p>
                    </div>
                  </div>
                  <div class="contact-wrapper">
                    <div
                      class="page-effect"
                      v-bind:id="item1.id"
                      v-bind:key="item1.id"
                      v-for="(item1, index) in item.MappedContacts"
                    >
                      <div
                        class="single-contact"
                        style="
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                          padding: 8px 15px;
                          border-radius: 6px;
                          box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);
                          margin-bottom: 10px;
                        "
                      >
                        <div
                          class="contact-left"
                          style="
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                          "
                        >
                          <div
                            class="contact-img-wrap"
                            style="
                              height: 60px;
                              width: 60px;
                              position: relative;
                              margin-right: 15px;
                            "
                          >
                            <div
                              class="contact-img"
                              style="
                                height: 60px;
                                width: 60px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                overflow: hidden;
                                border-radius: 50%;
                              "
                            >
                              <img
                                v-if="item1.ProfilePictureURL"
                                :src="getCDNUrl(item1.ProfilePictureURL)"
                                style="width: 100%"
                                @error="item1.ProfilePictureURL = ''"
                              />
                              <span
                                v-else-if="item1.NameInitial"
                                class="contact-initial"
                                >{{ item1.NameInitial }}</span
                              >
                              <img
                                v-else
                                src="../assets/Images/common-avatar.svg"
                                style="width: 100%"
                              />
                            </div>

                            <span
                              v-if="ShowRepActiveStatus"
                              :id="'spnStatus' + item1.AttendeeId"
                              :class="item1.statusClass"
                              style="
                                height: 14px;
                                width: 14px;
                                display: inline-block;
                                background: #29c303;
                                position: absolute;
                                border-radius: 50%;
                                bottom: 0px;
                                right: 9px;
                                z-index: 99;
                                border: 2px solid #fff;
                              "
                            ></span>
                            <!--:class="item1.statusClass" -->
                            <!-- <span
                            v-else
                            :id="'spnStatus'+item1.AttendeeId"
                            :class="item1.statusClass"
                            style="height: 14px; width: 14px; display: inline-block; background: #29c303;   
              position: absolute; border-radius: 50%; bottom: 0px; right: 9px; z-index: 99999;border: 2px solid #fff;"
                          ></span>-->
                          </div>
                          <div class="contact-details">
                            <h3
                              style="
                                color: #333;
                                font-size: 24px;
                                font-weight: 600;
                                margin: 0;
                              "
                            >
                              {{ item1.FirstName }} {{ item1.LastName }}
                            </h3>
                            <h4
                              style="
                                color: #333;
                                font-size: 18px;
                                font-weight: 300;
                                margin: 0;
                              "
                            >
                              {{ item1.Designation }}
                            </h4>
                          </div>
                        </div>
                        <div class="contact-right">
                          <ul style="margin: 0; padding: 0">
                            <li
                              v-if="
                                EnableExhibitorRepVideoCall &&
                                (item1.VideoCallEnable ||
                                  item1.AttendeeId == uid)
                              "
                              :data-tag="
                                'VideoCall-' + item1.Name + '-' + item.Name
                              "
                              style="
                                display: inline-block;
                                list-style: none;
                                margin-right: 15px;
                              "
                            >
                              <a
                                :id="'lnkVideoCall' + item1.AttendeeId"
                                href="#"
                                :data-tag="
                                  'VideoCall-' + item1.Name + '-' + item.Name
                                "
                                @click="onClickHandler"
                                v-on:click.prevent="
                                  JoinRepVideoCall(
                                    item.id,
                                    item1.AttendeeId,
                                    item1.StreamingClient,
                                    item1.Zoom_Detail
                                  );
                                  return false;
                                "
                                class="openBroadcast"
                                title="Video call"
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <img
                                      v-bind="attrs"
                                      v-on="on"
                                      src="../assets/Images/video-call.svg"
                                      data-html="true"
                                      :data-tag="
                                        'VideoCall-' +
                                        item1.Name +
                                        '-' +
                                        item.Name
                                      "
                                    />
                                  </template>
                                  <span>Video Chat</span>
                                </v-tooltip>
                              </a>
                            </li>
                            <li
                              v-else
                              style="
                                display: inline-block;
                                list-style: none;
                                margin-right: 15px;
                              "
                              :data-tag="
                                'VideoCall-' + item1.Name + '-' + item.Name
                              "
                            >
                              <img
                                src="../assets/Images/video-call-grey.svg"
                                style="width: 20px"
                                data-toggle="tooltip"
                                data-html="true"
                                :data-tag="
                                  'VideoCall-' + item1.Name + '-' + item.Name
                                "
                                title
                                data-original-title="Video Chat"
                              />
                            </li>
                            <li
                              style="
                                display: inline-block;
                                list-style: none;
                                margin-right: 15px;
                              "
                              :data-tag="
                                'Email-' + item1.Name + '-' + item.Name
                              "
                              v-if="turnONOFFContactsEmailChat"
                            >
                              <a
                                v-if="item1.AttendeeId != uid"
                                v-on:click="onClickHandler"
                                :href="
                                  hasValidAuth({
                                    auth_type: 1,
                                    no_need_reg_login: true,
                                  })
                                    ? 'mailto:' + item1.Email
                                    : 'javascript:void(0);'
                                "
                                :target="
                                  hasValidAuth({
                                    auth_type: 1,
                                    no_need_reg_login: true,
                                  })
                                    ? '_blank'
                                    : ''
                                "
                                title="Email"
                                :data-tag="
                                  'Email-' + item1.Name + '-' + item.Name
                                "
                                @click="hasValidAuth({ auth_type: 1 })"
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <img
                                      v-bind="attrs"
                                      v-on="on"
                                      src="../assets/Images/envelope2.svg"
                                      data-html="true"
                                      :data-tag="
                                        'Email-' + item1.Name + '-' + item.Name
                                      "
                                    />
                                  </template>
                                  <span>Email</span>
                                </v-tooltip>
                              </a>
                              <a
                                v-else
                                title="Email"
                                style="opacity: 0.4; cursor: default"
                              >
                                <img src="../assets/Images/envelope2.svg" />
                              </a>
                            </li>
                            <li
                              style="
                                display: inline-block;
                                list-style: none;
                                margin-right: 15px;
                              "
                              :data-tag="
                                'Meeting-' + item1.Name + '-' + item.Name
                              "
                              v-if="AllowRequestMeetingInExpoHall"
                            >
                              <input type="hidden" id="hdnAttendeeId" />

                              <span
                                v-if="
                                  item1.AttendeeId != uid &&
                                  AllowRequestMeetingInExpoHall
                                "
                                data-toggle="modal"
                                v-bind:data-target="'#calendarModal' + index"
                                v-on:click="OpenRequestMeeting(item1)"
                                :data-tag="
                                  'Meeting-' + item1.Name + '-' + item.Name
                                "
                                class="reqMeeting"
                              >
                                <a
                                  @click="onClickHandler"
                                  :data-tag="
                                    'Meeting-' + item1.Name + '-' + item.Name
                                  "
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <img
                                        v-bind="attrs"
                                        v-on="on"
                                        src="../assets/Images/Meeting.svg"
                                        :data-tag="
                                          'Meeting-' +
                                          item1.Name +
                                          '-' +
                                          item.Name
                                        "
                                      />
                                    </template>
                                    <span>1:1 Meeting</span>
                                  </v-tooltip>
                                </a>
                              </span>
                              <span v-else class="reqMeeting">
                                <a
                                  title="1:1 Meeting"
                                  style="opacity: 0.4; cursor: default"
                                >
                                  <img src="../assets/Images/Meeting.svg" />
                                </a>
                              </span>
                            </li>
                            <li
                              style="
                                display: inline-block;
                                list-style: none;
                                margin-right: 15px;
                              "
                              v-if="turnONOFFContactsEmailChat"
                            >
                              <span
                                v-if="item1.AttendeeId != uid"
                                v-on:click="OpenOneToOneChat(item1)"
                                :data-tag="
                                  'One To One Chat-' +
                                  item1.Name +
                                  '-' +
                                  item.Name
                                "
                                class="reqChat"
                              >
                                <a
                                  :data-tag="
                                    'One To One Chat-' +
                                    item1.Name +
                                    '-' +
                                    item.Name
                                  "
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <img
                                        v-bind="attrs"
                                        v-on="on"
                                        src="../assets/Images/chat.svg"
                                        :data-tag="
                                          'One To One Chat-' +
                                          item1.Name +
                                          '-' +
                                          item.Name
                                        "
                                      />
                                    </template>
                                    <span>1:1 Chat</span>
                                  </v-tooltip>
                                </a>
                              </span>
                              <span v-else class="reqChat">
                                <a
                                  title="1:1 Chat"
                                  style="opacity: 0.4; cursor: default"
                                >
                                  <img src="../assets/Images/chat.svg" />
                                </a>
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cross-btn-wrap">
                <button v-on:click="closeDiv('dvContacts')">X</button>
              </div>
            </div>

            <div
              id="dvColletrals"
              class="custom-tool-tip-left single-tooltip-common"
              style="z-index: 99 !important"
              :data-tag="item.id + '/' + item.Name + '  Colletrals'"
            >
              <div class="at-karney-wrap collateral-wrap">
                <div class="colletral-head-top">
                  <h4>
                    {{ $t("expoview.downloadbrochures") }} &amp;
                    {{ $t("expoview.collaterals") }}
                  </h4>
                </div>
                <div class="pdf-wrap" style="padding: 25px">
                  <div
                    class="page-effect"
                    v-bind:id="item2.id"
                    v-bind:key="item2.id"
                    v-for="item2 in ExhibitorFiles"
                  >
                    <div
                      class="single-pdf"
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 15px;
                        cursor: pointer;
                      "
                    >
                      <div
                        class="pdf-ico"
                        style="
                          display: flex;
                          justify-content: flex-start;
                          align-items: center;
                        "
                        :data-tag="
                          'Download - ' + item.Name + ' - ' + item2.Filename
                        "
                        @click="downloadBrocheures"
                      >
                        <img
                          v-if="item2.Url.includes('.mp4')"
                          :data-tag="
                            'Download - ' + item.Name + ' - ' + item2.Filename
                          "
                          src="../assets/Images/icons/video-icon.svg"
                          style="height: 35px; width: 35px"
                        />
                        <img
                          v-else
                          :data-tag="
                            'Download - ' + item.Name + ' - ' + item2.Filename
                          "
                          src="../assets/Images/icons/pdf.svg"
                        />

                        <a
                          :href="item2.Url"
                          target="_blank"
                          :data-tag="
                            'Download - ' + item.Name + ' - ' + item2.Filename
                          "
                          style="
                            color: #333;
                            font-size: 18px;
                            font-weight: 600;
                            display: inline-block;
                            margin-left: 15px;
                            text-decoration: none;
                          "
                          >{{ item2.Filename }}</a
                        >
                      </div>
                      <div class="pdf-button" @click="downloadBrocheures">
                        <a
                          :href="item2.Url"
                          target="_blank"
                          :data-tag="
                            'Download - ' + item.Name + ' - ' + item2.Filename
                          "
                        >
                          <i
                            class="fa fa-external-link"
                            aria-hidden="true"
                            style="color: black"
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pdf-wrap" style="padding: 25px">
                  <div
                    class="page-effect"
                    v-bind:id="links.id"
                    v-bind:key="links.id"
                    v-for="links in ExhibitorLinks"
                  >
                    <div
                      class="single-pdf"
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 15px;
                        cursor: pointer;
                      "
                    >
                      <div
                        class="pdf-ico"
                        style="
                          display: flex;
                          justify-content: flex-start;
                          align-items: center;
                        "
                        :data-tag="'Link - ' + links.Title + ' - ' + links.Link"
                      >
                        <img
                          :data-tag="
                            'Link - ' + links.Title + ' - ' + links.Link
                          "
                          src="../assets/Images/icons/link.svg"
                        />
                        <a
                          :href="links.Link"
                          target="_blank"
                          :data-tag="
                            'Link - ' + links.Title + ' - ' + links.Link
                          "
                          style="
                            color: #333;
                            font-size: 18px;
                            font-weight: 600;
                            display: inline-block;
                            margin-left: 15px;
                            text-decoration: none;
                          "
                          >{{ links.Title }}</a
                        >
                      </div>
                      <div class="pdf-button">
                        <a
                          :href="links.Link"
                          target="_blank"
                          :data-tag="
                            'Link - ' + links.Title + ' - ' + links.Link
                          "
                        >
                          <i
                            class="fa fa-external-link"
                            aria-hidden="true"
                            style="color: black"
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cross-btn-wrap">
                <button v-on:click="closeDiv('dvColletrals')">X</button>
              </div>
            </div>
            <div
              id="dvHumanrights"
              class="custom-tool-tip-left single-tooltip-common"
              style="z-index: 99 !important"
              :data-tag="item.id + '/' + item.Name + '  humanrights'"
            >
              <div class="at-karney-wrap collateral-wrap">
                <div class="colletral-head-top">
                  <h4>Human Rights Training</h4>
                </div>
                <div class="pdf-wrap" style="padding: 25px">
                  <div class="tool-tip-desc-info-box">
                    <p
                      style="
                        font-size: 14px !important;
                        font-weight: 400;
                        color: #333;
                        line-height: 18px;
                        margin: 0 0 20px;
                      "
                    >
                      <!-- <span v-html="item.Profile"></span> -->
                      <span
                        >Since 2017, every Informal ASEM Seminar on Human Rights
                        is followed by a training component. ASEF invites open
                        calls for proposals and develops the training programme
                        in coordination with the selected organisation.</span
                      >
                    </p>
                    <div
                      class="single-pdf"
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 15px;
                      "
                    >
                      <div
                        class="pdf-ico"
                        style="
                          display: flex;
                          justify-content: flex-start;
                          align-items: center;
                        "
                        :data-tag="'link - https://asef.org/news/investigative-interviewing-a-human-rights-compliant-alternative-to-police-interrogation/'"
                      >
                        <a
                          href="https://asef.org/news/investigative-interviewing-a-human-rights-compliant-alternative-to-police-interrogation/"
                          target="_blank"
                          :data-tag="'link - https://asef.org/news/investigative-interviewing-a-human-rights-compliant-alternative-to-police-interrogation/'"
                          style="
                            color: #333;
                            font-size: 18px;
                            font-weight: 600;
                            display: inline-block;
                            margin-left: 15px;
                            text-decoration: none;
                          "
                          >Training on Human Rights-Compliant Policing and
                          Investigative Interviewing (2020)</a
                        >
                      </div>
                    </div>
                    <div
                      class="single-pdf"
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 15px;
                      "
                    >
                      <div
                        class="pdf-ico"
                        style="
                          display: flex;
                          justify-content: flex-start;
                          align-items: center;
                        "
                        :data-tag="'link - https://asef.org/projects/18th-informal-asem-seminar-on-human-rights-training/'"
                      >
                        <a
                          href="https://asef.org/projects/18th-informal-asem-seminar-on-human-rights-training/"
                          target="_blank"
                          :data-tag="'link - https://asef.org/projects/18th-informal-asem-seminar-on-human-rights-training/'"
                          style="
                            color: #333;
                            font-size: 18px;
                            font-weight: 600;
                            display: inline-block;
                            margin-left: 15px;
                            text-decoration: none;
                          "
                          >Training on Human Rights & Prevention of Violent
                          Extremism (2019)</a
                        >
                      </div>
                    </div>
                    <div
                      class="single-pdf"
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 15px;
                      "
                    >
                      <div
                        class="pdf-ico"
                        style="
                          display: flex;
                          justify-content: flex-start;
                          align-items: center;
                        "
                        :data-tag="'link - https://asef.org/news/human-rights-and-children-training-held-in-leiden/'"
                      >
                        <a
                          href="https://asef.org/news/human-rights-and-children-training-held-in-leiden/"
                          target="_blank"
                          :data-tag="'link - https://asef.org/news/human-rights-and-children-training-held-in-leiden/'"
                          style="
                            color: #333;
                            font-size: 18px;
                            font-weight: 600;
                            display: inline-block;
                            margin-left: 15px;
                            text-decoration: none;
                          "
                          >Training on Human Rights & Children (2018)</a
                        >
                      </div>
                    </div>
                    <div
                      class="single-pdf"
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 15px;
                      "
                    >
                      <div
                        class="pdf-ico"
                        style="
                          display: flex;
                          justify-content: flex-start;
                          align-items: center;
                        "
                        :data-tag="'link - https://asef.org/news/1st-annual-human-rights-training-on-human-rights-persons-with-disabilities/'"
                      >
                        <a
                          href="https://asef.org/news/1st-annual-human-rights-training-on-human-rights-persons-with-disabilities/"
                          target="_blank"
                          :data-tag="'link - https://asef.org/news/1st-annual-human-rights-training-on-human-rights-persons-with-disabilities/'"
                          style="
                            color: #333;
                            font-size: 18px;
                            font-weight: 600;
                            display: inline-block;
                            margin-left: 15px;
                            text-decoration: none;
                          "
                          >Training on Human Rights & Persons with Disabilities
                          (2017)</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cross-btn-wrap">
                  <button v-on:click="closeDiv('dvHumanrights')">X</button>
                </div>
              </div>
            </div>
            <div
              id="dvPodcasts"
              class="custom-tool-tip-left single-tooltip-common"
              style="z-index: 99 !important"
              :data-tag="item.id + '/' + item.Name + '  poadcast'"
            >
              <div class="at-karney-wrap collateral-wrap">
                <div class="colletral-head-top">
                  <h4>Conversations on Human Rights Education</h4>
                </div>
                <div class="pdf-wrap" style="padding: 25px">
                  <div class="tool-tip-desc-info-box">
                    <p
                      style="
                        font-size: 14px !important;
                        font-weight: 400;
                        color: #333;
                        line-height: 18px;
                        margin: 0 0 20px;
                      "
                    >
                      <!-- <span v-html="item.Profile"></span> -->
                      <span
                        >Why do we need human rights education? What are the key
                        challenges facing human rights education in a world that
                        is becoming more integrated and digital? How are
                        governments fairing in terms of their commitments to
                        upholding human rights? How do we make educational
                        systems inclusive and respectful of minority
                        rights?.</span
                      >
                    </p>
                    <div
                      class="single-pdf"
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 15px;
                      "
                    >
                      <div
                        class="pdf-ico"
                        style="
                          display: flex;
                          justify-content: flex-start;
                          align-items: center;
                        "
                        :data-tag="'link - https://asef.org/news/asemhrs19-podcast-launch-conversations-on-human-rights-education/'"
                      >
                        <a
                          href="https://asef.org/news/asemhrs19-podcast-launch-conversations-on-human-rights-education/"
                          target="_blank"
                          :data-tag="'link - https://asef.org/news/asemhrs19-podcast-launch-conversations-on-human-rights-education/'"
                          style="
                            color: #333;
                            font-size: 18px;
                            font-weight: 600;
                            display: inline-block;
                            margin-left: 15px;
                            text-decoration: none;
                          "
                          >Listen to the podcasts here</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cross-btn-wrap">
                  <button v-on:click="closeDiv('dvPodcasts')">X</button>
                </div>
              </div>
            </div>
            <div
              id="dvWebinar"
              class="custom-tool-tip-left single-tooltip-common"
              style="z-index: 99 !important"
              :data-tag="item.id + '/' + item.Name + '  webinar'"
            >
              <div class="at-karney-wrap collateral-wrap">
                <div class="colletral-head-top">
                  <h4>
                    Access to Education and Human Rights Education in Times of
                    COVID-19
                  </h4>
                </div>
                <div class="pdf-wrap" style="padding: 25px">
                  <div class="tool-tip-desc-info-box">
                    <p
                      style="
                        font-size: 14px !important;
                        font-weight: 400;
                        color: #333;
                        line-height: 18px;
                        margin: 0 0 20px;
                      "
                    >
                      <!-- <span v-html="item.Profile"></span> -->
                      <span>
                        Access to education is a precondition to realise the
                        human right to human rights education. Yet the
                        coronavirus pandemic has majorly impacted access to
                        education: 1.53 billion learners are out of school,
                        including 184 country-wide school closures during the
                        first wave of the pandemic — affecting 87.6% of the
                        world’s total enrolled learners, according to UNESCO. To
                        explore how to support educators, the Asia-Europe
                        Foundation (ASEF) organised the webinar “Access to
                        Education and Human Rights Education in Times of
                        COVID-19” on 23 September. More than one hundred
                        teachers, policy makers and non-formal educators in Asia
                        and Europe participated in the virtual panel
                        debate.</span
                      >
                    </p>
                    <div
                      class="single-pdf"
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 15px;
                      "
                    >
                      <div
                        class="pdf-ico"
                        style="
                          display: flex;
                          justify-content: flex-start;
                          align-items: center;
                        "
                        :data-tag="'link - https://asef.org/news/ensuring-access-to-education-and-human-rights-education-during-the-pandemic/'"
                      >
                        <a
                          href="https://asef.org/news/ensuring-access-to-education-and-human-rights-education-during-the-pandemic/"
                          target="_blank"
                          :data-tag="'link - https://asef.org/news/ensuring-access-to-education-and-human-rights-education-during-the-pandemic/'"
                          style="
                            color: #333;
                            font-size: 18px;
                            font-weight: 600;
                            display: inline-block;
                            margin-left: 15px;
                            text-decoration: none;
                          "
                          >Read more on the ASEF website</a
                        >
                      </div>
                    </div>
                    <div
                      class="single-pdf"
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 15px;
                      "
                    >
                      <div
                        class="pdf-ico"
                        style="
                          display: flex;
                          justify-content: flex-start;
                          align-items: center;
                        "
                        :data-tag="'link - https://www.youtube.com/watch?v=D5bP-2dUGns'"
                      >
                        <a
                          href="https://www.youtube.com/watch?v=D5bP-2dUGns"
                          target="_blank"
                          :data-tag="'link - https://www.youtube.com/watch?v=D5bP-2dUGns'"
                          style="
                            color: #333;
                            font-size: 18px;
                            font-weight: 600;
                            display: inline-block;
                            margin-left: 15px;
                            text-decoration: none;
                          "
                          >Watch the webinar recording here</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cross-btn-wrap">
                  <button v-on:click="closeDiv('dvWebinar')">X</button>
                </div>
              </div>
            </div>
            <RequestMeeting
              v-if="requestMeetingFlag"
              :key="requestMeetingKey"
              :attendee="currentAttendee"
            >
            </RequestMeeting>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!mobileView"
      id="divLoading"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 30001;
        opacity: 1;
        transform: scale(2);
        display: none;
      "
    >
      <!-- <p style="position: fixed; top: 45%; left: 45%;"> -->
      <div class="loader">
        <!-- <div class="item-c item-1"></div>
        <div class="item-c item-2"></div>
        <div class="item-c item-3"></div>
        <div class="item-c item-4"></div>-->
        <svg
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 33 33;270 33 33"
              begin="0s"
              dur="1.4s"
              fill="freeze"
              repeatCount="indefinite"
            />
            <circle
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
              stroke-dasharray="187"
              stroke-dashoffset="610"
            >
              <animate
                attributeName="stroke"
                values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                begin="0s"
                dur="5.6s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 33 33;135 33 33;450 33 33"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-dashoffset"
                values="187;46.75;187"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>
      </div>
      <!-- </p> -->
    </div>
    <!-- Othe msg  Modal -->
    <div v-if="!mobileView" class="modal fade all-modal" id="Othermsg-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div id="dvOtherMsg" class="classOtheMsg"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- Othe msg  Modal Ends-->

    <v-dialog
      ref="exMeeting"
      v-model="dialog"
      content-class="client-dialog-exhibitors rounded-lg"
      transition="scroll-x-reverse-transition"
      width="auto"
    >
      <v-card class="rounded-lg" style="overflow: hidden">
        <!-- <v-toolbar
          class="pl-8"
          color="primary"
          style="box-shadow: none; background-color: #fff !important"
        >
          <v-toolbar-title
            class="text-h5 ml-2 mt-6"
            style="color: #000; font-weight: 500"
          >
            Appointment
          </v-toolbar-title>
          <v-spacer></v-spacer>
          
        </v-toolbar> -->
        <!--<v-card-title>
          <div style="position: absolute; right: 10px; top: 10px">
            Book Appointment
          </div>
        </v-card-title>-->
        <v-card-text
          id="ClientLobbyCard"
          class="ex-dialog-body px-0 mt-0 position-relative rounded-lg"
          style="p-0;font-size:1rem"
        >
          <div style="position: absolute; right: 0px; top: 0px">
            <v-icon style="z-index: 2" size="32" @click="closeHandler()"
              >close</v-icon
            >
          </div>
          <div class="apointment-pop-hld" style="width: 100%">
            <v-tabs v-model="tab" align-with-title>
              <v-tabs-slider color="black"></v-tabs-slider>
              <v-tab
                v-if="allowRequestMeeting"
                id="tabExhibitorsSchedule"
                href="#schedule"
                style="margin-left: 0"
                class="tab-top first-tab"
                >Book Appointment
              </v-tab>
              <v-tab href="#meeting" style="margin-left: 0" class="tab-top"
                >Confirmed Meetings
              </v-tab>
              <v-tab-item
                v-if="allowRequestMeeting"
                value="schedule"
                class="tab-content"
              >
                <Exhibitors
                  :Exhibitorlist="Exhibitorlist"
                  @OpenRequestMeeting="OpenRequestMeeting($event)"
                >
                </Exhibitors>
              </v-tab-item>
              <v-tab-item value="meeting" class="tab-content">
                <ExhibitorsMeeting
                  :uid="uid"
                  :allowRequestMeeting="allowRequestMeeting"
                  @goToBookAppointment="goToBookAppointment"
                ></ExhibitorsMeeting>
                <!--<router-view></router-view>-->
                <!--<v-card flat>
									<v-card-text v-text="text"></v-card-text>
								</v-card>-->
              </v-tab-item>
            </v-tabs>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div
      id="RetryJoinInZoom"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 400px">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>

            <div class="retry-modal p-4">
              <p style="font-size: 20px; font-weight: 600; color: #1e1f26">
                Please try again.
              </p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-no"
                  @click="cancelRetryJoinInZoom"
                  >Cancel</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="retryJoinInZoom"
                  >Retry</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--mobileView-->
    <div v-if="mobileView" class="container">
      <div class="mobile-booth-head-top">
        <div v-show="!protectNav" class="booth-head-left">
          <div class="back-to-hall">
            <!--v-bind:to="{ name: 'Exhibitorshalllite' }"-->
            <router-link
              v-if="showAerialView == false && showBirdView == false"
              class="tab-link d-flex"
              v-on:click.prevent="clearRefresh"
              v-bind:to="{ name: 'ExhibitorsHall' }"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 434 434"
                  style="enable-background: new 0 0 434 434"
                  xml:space="preserve"
                  width="25px"
                  height="25px"
                  class
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M219.239,55.804c-18.137,0-32.84,14.703-32.84,32.84s14.703,32.84,32.84,32.84s32.84-14.703,32.84-32.84    C252.059,70.516,237.368,55.825,219.239,55.804z M219.239,101.484c-7.091,0-12.84-5.749-12.84-12.84    c0-7.091,5.749-12.84,12.84-12.84c7.091,0,12.84,5.749,12.84,12.84C232.071,95.732,226.327,101.476,219.239,101.484z"
                          data-original="#000000"
                          class="active-path"
                          fill="#000000"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M423.919,358.219c-0.006,0-0.013,0-0.019,0H398v-200h17.842c5.522,0,10.158-4.042,10.158-9.564v-45.68    c-0.033-4.015-2.446-7.627-6.143-9.193L223.215,9.588c-2.52-1.077-5.372-1.077-7.892,0L18.892,93.782    c-3.639,1.595-5.963,5.221-5.892,9.193v45.68c-0.131,5.152,3.94,9.435,9.092,9.566c0.182,0.005,0.363,0.004,0.545-0.002H41v200    H10.1c-5.511-0.067-10.033,4.347-10.1,9.859c0,0.006,0,0.013,0,0.019v47.56c0,5.523,4.574,9.562,10.1,9.562h413.8    c5.523,0,10.1-4.039,10.1-9.562v-47.56C433.944,362.586,429.431,358.163,423.919,358.219z M33,138.219v-28.648l186.5-79.912    L406,109.571v28.648H33z M378,158.219v200h-49v-200H378z M309,158.219v200h-48v-200H309z M241,158.219v200h-48v-200H241z     M173,158.219v200h-48v-200H173z M105,158.219v200H61v-200H105z M414,405.219H20v-27h394V405.219z"
                          data-original="#000000"
                          class="active-path"
                          fill="#000000"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              <h3 class="mb-0 ml-2" id="boothHeaderTxt"></h3>
            </router-link>
            <router-link
              v-else-if="showBirdView == true && showAerialView == false"
              class="tab-link d-flex"
              v-on:click.prevent="clearRefresh"
              v-bind:to="{ name: 'ExhibitorsHall' }"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 434 434"
                  style="enable-background: new 0 0 434 434"
                  xml:space="preserve"
                  width="25px"
                  height="25px"
                  class
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M219.239,55.804c-18.137,0-32.84,14.703-32.84,32.84s14.703,32.84,32.84,32.84s32.84-14.703,32.84-32.84    C252.059,70.516,237.368,55.825,219.239,55.804z M219.239,101.484c-7.091,0-12.84-5.749-12.84-12.84    c0-7.091,5.749-12.84,12.84-12.84c7.091,0,12.84,5.749,12.84,12.84C232.071,95.732,226.327,101.476,219.239,101.484z"
                          data-original="#000000"
                          class="active-path"
                          fill="#000000"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M423.919,358.219c-0.006,0-0.013,0-0.019,0H398v-200h17.842c5.522,0,10.158-4.042,10.158-9.564v-45.68    c-0.033-4.015-2.446-7.627-6.143-9.193L223.215,9.588c-2.52-1.077-5.372-1.077-7.892,0L18.892,93.782    c-3.639,1.595-5.963,5.221-5.892,9.193v45.68c-0.131,5.152,3.94,9.435,9.092,9.566c0.182,0.005,0.363,0.004,0.545-0.002H41v200    H10.1c-5.511-0.067-10.033,4.347-10.1,9.859c0,0.006,0,0.013,0,0.019v47.56c0,5.523,4.574,9.562,10.1,9.562h413.8    c5.523,0,10.1-4.039,10.1-9.562v-47.56C433.944,362.586,429.431,358.163,423.919,358.219z M33,138.219v-28.648l186.5-79.912    L406,109.571v28.648H33z M378,158.219v200h-49v-200H378z M309,158.219v200h-48v-200H309z M241,158.219v200h-48v-200H241z     M173,158.219v200h-48v-200H173z M105,158.219v200H61v-200H105z M414,405.219H20v-27h394V405.219z"
                          data-original="#000000"
                          class="active-path"
                          fill="#000000"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              <h3 class="mb-0 ml-2" id="boothHeaderTxt"></h3>
            </router-link>
            <router-link
              v-else
              class="tab-link d-flex"
              v-on:click.prevent="clearRefresh"
              v-bind:to="{ name: 'ExhibitorsHall' }"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 434 434"
                  style="enable-background: new 0 0 434 434"
                  xml:space="preserve"
                  width="25px"
                  height="25px"
                  class
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M219.239,55.804c-18.137,0-32.84,14.703-32.84,32.84s14.703,32.84,32.84,32.84s32.84-14.703,32.84-32.84    C252.059,70.516,237.368,55.825,219.239,55.804z M219.239,101.484c-7.091,0-12.84-5.749-12.84-12.84    c0-7.091,5.749-12.84,12.84-12.84c7.091,0,12.84,5.749,12.84,12.84C232.071,95.732,226.327,101.476,219.239,101.484z"
                          data-original="#000000"
                          class="active-path"
                          fill="#000000"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M423.919,358.219c-0.006,0-0.013,0-0.019,0H398v-200h17.842c5.522,0,10.158-4.042,10.158-9.564v-45.68    c-0.033-4.015-2.446-7.627-6.143-9.193L223.215,9.588c-2.52-1.077-5.372-1.077-7.892,0L18.892,93.782    c-3.639,1.595-5.963,5.221-5.892,9.193v45.68c-0.131,5.152,3.94,9.435,9.092,9.566c0.182,0.005,0.363,0.004,0.545-0.002H41v200    H10.1c-5.511-0.067-10.033,4.347-10.1,9.859c0,0.006,0,0.013,0,0.019v47.56c0,5.523,4.574,9.562,10.1,9.562h413.8    c5.523,0,10.1-4.039,10.1-9.562v-47.56C433.944,362.586,429.431,358.163,423.919,358.219z M33,138.219v-28.648l186.5-79.912    L406,109.571v28.648H33z M378,158.219v200h-49v-200H378z M309,158.219v200h-48v-200H309z M241,158.219v200h-48v-200H241z     M173,158.219v200h-48v-200H173z M105,158.219v200H61v-200H105z M414,405.219H20v-27h394V405.219z"
                          data-original="#000000"
                          class="active-path"
                          fill="#000000"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              <h3 class="mb-0 ml-2" id="boothHeaderTxt"></h3>
            </router-link>
          </div>
        </div>

        <div v-show="!protectNav" class="booth-mobile-slide-btn">
          <ul>
            <li>
              <a
                href="#"
                @click.prevent="LoadNext(prv)"
                :data-tag="'exibitorview/' + prv + '/LeftArrow'"
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 455 455"
                    style="enable-background: new 0 0 455 455"
                    xml:space="preserve"
                    width="25px"
                    height="25px"
                  >
                    <g>
                      <path
                        d="M227.5,0C101.855,0,0,101.855,0,227.5S101.855,455,227.5,455S455,353.145,455,227.5S353.145,0,227.5,0z M276.772,334.411  l-21.248,21.178L127.852,227.5L255.524,99.411l21.248,21.178L170.209,227.5L276.772,334.411z"
                        data-original="#000000"
                        class="active-path"
                        fill="#000000"
                      />
                    </g>
                  </svg>
                </span>
                <label>Prev</label>
              </a>
            </li>
            <li>
              <a
                @click.prevent="LoadNext(nxt)"
                :data-tag="'exibitorview/' + prv + '/RightArrow'"
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 455 455"
                    style="enable-background: new 0 0 455 455"
                    xml:space="preserve"
                    width="25px"
                    height="25px"
                    class
                  >
                    <g>
                      <path
                        d="M227.5,0C101.855,0,0,101.855,0,227.5S101.855,455,227.5,455S455,353.145,455,227.5S353.145,0,227.5,0z M199.476,355.589  l-21.248-21.178L284.791,227.5L178.228,120.589l21.248-21.178L327.148,227.5L199.476,355.589z"
                        data-original="#000000"
                        class="active-path"
                        fill="#000000"
                      />
                    </g>
                  </svg>
                </span>
                <label>Next</label>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div
        v-bind:id="item.id"
        v-bind:key="item.id"
        v-for="(item, index) in ExhibitorData"
      >
        <div class="lite-single-booth-wrap">
          <div class="booth-inner-lite wrap">
            <img :src="item.HotspotImageUrL" v-if="showVideoFlg == false" />
            <span v-html="item.HtmlCode" v-if="showVideoFlg == false"></span>
            <img
              @click="playVideoURL"
              v-if="item.ShowcaseVideoURL != '' && showVideoFlg == false"
              class="play-video-btn"
              src="../assets/Images/Play-expo-round-white.png"
            />

            <iframe
              id="frmVideo"
              v-if="showVideoFlg"
              :src="item.ShowcaseVideoURL"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              :data-tag="item.id + '/' + item.Name + ' -Video'"
            ></iframe>
          </div>
        </div>
        <div class="booth-details-wrap">
          <!--<div class="position-relative mr-2 text-right" style="top: 36px">
            <v-btn
              v-if="roomId"
              outlined="false"
              style="cursor: pointer; border: 0"
              @click="joinExpoBoothSepcificChat(roomId)"
              ><img src="../assets/Images/chat-wht.svg" alt="Chat"
            /></v-btn>
            <v-icon color="#fff">bookmark_border</v-icon>
          </div>-->
          <div class="booth-details-small position-relative my-0">
            <div class="booth-image">
              <img :src="item.Logo" />
            </div>
            <div class="booth-description">
              <p>{{ item.Name }}</p>
              <span class="bookmark-icon ml-2">
                <v-tooltip
                  v-if="!item.isBookmarked && !item.isBookmarkLoading"
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      size="32"
                      color="white"
                      @click.stop="addBookMark(item.id, item.Name, item.Logo)"
                      style="cursor: pointer"
                      v-on="on"
                      >bookmark_border</v-icon
                    >
                  </template>
                  <span>Bookmark</span>
                </v-tooltip>
                <v-tooltip
                  v-else-if="item.isBookmarked && !item.isBookmarkLoading"
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      size="32"
                      color="success"
                      @click.stop="addBookMark(item.id, item.Name, item.Logo)"
                      style="cursor: pointer"
                      v-on="on"
                      >bookmark</v-icon
                    >
                  </template>
                  <span>Bookmarked</span>
                </v-tooltip>
                <v-btn
                  v-show="item.isBookmarkLoading"
                  :loading="item.isBookmarkLoading"
                  outlined="false"
                  color="white"
                  style="border: 0"
                  min-width="0"
                  class="tool-tip-loader"
                ></v-btn>
              </span>
            </div>
          </div>
          <div
            class="lite-booth-activity-section d-flex align-item-center flex-wrap"
          >
            <!--data-toggle="modal" data-target="#exampleModalCenter" -->
            <v-btn
              color="#288aef"
              :class="
                allRoundTables.length == 0
                  ? 'exchange-businesscard-lite mt-2 hide-roundtable '
                  : 'exchange-businesscard-lite mt-2 '
              "
              v-on:click="showDiv('exampleModalCenter')"
            >
              <span class="inner-text d-flex align-items-center">
                <img
                  src="../assets/Images/exchange-business-card.svg"
                  class="mr-3"
                  width="34px"
                  alt="e2m"
                />
                Exchange Business Card
              </span>
            </v-btn>
            <!--<button
            :class="
              allRoundTables.length == 0
                ? 'exchange-businesscard-lite mr-3 hide-roundtable'
                : 'exchange-businesscard-lite mr-3'
				
            "
          >
            <span>Join Round Table</span>
          </button>-->
            <!-- v-show="roundtable.IsVisible" -->
            <v-btn
              color="#1a5493"
              v-for="roundtable in allRoundTables"
              v-show="roundtable.IsVisible"
              v-bind:key="roundtable.TableId"
              :class="
                showBusinessCardBtn == false
                  ? 'join-round-table-lite hide-bussiness-card mt-2'
                  : 'join-round-table-lite mt-2'
              "
              :data-tag="'exibitorview/' + roundtable.hostId + '/Roundtable'"
              v-on:click="JoinRT(roundtable.TableId)"
            >
              <span class="inner-text align-items-center">
                <img
                  src="../assets/Images/round-table-white.svg"
                  class="mr-2"
                  width="24px;"
                  alt="e2m"
                />
                Join Round Table
              </span>
            </v-btn>
            <v-btn
              color="#19a883"
              id="btnAppointment"
              class="btn meeting-request mt-2 border-stranprent border-tranprent text-left"
              @click="openSchedulePopup('')"
            >
              <span class="inner-text align-items-center">
                <img
                  src="../assets/Images/icons/calendar-check.svg"
                  class="mr-1"
                  width="32px;"
                  alt="e2m"
                />
                BOOK APPOINTMENT
              </span>
            </v-btn>
          </div>
        </div>
        <div class="booth-inner-company-details-lite">
          <ul class="nav nav-tabs expo-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                id="home-tab"
                data-toggle="tab"
                href="#home"
                role="tab"
                aria-controls="home"
                aria-selected="true"
                >Profile</a
              >
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                id="profile-tab"
                data-toggle="tab"
                href="#profile"
                role="tab"
                aria-controls="profile"
                aria-selected="false"
                >Contacts</a
              >
            </li>

            <li class="nav-item" v-if="isPodiumEnabled">
              <a
                class="nav-link"
                id="upcomingEvent-tab"
                data-toggle="tab"
                href="#upcomingevent"
                role="tab"
                aria-controls="upcomingevent-tab"
                aria-selected="false"
                >Upcoming Events</a
              >
            </li>

            <li class="nav-item" v-if="ExhibitorFiles.length > 0">
              <a
                class="nav-link"
                id="contact-tab"
                data-toggle="tab"
                href="#contact"
                role="tab"
                aria-controls="contact"
                aria-selected="false"
                >Collaterals</a
              >
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade show active"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div class="mobile-company-profile px-4">
                <p v-html="item.Profile"></p>
                <ul>
                  <li>
                    <a
                      :href="'mailto:' + item.Email"
                      target="_blank"
                      v-if="item.Email !== ''"
                      :data-tag="'Email -' + item.Name + '-' + item.Email"
                      >{{ item.Email }}</a
                    >
                  </li>
                  <li>
                    <a
                      :href="'tel:' + item.Phone"
                      :data-tag="'Phone -' + item.Name + '-' + item.Phone"
                      v-if="item.Phone !== ''"
                      >{{ item.Phone }}</a
                    >
                  </li>
                  <li>
                    <a
                      target="_blank"
                      :href="item.Website"
                      :data-tag="'Website -' + item.Name + '-' + item.Website"
                      v-if="item.Website !== ''"
                      >{{ item.Website }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="profile"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div class="mobile-contacts-wrap">
                <div
                  class="mobile-single-contact"
                  v-bind:id="item1.id"
                  v-bind:key="item1.id"
                  v-for="item1 in item.MappedContacts"
                >
                  <div
                    class="mobile-cont-dect-wrap"
                    :data-tag="item.id + '/' + item.Name + '  Contact'"
                  >
                    <div class="mobile-contact-image-wrapper active-contact">
                      <div class="contact-image">
                        <img :src="item1.ProfilePictureURL" />
                      </div>
                    </div>
                    <div class="mobile-cont-desc">
                      <h4>{{ item1.FirstName }} {{ item1.LastName }}</h4>
                      <p>{{ item1.Designation }}</p>
                      <p>{{ item1.Company }}</p>
                    </div>
                  </div>
                  <div class="mobile-contact-options">
                    <ul>
                      <li
                        v-if="
                          EnableExhibitorRepVideoCall &&
                          (item1.VideoCallEnable || item1.AttendeeId == uid)
                        "
                        :data-tag="'VideoCall-' + item1.Name + '-' + item.Name"
                      >
                        <a
                          :id="'lnkVideoCall' + item1.AttendeeId"
                          href="#"
                          :data-tag="
                            'VideoCall-' + item1.Name + '-' + item.Name
                          "
                          @click="onClickHandler"
                          v-on:click.prevent="
                            JoinRepVideoCall(
                              item.id,
                              item1.AttendeeId,
                              item1.StreamingClient,
                              item1.Zoom_Detail
                            );
                            return false;
                          "
                          class="openBroadcast"
                          title="Video call"
                        >
                          <img
                            data-toggle="tooltip"
                            data-html="true"
                            title
                            data-original-title="Video Chat"
                            :data-tag="
                              'VideoCall-' + item1.Name + '-' + item.Name
                            "
                            src="../assets/Images/icons/video3.svg"
                        /></a>
                      </li>
                      <li
                        v-else
                        :data-tag="'VideoCall-' + item1.Name + '-' + item.Name"
                      >
                        <img
                          src="../assets/Images/video-call-grey.svg"
                          data-toggle="tooltip"
                          data-html="true"
                          :data-tag="
                            'VideoCall-' + item1.Name + '-' + item.Name
                          "
                          title
                          data-original-title="Video Chat"
                        />
                      </li>
                      <li
                        :data-tag="'Email-' + item1.Name + '-' + item.Name"
                        v-if="turnONOFFContactsEmailChat"
                      >
                        <a
                          v-on:click="onClickHandler"
                          :href="'mailto:' + item1.Email"
                          target="_blank"
                          title="Email"
                          :data-tag="'Email-' + item1.Name + '-' + item.Name"
                          ><img
                            src="../assets/Images/icons/envelope2.svg"
                            data-toggle="tooltip1"
                            data-html="true"
                            :data-tag="'Email-' + item1.Name + '-' + item.Name"
                            title
                            data-original-title="Email"
                        /></a>
                      </li>
                      <li
                        :data-tag="'Meeting-' + item1.Name + '-' + item.Name"
                        data-toggle="modal"
                        v-bind:data-target="'#calendarModal' + index"
                        v-on:click="OpenRequestMeeting(item1)"
                      >
                        <input type="hidden" id="hdnAttendeeId" />
                        <a
                          data-toggle="tooltip"
                          data-placement="top"
                          @click="onClickHandler"
                          :data-tag="'Meeting-' + item1.Name + '-' + item.Name"
                          data-original-title="Request Meeting"
                          title="1:1 Meeting"
                          ><img
                            src="../assets/Images/Meeting.svg"
                            :data-tag="
                              'Meeting-' + item1.Name + '-' + item.Name
                            "
                        /></a>
                      </li>
                      <li
                        v-if="
                          userid != item1.AttendeeId &&
                          turnONOFFContactsEmailChat
                        "
                        v-on:click="OpenOneToOneChat(item1)"
                        :data-tag="
                          'One To One Chat-' + item1.Name + '-' + item.Name
                        "
                      >
                        <a
                          data-toggle="tooltip"
                          data-placement="top"
                          class="ml-2"
                          :data-tag="
                            'One To One Chat-' + item1.Name + '-' + item.Name
                          "
                          data-original-title="Request Chat"
                          title="1:1 Chat"
                          ><img
                            src="../assets/Images/icons/chat.svg"
                            :data-tag="
                              'One To One Chat-' + item1.Name + '-' + item.Name
                            "
                        /></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="tab-pane fade"
              id="upcomingevent"
              role="tabpanel"
              aria-labelledby="upcomingevent-tab"
            >
              <div class="mobile-podium-hld text-center pt-3">
                <h4 v-if="podiumTitle">{{ podiumTitle }}</h4>
                <p class="text-justify" v-if="podiumDescription">
                  {{ podiumDescription }}
                </p>
                <div
                  class="empodium-bottom-buttons d-flex justify-content-center"
                >
                  <a
                    class="single-bottom-buttons mr-2"
                    :href="knowMoreLink"
                    target="_blank"
                    v-if="knowMoreLink"
                    >KNOW MORE
                    <v-icon color="#ffffff" size="25px"
                      >mdi-arrow-right</v-icon
                    ></a
                  >
                  <v-btn
                    class="single-bottom-buttons"
                    :loading="registering"
                    @click="
                      Register(
                        ExhibitorData[0].id,
                        ExhibitorData[0].Name,
                        podiumTitle
                      )
                    "
                  >
                    REGISTER
                    <v-icon color="#ffffff" size="25px"
                      >mdi-arrow-right</v-icon
                    ></v-btn
                  >
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="contact"
              role="tabpanel"
              aria-labelledby="contact-tab"
            >
              <div class="mobile-collaterals-wrapper">
                <div
                  class="mobile-single-collaterals"
                  v-bind:id="item2.id"
                  v-bind:key="item2.id"
                  v-for="item2 in ExhibitorFiles"
                >
                  <div
                    class="collateral-file-icon-img"
                    :data-tag="
                      'Download - ' + item.Name + ' - ' + item2.Filename
                    "
                  >
                    <img
                      v-if="item2.Url.includes('.mp4')"
                      :data-tag="
                        'Download - ' + item.Name + ' - ' + item2.Filename
                      "
                      src="../assets/Images/icons/video-icon.svg"
                      style="height: 35px; width: 35px"
                    />
                    <img
                      v-else
                      :data-tag="
                        'Download - ' + item.Name + ' - ' + item2.Filename
                      "
                      src="../assets/Images/icons/pdf.svg"
                    />
                  </div>
                  <div class="collaterals-file">
                    <a
                      :href="item2.Url"
                      target="_blank"
                      :data-tag="
                        'Download - ' + item.Name + ' - ' + item2.Filename
                      "
                    >
                      <h4>{{ item2.Filename }}</h4>
                    </a>
                  </div>
                  <div class="collaterals-download">
                    <a
                      :href="item2.Url"
                      target="_blank"
                      :data-tag="
                        'Download - ' + item.Name + ' - ' + item2.Filename
                      "
                    >
                      <!-- <img src="../assets/Images/icons/download.svg" /> -->
                      <i
                        class="fa fa-external-link"
                        aria-hidden="true"
                        style="color: black"
                      ></i>
                    </a>
                  </div>
                </div>
                <div
                  class="mobile-single-collaterals"
                  v-bind:id="links.id"
                  v-bind:key="links.id"
                  v-for="links in ExhibitorLinks"
                >
                  <div
                    class="collateral-file-icon-img"
                    :data-tag="'Link - ' + links.Title + ' - ' + links.Link"
                  >
                    <img
                      :data-tag="'Link - ' + links.Title + ' - ' + links.Link"
                      src="../assets/Images/icons/link.svg"
                      style="height: 35px; width: 35px"
                    />
                  </div>
                  <div class="collaterals-file">
                    <a
                      :href="links.Link"
                      target="_blank"
                      :data-tag="'Link - ' + links.Title + ' - ' + links.Link"
                    >
                      <h4>{{ links.Title }}</h4>
                    </a>
                  </div>
                  <div class="collaterals-download">
                    <a
                      :href="links.Link"
                      target="_blank"
                      :data-tag="'Link - ' + links.Title + ' - ' + links.Link"
                    >
                      <!-- <img src="../assets/Images/icons/download.svg" /> -->
                      <i
                        class="fa fa-external-link"
                        aria-hidden="true"
                        style="color: black"
                      ></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RequestMeeting
      v-if="mobileView && requestMeetingFlag"
      key="requestMeetingKey"
    ></RequestMeeting>
    <div
      v-if="mobileView"
      id="exampleModalCenter"
      class="modal fade"
      tabindex="-1"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div
        class="business-card-modal modal-dialog modal-dialog-centered"
        id="businessCrdModal"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Leave a Message
            </h5>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="closeDiv('exampleModalCenter')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <textarea
              placeholder="Your Message"
              id="sendBunessCardMsg"
            ></textarea>
          </div>
          <div class="modal-footer">
            <div class="mobile-card-exchange-footer">
              <p>You agree to exchange contact details with this Expo booth</p>
              <!--<button
                type="button"
                class="btn btn-primary"
                :data-tag="'Exchange Bussiness Card -  Exhibitor -' + BoothName"
                v-on:click="ExchangeBusinessCard('mobile')"
              >
                Send
              </button>-->
              <v-btn
                :loading="businessCardSending"
                :data-tag="'Exchange Bussiness Card -  Exhibitor -' + BoothName"
                @click="ExchangeBusinessCard('mobile')"
              >
                {{ $t("expoview.send") }}
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="mobileView" class="modal fade all-modal" id="Othermsg-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div id="dvOtherMsg" class="classOtheMsg"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="mobileView" class="game-wrap d-none">
      <h3>Participate Scavenger Hunt</h3>
      <v-dialog transition="dialog-bottom-transition" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <div class="code-reveal-btn" v-bind="attrs" v-on="on">
            <img src="../assets/Images/leaderboard/reveal-code.svg" />
            <p>
              Reveal Code

              <v-icon dark color="#f62290" size="25">mdi-arrow-right</v-icon>
            </p>
          </div>
        </template>

        <template v-slot:default="dialog" class="shadow-hide">
          <div class="mobile-scavenger-dialog">
            <div class="mobile-scavenger-dialog-inner">
              <div class="mobile-congo">
                <img src="../assets/Images/leaderboard/congratulations.png" />
              </div>
              <p>You have revealed the secret code</p>
              <div class="mobile-reveal-code">
                <h4>SBC20</h4>
              </div>
              <p>You have received</p>
              <h3>10</h3>
              <p style="font-size: 20px" class="my-0">Points</p>
              <v-btn
                depressed
                color="#fff"
                class="mt-4"
                @click="dialog.value = false"
              >
                Collect Now
              </v-btn>
            </div>
          </div>
        </template>
      </v-dialog>
    </div>
    <v-dialog v-model="eventRegSuccessDialog" width="500">
      <v-card>
        <v-card-text>
          <div class="success-event-hld position-rleative">
            <v-btn
              icon
              class="close-btn-success"
              @click="eventRegSuccessDialog = false"
              ><v-icon color="#333" size="24px">mdi-close</v-icon></v-btn
            >
            <img src="../assets/Images/landing/recorded.svg" />
            <p>
              Your interest for the event is successfully recorded. You will
              hear from the Organizer soon.
            </p>
            <v-btn
              dark
              class="yes-submit"
              width="120px"
              @click="eventRegSuccessDialog = false"
              >OK</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
.desktop-view {
  .pdf-wrap i.fa {
    visibility: hidden;
  }

  .pdf-wrap .single-pdf:hover i.fa {
    visibility: visible;
  }

  #divBusinessCard.include-appointment {
    min-width: 450px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    max-width: auto;
  }

  #divBusinessCard.include-appointment button.expo-details-appo-btn {
    margin-top: 0;
    margin-left: 10px;
    font-family: "Poppins", sans-serif;
  }

  #divBusinessCard.include-appointment .business-card-dropdown:after {
    right: 160px;
  }

  .one-booth {
    background-image: url("https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FSymposium%20Exhibitor%20Booth%2Fexpo-bg.jpg?alt=media&token=3eb488b8-32fd-4fae-8d49-b35a4e9a3ded") !important;
  }
}

@import "../assets/expo.css";
@import "../assets/Hotspot/css/jquery-hotspotter.min.css";
@import "../assets/Hotspot/css/jquery-ui-1.9.2.custom.min.css";

/*@media only screen and (min-width: 1025px) and (max-width: 1366px) {*/
@media only screen and (max-width: 1366px) {
  .desktop-view {
    .single-tooltip-common {
      max-width: 440px;
    }
  }
}

/*@media only screen and (max-width: 1024px) {
  .single-tooltip-common {
    max-width: 275px;
  }
}*/
</style>

<style>
.edit-expo-btn {
  font-size: 16px !important;
  text-transform: capitalize !important;
  font-weight: 500 !important;
  font-family: "poppins", sans-serif !important;
  display: flex;
  align-items: center;
  justify-content: space-between !important;
  overflow: hidden;
}

.edit-expo-btn .drop-toggle {
  height: 40px;
  margin: 0 !important;
  min-width: 15px;
  padding: 0;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  border-left: 1px solid #6e6e6e;
  cursor: pointer;
  padding-left: 8px !important;
  margin-left: 15px !important;
  padding-right: 8px;
}

.edit-expo-btn {
  font-weight: 400 !important;
  font-size: 14px !important;
  padding-right: 0 !important;
}

.edit-expo-btn .drop-toggle:before {
  display: inline-block;
  width: 0;
  height: 0;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
  opacity: 0.6;
}

.edit-expo-btn:hover .drop-toggle:before {
  opacity: 1;
}

#vueScratchableWrapper {
  font-family: "Open Sans", sans-serif;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  margin: 0;
  z-index: 9;
  position: absolute !important;
}

#vueScratchableWrapper.vue-scratchable-wrapper {
  background-color: white;
  position: absolute !important;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
}

#vueScratchableWrapper h3 {
  color: #2c3e50;
  text-align: center;
}

#vueScratchableWrapper a {
  color: #2196f3;
}

#vueScratchableWrapper canvas {
  height: 100% !important;
}

.reveal-code.revealed-code {
  background: #ffffff url(../assets/Images/leaderboard/revealed-code.svg)
    no-repeat left 12px center / 10px;
}

.scavenger-hunt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.scavenger-hunt-right {
  left: unset;
  right: 42px;
}
</style>


<style lang="scss">
.clsclick:hover {
  cursor: pointer;
}

.desktop-view#divTop span.online {
  display: inline-block !important;
}

.desktop-view.expoDiv {
  width: 100%;
  height: calc(100vh - var(--banner-height));
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background-repeat: no-repeat;
  background-size: cover;
  /*background-image: url("https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591205467009E1625670766113%2FExhibitor%2FTypes%2FBackgroundImg%2F1626072629198_1615793755736_expo-bg%20(1).jpg?alt=media");*/
}

.full-screen .desktop-view.expoDiv {
  height: 100vh;
}

.client-dialog-exhibitors {
  width: 1000px;
  /*min-height: 600px;
  max-height: 600px;*/
}

.client-dialog-exhibitors .v-sheet.v-card {
  border-radius: 0px !important;
}

.ex-dialog-body {
  /*margin: 20px !important;*/
  height: 530px;
}

.client-dialog-exhibitors .v-tab {
  text-transform: unset !important;
}

.client-dialog-exhibitors .tab-content {
  margin-top: 0px;
}

.client-dialog-exhibitors .tab-content .v-tab {
  margin-bottom: 10px;
}

.client-dialog-exhibitors .v-tab:first-child {
  margin-left: 0px !important;
}

.client-dialog-exhibitors .v-tab {
  padding: 6px !important;
}

.client-dialog-exhibitors .v-tabs.v-tabs--vertical .v-tab {
  padding: 0px !important;
  padding-right: 6px !important;
}

.client-dialog-exhibitors .v-tabs-bar {
  height: 60px !important;
}

.scavenge-body {
  overflow: hidden !important;
}
</style>
<style>
.tab-top {
  font-size: 22px !important;
}

.tab-top.first-tab {
  margin-left: 32px !important;
}

@media only screen and (max-width: 767px) {
  .tab-top {
    font-size: 16px !important;
  }

  .tab-top.first-tab {
    margin-left: 5px !important;
  }

  .client-dialog-exhibitors .v-tabs-bar {
    height: 80px !important;
  }

  .client-dialog-exhibitors .v-tabs-bar a.tab-top {
    width: 45%;
  }
}
</style>

<style lang="scss">
.substitute-booth-page {
  .v-btn.meeting-request {
    color: #6cd2e7;
    background-color: #19a883;
    background-size: 20px;
    border-color: #6cd2e7;
    height: 52px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: 2px solid #fff;
    color: #fff;
    margin: 0;
    font-weight: 400;
    font-size: 1rem;
    //padding-left: 52px;
    cursor: pointer;
    position: relative;
    z-index: 1;
  }

  .v-btn.meeting-request {
    border-radius: 6px 0 0 6px !important;
  }

  .v-btn.meeting-request:before {
    background: url(../assets/Images/icons/calendar-check.svg) no-repeat 3px 2px;
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-repeat: no-repeat;
    width: 45px;
    height: 35px;
    right: auto;
    left: 10px;
  }

  .booth-mobile-slide-btn ul li a {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 10px !important;
  }

  .booth-mobile-slide-btn ul li:last-child a {
    margin-right: 0;
  }

  .booth-mobile-slide-btn ul li a label {
    margin: 0;
    color: #000;
  }

  .mobile-card-exchange-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }

  .mobile-card-exchange-footer p {
    margin: 0;
  }

  .boothpage-lite-wrapper {
    background: #eee;
    padding: 20px 0;
    height: 100%;
  }

  .lite-single-booth-wrap {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .booth-details-small {
    background: #333;
    padding: 15px;
    margin: 20px 0;
    border-radius: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .booth-details-small .booth-image {
    height: 148px;
    background: #fff;
    width: 200px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .booth-details-small .booth-image img {
    width: 100%;
  }

  .booth-details-small .booth-description {
    padding-left: 18px;
  }

  .booth-details-small .booth-description p {
    color: #fff;
    font-size: 18px;
    font-weight: 400;
    margin: 0;
  }

  .booth-details-small .booth-description .bookmark-icon {
    position: absolute;
    top: 15px;
    right: 15px;
  }

  .exchange-businesscard-lite {
    background: #288aef url(../assets/Images/exchange-business-card.svg)
      no-repeat left 8px center;
    height: 52px;
    width: 282px;
    display: block;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    //border: 2px solid #fff;
    color: #fff;
    margin: 0;
    font-weight: 400;
    font-size: 1rem;
    padding-left: 44px;
    cursor: pointer;
  }

  .join-round-table-lite {
    background: #1a5493 url(../assets/Images/round-table-white.svg) no-repeat
      left 8px center;
    height: 52px;
    width: 200px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: 2px solid #fff;
    color: #fff;
    margin: 0;
    font-weight: 400;
    font-size: 1rem;
    padding-left: 44px;
    cursor: pointer;
  }

  .booth-inner-company-details-lite {
    margin-top: 25px;
  }

  .booth-inner-company-details-lite .nav-tabs {
    border-bottom: none;
  }

  .booth-inner-company-details-lite .nav-tabs .nav-link {
    border: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom: 4px solid transparent;
  }

  .booth-inner-company-details-lite .nav-tabs .nav-link.active,
  .booth-inner-company-details-lite .nav-tabs .nav-item.show .nav-link {
    color: #495057;
    background-color: transparent;
    border-color: #f00;
    color: #000;
    font-weight: 600;
  }

  .booth-inner-company-details-lite ul li a {
    color: #333;
  }

  .mobile-company-profile {
    padding: 15px 0;
  }

  .mobile-company-profile p {
    color: #333;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    margin: 0;
    margin-bottom: 5px;
  }

  .mobile-company-profile ul {
    margin: 15px 0 0;
    padding: 0;
  }

  .mobile-company-profile ul li {
    list-style: none;
    display: block;
  }

  .mobile-company-profile ul li a {
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    padding-left: 40px;
    margin-bottom: 8px;
  }

  .mobile-company-profile ul li:first-child a {
    background: url(../assets/Images/icons/envelope.svg) no-repeat scroll left
      center;
  }

  .mobile-company-profile ul li:nth-child(2) a {
    background: url(../assets/Images/icons/contact.svg) no-repeat scroll left
      center;
  }

  .mobile-company-profile ul li:last-child a {
    background: url(../assets/Images/icons/web.svg) no-repeat scroll left center;
  }

  .mobile-contacts-wrap {
    padding: 15px;
  }

  .mobile-contact-image-wrapper {
    height: 53px;
    width: 53px;
    border-radius: 50%;
    position: relative;
  }

  .mobile-contact-image-wrapper.active-contact:after {
    content: "";
    position: absolute;
    height: 10px;
    width: 10px;
    background: #2ec72e;
    right: 8px;
    bottom: 3px;
    border-radius: 50%;
  }

  .mobile-contact-image-wrapper.away-contact:after {
    content: "";
    position: absolute;
    height: 10px;
    width: 10px;
    background: #ffc400;
    right: 8px;
    bottom: 3px;
    border-radius: 50%;
  }

  .mobile-contact-image-wrapper.offline-contact:after {
    content: "";
    position: absolute;
    height: 10px;
    width: 10px;
    background: #f00;
    right: 8px;
    bottom: 3px;
    border-radius: 50%;
  }

  .mobile-cont-dect-wrap .contact-image {
    height: 50px;
    width: 50px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    position: relative;
  }

  .mobile-cont-dect-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .mobile-cont-desc {
    padding-left: 15px;
  }

  .mobile-cont-desc h4 {
    font-size: 20px;
    font-weight: 500;
    color: #333;
    margin-bottom: 3px;
  }

  .mobile-cont-desc p {
    font-size: 16px;
    font-weight: 400;
    color: #333;
    margin-bottom: 3px;
  }

  .mobile-single-contact {
    padding: 15px;
    box-shadow: 0 0 6px rgb(0 0 0 / 50%);
    border-radius: 5px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 15px;
    flex-direction: column;
  }

  .mobile-contact-options ul {
    margin: 0;
    padding: 0;
  }

  .mobile-contact-options ul li {
    list-style: none;
    display: inline-block;
  }

  .mobile-contact-options ul li a {
    display: inline-block;
    margin: 10px;
  }

  .mobile-contacts-wrap {
    padding: 15px;
    height: 287px;
    overflow-y: auto;
  }

  .mobile-collaterals-wrapper {
    padding: 15px;
    height: 250px;
    overflow-y: auto;
  }

  .mobile-single-collaterals {
    padding: 8px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }

  .collaterals-file h4 {
    font-size: 20px;
    font-weight: 500;
    color: #333;
    margin: 0;
    padding-left: 10px;
    /* background: url(../assets/Images/icons/pdf.svg) no-repeat left center / auto; */
    line-height: 17px;
    word-break: break-word;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .substitute-booth-page {
    button.join-round-table-lite.hide-bussiness-card {
      justify-content: flex-start;
    }

    .lite-booth-activity-section .exchange-businesscard-lite,
    .lite-booth-activity-section .v-btn.meeting-request,
    .lite-booth-activity-section .join-round-table-lite {
      flex: 1 1 calc(33.3% - 6px);
      border: 0 !important;
      background-image: none;
      height: 52px;
      border-radius: 6px !important;
      margin: 0 3px;
      white-space: inherit;
      max-width: 300px;
    }

    .lite-booth-activity-section .exchange-businesscard-lite .v-btn__content {
      justify-content: center;
      line-height: 1;
    }

    .expo-tabs {
      display: flex;
    }

    .exchange-businesscard-lite {
      //width: 50%;
      font-size: 14px;
      background-size: 27px;
      padding-left: 44px;
    }

    .join-round-table-lite {
      width: 45%;
      font-size: 14px;
    }

    .join-round-table-lite {
      padding-left: 30px;
      background-size: 24px;
    }

    .mobile-single-contact {
      padding: 8px;
    }

    .mobile-contact-options ul li a img {
      height: 30px;
      width: 30px;
    }

    .mobile-contact-options {
      width: 100%;
    }

    .mobile-contact-options ul {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .mobile-cont-desc {
      padding-left: 0px;
    }

    .mobile-cont-desc h4 {
      font-size: 16px;
      margin-bottom: 0;
    }

    .mobile-cont-desc p {
      font-size: 14px;
      margin-bottom: 0;
    }

    .mobile-contact-options ul li a {
      margin: 10px;
    }

    .mobile-contacts-wrap {
      padding: 15px;
    }

    .mobile-cont-dect-wrap .contact-image {
      height: 40px;
      width: 40px;
    }

    .mobile-contact-image-wrapper {
      height: 40px;
      width: 48px;
    }

    .collaterals-file h4 {
      font-size: 16px;
    }

    .play-video-btn {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .booth-inner-lite {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }

    .booth-inner-light img {
      max-width: 100%;
      height: 100%;
    }

    .booth-inner-light img.play-video-btn {
      height: auto !important;
    }

    .business-card-modal .modal-body textarea {
      width: 100%;
      height: 200px;
      border-radius: 6px;
      border: 1px solid #dfdfdf;
      padding: 10px;
      font-size: 14px;
      color: #838383;
      resize: none;
    }

    .business-card-modal .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0rem 1rem;
      border-bottom: none;
    }

    .business-card-modal button.close {
      position: relative;
      top: 0;
      right: 0;
      z-index: 99;
    }

    .business-card-modal .btn-primary {
      color: #fff;
      background-color: #19a883;
      border-color: #19a883;
    }

    .collaterals-download {
      height: 30px;
      width: 30px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 0 0 30px;
    }

    .collaterals-download img {
      max-width: 100%;
      height: 100%;
    }

    .collateral-file-icon-img img {
      max-width: 100%;
      height: 100%;
    }

    .collateral-file-icon-img {
      width: 30px;
      height: 30px;
      flex: 30px 0 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .booth-inner-lite iframe {
      width: 100%;
      height: 354px;
    }

    .booth-details-small {
      padding-top: 15px !important;
    }

    .booth-details-small .booth-image {
      height: 100px;
      width: 30%;
      flex: 30% 0 0;
    }

    .mobile-booth-head-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }

    .booth-head-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .back-to-hall {
      height: 25px;
      //width: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      margin-right: 10px;
    }

    .back-to-hall a {
      color: #000 !important;
    }

    .back-to-hall img {
      max-width: 100%;
      height: 100%;
    }

    .booth-mobile-slide-btn ul {
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .booth-mobile-slide-btn ul li {
      display: inline-block;
    }

    .booth-mobile-slide-btn ul li:last-child {
      margin-right: 0;
    }

    .booth-mobile-slide-btn ul li span {
      display: inline-flex;
      height: 25px;
      width: 25px;
      justify-content: center;
      align-items: center;
    }

    .boothpage-lite-wrapper {
      padding: 20px 0 20px 80px;
    }

    .booth-details-wrap {
      margin-top: 15px;
    }

    .game-wrap {
      position: fixed;
      bottom: 0;
      z-index: 99;
      /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ff6801+0,f62290+73,f62290+73 */
      background: #ff6801;
      /* Old browsers */
      background: -moz-linear-gradient(
        left,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      );
      /* FF3.6-15 */
      background: -webkit-linear-gradient(
        left,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      );
      /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(
        to right,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      );
      /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff6801', endColorstr='#f62290', GradientType=1);
      /* IE6-9 */
      width: 100%;
      left: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;

      h3 {
        margin: 0;
        color: #fff;
        font-weight: 600;
        font-size: 24px;
        padding-left: 10px;
      }
    }

    .v-dialog {
      box-shadow: none !important;
    }

    .code-reveal-btn {
      background: #fff;
      margin-right: 10px;
      padding: 8px 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 5px;
      width: 212px;

      p {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 0;
        color: #f62290;
        font-weight: 600;
      }
    }

    .mobile-scavenger-dialog {
      height: 390px;
      /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ff6801+0,f62290+73,f62290+73 */
      background: #ff6801;
      /* Old browsers */
      background: -moz-linear-gradient(
        top,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      );
      /* FF3.6-15 */
      background: -webkit-linear-gradient(
        top,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      );
      /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(
        to bottom,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      );
      /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff6801', endColorstr='#f62290', GradientType=0);
      /* IE6-9 */
      border-radius: 25px;

      .mobile-scavenger-dialog-inner {
        height: 100%;
        padding: 22px;
        text-align: center;

        p {
          color: #fff;
          margin-top: 17px;
          width: 150px;
          margin: 12px auto 0;
          font-size: 18px;
        }

        .mobile-reveal-code h4 {
          display: inline-block;
          background: #fff;
          padding: 5px 8px;
          border-radius: 10px;
          margin-top: 10px;
        }

        h3 {
          color: #fff;
          font-size: 50px;
          margin: 0;
          line-height: 46px;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .substitute-booth-page {
    .container {
      padding: 12px 0;
    }

    button.exchange-businesscard-lite.hide-roundtable {
      width: 100%;
      justify-content: flex-start;
      padding-left: 60px;
    }

    button.join-round-table-lite.hide-bussiness-card {
      width: 100%;
      justify-content: flex-start;
      padding-left: 60px;
    }

    .expo-tabs {
      padding: 0 15px !important;
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      border: 1px solid #dbdbdb !important;
      border-right: 0 !important;
      border-left: 0 !important;
    }

    .exchange-businesscard-lite {
      width: 50%;
      font-size: 14px;
      background-size: 27px;
      padding-left: 44px;
    }

    .lite-booth-activity-section .join-round-table-lite .v-btn__content,
    .lite-booth-activity-section .meeting-request .v-btn__content {
      flex: auto;
    }

    .lite-booth-activity-section .exchange-businesscard-lite {
      flex: 1 1 100%;
      border: 0 !important;
      background-image: none;
      height: 52px;
      padding-left: 6px;
      padding-right: 6px;
      margin: 0 2px;
    }

    .lite-booth-activity-section .join-round-table-lite {
      flex: 1 1 40%;
      border: 0 !important;
      background-image: none;
      height: 52px;
      white-space: inherit;
      margin: 0 2px;
      padding-left: 6px;
      padding-right: 6px;
    }

    .lite-booth-activity-section .v-btn.meeting-request {
      flex: 1 1 40%;
      border: 0 !important;
      border-radius: 6px !important;
      background-image: none;
      height: 52px;
      white-space: inherit;
      margin: 0 2px;
      padding-left: 6px;
      padding-right: 6px;
    }

    .v-btn.meeting-request .inner-text,
    .exchange-businesscard-lite .inner-text,
    .join-round-table-lite .inner-text {
      min-height: 40px;
      display: flex;
      align-items: center;
      text-align: center;
    }

    .join-round-table-lite {
      width: 45%;
      font-size: 14px;
    }

    .join-round-table-lite {
      padding-left: 30px;
      background-size: 24px;
    }

    .mobile-single-contact {
      padding: 15px;
    }

    .mobile-contact-options ul li a img {
      height: 30px;
      width: 30px;
    }

    .mobile-contact-options {
      width: 100%;
    }

    .mobile-contact-options ul {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .mobile-cont-desc {
      padding-left: 0px;
    }

    .mobile-cont-desc h4 {
      font-size: 16px;
      margin-bottom: 0;
      font-weight: 600;
    }

    .mobile-cont-desc p {
      font-size: 14px;
      margin-bottom: 0;
    }

    .mobile-contact-options ul li a {
      margin: 10px;
    }

    .mobile-contacts-wrap {
      padding: 15px 8px;
    }

    .mobile-cont-dect-wrap .contact-image {
      height: 40px;
      width: 40px;
    }

    .mobile-contact-image-wrapper {
      height: 40px;
      width: 48px;
    }

    .collaterals-file h4 {
      font-size: 16px;
    }

    .play-video-btn {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .booth-inner-lite {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }

    .booth-inner-light img {
      max-width: 100%;
      height: 100%;
    }

    .booth-inner-light img.play-video-btn {
      height: auto !important;
    }

    .business-card-modal .modal-body textarea {
      width: 100%;
      height: 200px;
      border-radius: 6px;
      border: 1px solid #dfdfdf;
      padding: 10px;
      font-size: 14px;
      color: #838383;
      resize: none;
    }

    .business-card-modal .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0rem 1rem;
      border-bottom: none;
    }

    .business-card-modal button.close {
      position: relative;
      top: 0;
      right: 0;
      z-index: 99;
    }

    .business-card-modal .btn-primary {
      color: #fff;
      background-color: #19a883;
      border-color: #19a883;
    }

    .collaterals-download {
      height: 30px;
      width: 30px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 0 0 30px;
    }

    .collaterals-download img {
      max-width: 100%;
      height: 100%;
    }

    .collateral-file-icon-img img {
      max-width: 100%;
      height: 100%;
    }

    .collateral-file-icon-img {
      width: 30px;
      height: 30px;
      flex: 30px 0 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .booth-inner-lite iframe {
      width: 100%;
      height: 170px;
    }

    .booth-details-wrap {
      background: #333;
    }

    .booth-details-wrap .lite-booth-activity-section {
      padding: 0 15px 15px;
    }

    .booth-details-small .booth-image {
      height: 100px;
      width: 30%;
      flex: 30% 0 0;
    }

    .mobile-booth-head-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }

    .booth-head-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-left: 8px;
    }

    .back-to-hall {
      height: 25px;
      //width: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      margin-right: 10px;
    }

    .back-to-hall a {
      color: #000 !important;
    }

    .back-to-hall img {
      max-width: 100%;
      height: 100%;
    }

    .booth-mobile-slide-btn ul {
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .booth-mobile-slide-btn ul li {
      display: inline-block;
    }

    .booth-mobile-slide-btn ul li:last-child {
      margin-right: 0;
    }

    .booth-mobile-slide-btn ul li span {
      display: inline-flex;
      height: 25px;
      width: 25px;
      justify-content: center;
      align-items: center;
    }

    .game-wrap {
      position: fixed;
      bottom: 0;
      z-index: 99;
      /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ff6801+0,f62290+73,f62290+73 */
      background: #ff6801;
      /* Old browsers */
      background: -moz-linear-gradient(
        left,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      );
      /* FF3.6-15 */
      background: -webkit-linear-gradient(
        left,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      );
      /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(
        to right,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      );
      /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff6801', endColorstr='#f62290', GradientType=1);
      /* IE6-9 */
      width: 100%;
      left: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;

      h3 {
        margin: 0;
        color: #fff;
        font-weight: 600;
        font-size: 24px;
        padding-left: 10px;
      }
    }

    .v-dialog {
      box-shadow: none !important;
    }

    .code-reveal-btn {
      background: #fff;
      margin-right: 10px;
      padding: 8px 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 5px;
      width: 212px;

      p {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 0;
        color: #f62290;
        font-weight: 600;
      }
    }

    .mobile-scavenger-dialog {
      height: 390px;
      /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ff6801+0,f62290+73,f62290+73 */
      background: #ff6801;
      /* Old browsers */
      background: -moz-linear-gradient(
        top,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      );
      /* FF3.6-15 */
      background: -webkit-linear-gradient(
        top,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      );
      /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(
        to bottom,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      );
      /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff6801', endColorstr='#f62290', GradientType=0);
      /* IE6-9 */
      border-radius: 25px;

      .mobile-scavenger-dialog-inner {
        height: 100%;
        padding: 22px;
        text-align: center;

        p {
          color: #fff;
          margin-top: 17px;
          width: 150px;
          margin: 12px auto 0;
          font-size: 18px;
        }

        .mobile-reveal-code h4 {
          display: inline-block;
          background: #fff;
          padding: 5px 8px;
          border-radius: 10px;
          margin-top: 10px;
        }

        h3 {
          color: #fff;
          font-size: 50px;
          margin: 0;
          line-height: 46px;
        }
      }
    }
  }
}
</style>

<script>
import Vue from "vue";
import db from "../components/firebaseInit";
import router from "../router";
import store from "../store";
import jQuery from "jquery";
import analytics from "@/components/Analytics";
import moment from "moment";
import axios from "axios";
import VueScratchable from "vue-scratchable";
import paperPattern from "@/assets/Images/natural-paper-texture.jpg";
//import paperPattern from "@/assets/Images/ariel-view-floor-space.jpg";
//import paperPattern from "@/assets/Images/ascena.png";
import APIs from "@/components/APIInit";
import Exhibitors from "@/components/Exhibitors.vue";
import ExhibitorsMeeting from "@/components/ExhibitorsMeeting.vue";
import RequestMeeting from "@/components/RequestMeeting.vue";
import RoundTable from "@/components/RoundTable.vue";
import common from "@/common";
import { bus } from "../main";
let $ = jQuery;

var vm;
var interval = null;
export default {
  components: {
    Exhibitors,
    ExhibitorsMeeting,
    RequestMeeting,
    VueScratchable,
    RoundTable,
  },
  data() {
    return {
      allowBusinessCardExchange: false,
      disableEditBtn: false,
      showBoothEditButton: false,
      expoNameForExport: null,
      eventRegSuccessDialog: false,
      isPodiumEnabled: false,
      podiumTitle: null,
      podiumDescription: null,
      ctaLink: null,
      knowMoreLink: null,
      turnONOFFContactsEmailChat: false,
      AllowMoreThan1tojoinRepInVideoCall: false,
      ShowRepActiveStatus: false,
      EnableExhibitorRepVideoCall: false,
      AllowRequestMeetingInExpoHall: false,
      ExhParticipance: [],
      headerText: "Exhibit Hall",
      LiveStageURL: "/livestage",
      id: null,
      Name: null,
      BoothNo: null,
      Category: null,
      Email: null,
      Website: null,
      Image: null,
      Profile: null,
      Phone: null,
      MappedGroup: [],
      BroadcastData: [],
      exid: null,
      pageSize: 9,
      pageIndex: 0,
      roomId: null,
      totalRecords: 1,
      lastVisible: null,
      Exhibitorlist: [],
      ExhibitorData: [],
      DropFilter: [],
      nxt: null,
      prv: null,
      loadedScript: 0,
      timerLoader: 0,
      tid: null,
      event_collectionName: "",
      allRoundTables: [],
      tableTopic: {
        TopicId: "",
        TopicName: "",
        TopicLogo: "",
        ExhibitorId: "",
        ExhibitorName: "",
      },
      eventId2: "",
      uid: "",
      visitor: true,
      allowRequestMeeting: true,
      clientId: "",
      eventId: "",
      roundtableTopicData: [],
      roundtableAttendeesData: [],
      arrMappedAttndees: [],
      ExhibitorFiles: [],
      ExhibitorLinks: [],
      displayPic: null,
      Username: null,
      boothSettingsLoaded: false,
      boothDetailsLoaded: false,
      boothDefaultBackgroundImage:
        "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FSymposium%20Exhibitor%20Booth%2Fexpo-bg.jpg?alt=media&token=3eb488b8-32fd-4fae-8d49-b35a4e9a3ded",
      ExpoHallBackgroundImage: "",
      expoHallTypeBackgroundImage: "",
      JoinTheConversationTextFormat:
        "Welcome to {BoothName} Our Reps are here to assist you.",
      JoinTheConversationText: "",
      isBusinessCardApiNew: false,
      APIs: APIs,
      showAerialView: false,
      showBirdView: false,
      alreadyChatted: false,
      GlobalKeysData: {
        // id: "SN1591285924312",
        // Name: "Opening Key Note",
        IsOpenInternalPlayer: 1,
        IsBroadcastInNewTab: 1,
        broadcastbaseURL:
          "https://he96zdju46.execute-api.us-east-1.amazonaws.com/PRD/",
        BroadcastID: "605f401455444442838e00cb859c037b",
        BroadcastCertificate: "8f472eef21f64cba97c105eab797522f",
        BroadcastSpeakerApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        BroadcastAttendeeApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        BroadcastStartURL: "https://onair2.e2m.live/video/live-broadcast.html",
        BroadcastViewURL: "https://onair2.e2m.live/video/live-audience.html",
        videoId: "605f401455444442838e00cb859c037b",
        // UserID: "84607270",
        //  eventID: this.eventId,
        // chanelID: "GB" + "_4733" + "_" + "SN1591285924312",
        BroadcastvalidityHours: "72",
        ChannelPrefix: "OAUAT",
        OnDemandTypeID: 1,
        LiveStreamTypeID: 2,
        LivePanelTypeID: 3,
        RoundTableTypeID: 4,
        videoParamsEncryptURL: "https://awsapi.e2m.live/encrypt-call-params",
      },
      rtSettings: {
        SeatGrabText: this.$t("livestage.grabseat"),
        AudienceViewText: this.$t("livestage.spectate"),
        TableFullText: this.$t("livestage.tablefull"),
      },
      zoomErrorMsg:
        "An error has occurred with this Zoom live panel session. Please try again in sometime.",
      defaultChatMsg: null,
      openVideoModal: false,
      showcaseVideoUrl: "",
      dialog: false,
      tab: "schedule",
      requestMeetingKey: 0,
      requestMeetingFlag: false,
      currentAttendee: null,
      scrachScreen: true,
      blastConfetti: false,
      ScavengerHuntGameLoaded: false,
      ScavengerHuntGamePlayed: false,
      scavengerHuntDialog: false,
      scavengerHuntDialogKey: 0,
      ScavengerHuntEnabled: false,
      ScavengerHuntDocId: "",
      ScavengerHuntCode: "",
      ScavengerHuntName: "",
      ScavengerHuntNameDefault: "Scavenger Hunt",
      ScavengerHuntMessage: "",
      ScavengerHuntMessageDefault: "You have revealed the secret code",
      ScavengerHuntScore: 0,
      ScavengerHuntMaxScore: 0,

      percentage: 0,
      hide: {
        type: "pattern",
        src: paperPattern,
        repeat: "repeat",
      },
      brush: {
        size: 100,
        shape: "round",
      },
      getPercentageCleared: true,
      RestrictedZoomMeetingEnabled: true,
      tempTable: null,
      tempMeeting: null,
      retryType: "",
      email: "",
      name: "",
      firstName: "",
      lastName: "",
      phone: "",
      company: "",
      title: "",
      mobileView: false,
      screenWidth: 0,

      showVideoFlg: false,
      businessCardSending: false,
      windowHeight: window.innerHeight,
      protectNav: false,
      nav: "",
      registering: false,
      scavengerHuntShowMe: false,
      scavengerHuntRandomBoothEnabled: false,
      scavengerHuntMinBooths: 0,
      scavengerHuntMaxBooths: 0,
      scavengerHuntBooths: [],
      scavengerHuntBoothsForMe: [],
      scavengerHuntRight: false,
      todaysDate: "",
    };
  },
  computed: {
    MeetingSettings() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return {
        Slot: obj.MeetingSettings[0].Slot,
        StartDate: obj.MeetingSettings[0].StartDate,
        EndDate: obj.MeetingSettings[0].EndDate,
        AvailabilityFromTime: obj.MeetingSettings[0].AvailabilityFromTime,
        AvailabilityToTime: obj.MeetingSettings[0].AvailabilityToTime,
      };
    },
    BoothName() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.selExhibitorID;
    },
    subline() {
      return this.percentage < 100
        ? `🎉 There is still ${
            100 - this.percentage
          }% left for me to be free... 🎉`
        : "💚 Thank you for scratching me free! 💚";
    },
  },
  watch: {
    openVideoModal() {
      if (this.openVideoModal) {
        if (this.showcaseVideoUrl) {
          this.showcaseVideoUrl =
            this.showcaseVideoUrl.split("?")[0] + "?autoplay=1";
          document.getElementById("expo-video-tile").click();
        }
      } else {
        if (this.showcaseVideoUrl) {
          this.showcaseVideoUrl =
            this.showcaseVideoUrl.split("?")[0] + "?autoplay=0";
        }
      }
      if (
        this.$store.getters.getVideoPlaySettings == "1 time play" &&
        this.openVideoModal == true
      ) {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));

        var cookieName = vm.event_collectionName + "_" + "videoPlaySettings";
        var cookieData = this.getCookie(cookieName);

        if (cookieData != "" && cookieData.includes(obj.selExhibitorID)) {
          var replaceYoutube = this.showcaseVideoUrl
            ? this.showcaseVideoUrl.replace(/autoplay=1/g, "autoplay=0")
            : "";
          this.showcaseVideoUrl = replaceYoutube;
        } else {
          this.showcaseVideoUrl = this.showcaseVideoUrl
            ? this.showcaseVideoUrl.split("?")[0] + "?autoplay=1"
            : "";
          cookieData = cookieData + " [" + obj.selExhibitorID + "]";
          var value = cookieName + `=${cookieData} ;path=/`;
          document.cookie = value;
        }
      }
    },
    screenWidth(val) {
      if (val > 768) {
        vm.mobileView = false;
      } else {
        vm.mobileView = true;
      }
    },
    boothSettingsLoaded() {
      if (vm.boothDetailsLoaded) {
        vm.SetBoothBackgroundImage();
      }
    },
    boothDetailsLoaded() {
      if (vm.boothSettingsLoaded) {
        vm.SetBoothBackgroundImage();
      }
    },
  },
  created() {
    vm = this;
    if (vm.$route.params.nav) {
      vm.nav = vm.$route.params.nav;
      vm.protectNav = true;
    }
    vm.screenWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      vm.screenWidth = window.innerWidth;
    });
    vm.uid = vm.getSessionUserId();
    vm.visitor = vm.isVisitor();
    vm.event_collectionName = vm.getEventCollectionName();
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (obj) {
      if (obj.user && obj.user.length > 0) {
        vm.name = obj.user[0].name;
        vm.email = obj.user[0].Email;
        vm.Email = obj.user[0].Email;
        vm.firstName = obj.user[0].fname;
        vm.lastName = obj.user[0].lname;
        vm.phone = obj.user[0].phone;
        vm.company = obj.user[0].company;
        vm.title = obj.user[0].title;
      }
    }
    db.collection(vm.event_collectionName)
      .doc("AttendeeList")
      .collection("Attendees")
      .doc(vm.uid)
      .get()
      .then((attendeeDoc) => {
        if (attendeeDoc.exists) {
          var attendee = attendeeDoc.data();
          var registrationType = "";
          if (typeof attendee.RegistrationType == "string") {
            registrationType = attendee.RegistrationType;
          } else if (typeof attendee.RegistrationType == "object") {
            registrationType = attendee.RegistrationType.RegistrationType;
          }
          db.collection(vm.event_collectionName)
            .doc("AttendeeList")
            .collection("AttendeeSettings")
            .doc("FilterSettings")
            .get()
            .then((doc) => {
              if (doc.exists) {
                var data = doc.data();
                if (data.MeetingRestrictionEnabled) {
                  if (
                    data.AllowExMtngRqstForRegTypes &&
                    data.AllowExMtngRqstForRegTypes.length > 0 &&
                    !data.AllowExMtngRqstForRegTypes.includes(registrationType)
                  ) {
                    vm.allowRequestMeeting = false;
                  }
                  if (
                    vm.allowRequestMeeting &&
                    data.ExcludeGroupToRequestMeeting
                  ) {
                    vm.restrictedAttendeeIDs = [];
                    debugger;
                    let headers = {
                      "content-type": "application/json",
                      Authorization: "Bearer " + vm.getSessionToken(),
                    };
                    let requestData = {
                      key: {
                        instanceId: "OA_UAT",
                        clientId: vm.$store.state.client[0].id,
                        eventId: vm.$store.state.eventid,
                      },
                      data: {
                        groups: [
                          {
                            GroupId: data.ExcludeGroupToRequestMeeting,
                          },
                        ],
                      },
                    };
                    axios
                      .post(APIs.GetAttendees, requestData, {
                        headers: headers,
                      })
                      .then((responseData) => {
                        if (
                          responseData &&
                          responseData.data &&
                          responseData.data.status == 0 &&
                          responseData.data.groups
                        ) {
                          responseData.data.groups.forEach(function (group) {
                            if (group.attendees) {
                              group.attendees.forEach(function (item) {
                                if (item.AttendeeId == vm.uid) {
                                  vm.allowRequestMeeting = false;
                                }
                              });
                            }
                          });
                        } else {
                          console.log("Unable to fetch group attendees");
                        }
                      })
                      .catch((error) => {
                        //alert(error);
                        console.log(error);
                      });
                  }
                }
              }
            });
        }
      });
  },
  beforeDestroy() {
    clearInterval(interval);
    vm.removeSelection();
    vm.disposeRoundTableListener();
    vm.disposeContactListener();
  },
  destroyed() {
    window.removeEventListener("keydown", vm.onKeyboardArrowPress);
  },
  mounted() {
    vm.todaysDate = new Date().toISOString().slice(0, 10).replace(/-/g, "");
    // vm.scavengerHuntRandomPosition();
    if (
      vm.$store.state.totalExpoBoothCount == 0 ||
      vm.Exhibitorlist.length == 0
    ) {
      $("#sphallName").text("Exhibitors");
      vm.getExhibitors();
    }
    if (screen.width >= 768 && screen.width <= 1024) {
      common.checkAppDownloadScreenByDevice("ipad");
    } else if (screen.width < 767) {
      common.checkAppDownloadScreenByDevice("mobile");
    }
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (obj) {
      vm.clientId = obj.client[0].id;
      vm.eventId = obj.eventid;
    }
    vm.checkSettingFlagValue();
    $("#btnAddUserView").click();
    common.toggleTopMenu(true);
    common.toggleLeftMenu(true);
    //$("#topmenu").show();
    //$("#leftmenu").show();
    vm.getSettings();
    // if ($("#ulLeftMenu li").length > 0) {
    //   $("#leftMenuParent").show();
    //   $("#leftmenu").show();
    // } else {
    //   $("#leftMenuParent").hide();
    //   $("#leftmenu").hide();
    // }

    //var obj = JSON.parse(window.localStorage.getItem("my-app"));
    db.collection(vm.event_collectionName)
      .doc("Menu")
      .get()
      .then((doc) => {
        var data = doc.data();
        $.each(data.LeftMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "Exhibitors") {
              //vm.headerText = value.DisplayLabel;
              var headText = "";
              if (vm.$store.state.locale == "English") {
                headText = value.DisplayLabel;
              } else if (vm.$store.state.locale == "German") {
                headText = value.DisplayLabel_de;
              } else if (vm.$store.state.locale == "French") {
                headText = value.DisplayLabel_fr;
              } else if (vm.$store.state.locale == "Chinese") {
                headText = value.DisplayLabel_zh;
              } else if (self.$store.state.locale == "Spanish") {
                headText = value.DisplayLabel_es;
              } else {
                headText = value.DisplayLabel;
              }
              if ($("#sphallName")) {
                $("#sphallName").text(headText);
              }
              if ($("#boothHeaderTxt")) {
                $("#boothHeaderTxt").text(headText);
              }
            }
            if (value.MenuID == 1022) {
              vm.LiveStageURL = value.PageUrl ? value.PageUrl : "/livestage";
            }
          }
        });
        $.each(data.AllMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "Exhibitors") {
              //vm.headerText = value.DisplayLabel;
              var headText = "";
              if (vm.$store.state.locale == "English") {
                headText = value.DisplayLabel;
              } else if (vm.$store.state.locale == "German") {
                headText = value.DisplayLabel_de;
              } else if (vm.$store.state.locale == "French") {
                headText = value.DisplayLabel_fr;
              } else if (vm.$store.state.locale == "Chinese") {
                headText = value.DisplayLabel_zh;
              } else if (self.$store.state.locale == "Spanish") {
                headText = value.DisplayLabel_es;
              } else {
                headText = value.DisplayLabel;
              }
              if ($("#sphallName")) {
                $("#sphallName").text(headText);
              }
              if ($("#boothHeaderTxt")) {
                $("#boothHeaderTxt").text(headText);
              }
            }
            if (value.MenuID == 1022) {
              vm.LiveStageURL = value.PageUrl ? value.PageUrl : "/livestage";
            }
          }
        });
      });
    if ($("#sphallName")) {
      $("#sphallName").text("Exhibitors");
    }
    if ($("#boothHeaderTxt")) {
      $("#boothHeaderTxt").text("Exhibitors");
    }
    document.title = vm.headerText + " - " + obj.eventname;

    //var newLine = "\r\n";
    //var newLine = "";
    var defaultMsg = vm.$t("expoview.exchangetxtmsg");
    // "Hello," +
    // newLine +
    // newLine +
    //"I dropped by your booth, please contact me.";
    // newLine +
    // newLine +
    // "Thanks";

    $("#txtMsgArea").val(defaultMsg);

    //var obj = JSON.parse(window.localStorage.getItem("my-app"));

    //-------Page Title-------------
    //-------Page Title-------------

    //---------------------------------------------------
    //-------------------FAVICONJOB------------------------------------------------------------

    if (obj.branding[0].favicon != undefined) {
      if (obj.branding[0].favicon != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    }
    //----------------------------------------------------------------------------------

    if (this.$route.params.sid != null) {
      vm.exid = this.$route.params.sid;
      store.commit("addExhibitorID", this.$route.params.sid);
    } else {
      vm.exid = obj.selExhibitorID;
      store.commit("addExhibitorID", vm.exid);
    }

    console.log("currentExhiid" + vm.exid);
    vm.setFirebaseAppsettings();
    vm.showLoader();
    // if (obj.selExhibitorID !== undefined) {
    //   if (obj.selExhibitorID !== "") {
    //     store.commit("addExhibitorID", vm.exid);
    //   } else {
    //     router.push({ name: "ExhibitorsHall" });
    //   }
    // } else {
    //   router.push({ name: "ExhibitorsHall" });
    // }
    this.getExhibitorDetails();
    vm.hideLoader();
    this.getPrv(vm.exid);
    this.getNxt(vm.exid);
    $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);

    //this.loadscripts();

    //interval = setInterval(() => {
    if (
      document.getElementById("dvVideo") &&
      document.getElementById("dvVideo").style.display == "block"
    ) {
      console.log("open video");
    } else {
      if (this.showcaseVideoUrl.includes("autoplay=1")) {
        this.showcaseVideoUrl = this.showcaseVideoUrl
          ? this.showcaseVideoUrl + "?autoplay=0"
          : "";
      }
    }

    //vm.getSettings();
    //}, 1000);

    // clearInterval(interval);
    setTimeout(() => {
      $('[data-toggle="tooltip"]').tooltip();
    }, 1000);
    setTimeout(() => {
      $('[data-toggle="tooltip1"]').tooltip();
    }, 1000);
    setTimeout(() => {
      $('[data-toggle="tooltip2"]').tooltip();
    }, 1000);
    window.addEventListener("keydown", vm.onKeyboardArrowPress);
  },
  methods: {
    getHtmlCodeWithImage(item) {
      if (!item.HtmlCode) return "";
      // Insert the image inside the anchor with title="Company Profile"
      return item.HtmlCode.replace(
        /(<a[^>]*title="Company Profile"[^>]*>)(<\/a>)/,
        `$1<img src="${item.Image}" style="width:100%;height:100%;object-fit:contain;" />$2`
      );
    },
    scavengerHuntRandomPosition() {
      var rnd = parseInt(new Date().getTime() / 1000);
      if (rnd % 2 == 0) {
        vm.scavengerHuntRight = false;
      } else {
        vm.scavengerHuntRight = true;
      }
      vm.CheckScavengerHuntForMe();
    },
    CheckScavengerHuntForMe() {
      vm.scavengerHuntShowMe = false;
      // Implement booth checking logic here
      // scavengerHuntShowMe: false,
      // scavengerHuntRandomBoothEnabled: false,
      // scavengerHuntMinBooths: 0,
      // scavengerHuntMaxBooths: 0,
      // scavengerHuntBooths: [],
      // scavengerHuntBoothsForMe: [],
      // scavengerHuntRight: false,
      if (vm.scavengerHuntRandomBoothEnabled) {
        var cookieData = this.getCookie(
          "scavengerHuntBoothsForMe" + vm.todaysDate
        );
        if (cookieData) {
          vm.scavengerHuntBoothsForMe = JSON.parse(cookieData);
        }
        console.log(
          "cookieData scavengerHuntBoothsForMe",
          vm.scavengerHuntBoothsForMe
        );
        if (
          vm.scavengerHuntBoothsForMe.length == 0 &&
          vm.scavengerHuntBooths.length > 0
        ) {
          console.log(
            "--------------------------------------------------------------------------"
          );
          var myHuntsCount = vm.getRandomBetween(
            vm.scavengerHuntMinBooths,
            vm.scavengerHuntMaxBooths
          );
          var myHuntsBoothIndexes = vm.getUniqueRandomNumbers(
            myHuntsCount,
            vm.scavengerHuntBooths.length
          );

          vm.scavengerHuntBoothsForMe = myHuntsBoothIndexes.map(
            (index) => vm.scavengerHuntBooths[index - 1]
          );
          console.log("scavengerHuntBoothsForMe", vm.scavengerHuntBoothsForMe);
          document.cookie =
            "scavengerHuntBoothsForMe" +
            vm.todaysDate +
            "=" +
            JSON.stringify(vm.scavengerHuntBoothsForMe);
        }
        if (vm.scavengerHuntBoothsForMe.includes(vm.exid)) {
          vm.scavengerHuntShowMe = true;
        }
      } else {
        vm.scavengerHuntShowMe = true;
      }
    },
    getRandomBetween(x, y) {
      return Math.floor(Math.random() * (y - x + 1)) + x;
    },
    getUniqueRandomNumbers(n, x) {
      if (n > x) n = x;
      var numbers = Array.from({ length: x }, (_, i) => i + 1);
      console.log("numbers>>", numbers);
      // Fisher–Yates shuffle
      for (let i = numbers.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [numbers[i], numbers[j]] = [numbers[j], numbers[i]];
      }
      console.log("numbers>>", numbers);
      numbers = numbers.slice(0, n);
      console.log("numbers>>", numbers);
      return numbers;
    },
    editBooth() {
      router.push("/expo-studio/" + vm.exid);
      bus.$emit("toggleLoader", true);
    },
    downloadAnalytics() {
      bus.$emit("toggleLoader", true);
      let headers = {
        Authorization: "Bearer " + vm.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        eventId: this.$store.state.eventid,
        clientId: this.$store.state.client[0].id,
        instanceId: "OA_UAT",
        exhibitorId: vm.exid,
        numDays: 365,
      };

      axios
        .post(APIs.GetBoothStats, requestData, { headers: headers })
        .then((row) => {
          bus.$emit("toggleLoader", false);
          console.log("row>>>>>", row);

          if (row && row.data) {
            var datarow = [];
            /*datarow.push("Booth Name");
            datarow.push("Data Exported in");
            datarow.push("Total Booth Views");
            datarow.push("Total Resource Views");
            datarow.push("Total Video Views");
            datarow.push("Total Business Card Exchanges");
            datarow.push("Total Profile Views");
            datarow.push("Total Roundtable Visits");
            datarow.push("Total Chat Messages");
            datarow.push("Total Rep Video Calls");*/
            var AttendeeData = [];
            //AttendeeData.push(datarow);
            //datarow = [];
            datarow.push("Booth Name");
            datarow.push('"' + vm.expoNameForExport + '"');
            AttendeeData.push(datarow);
            datarow = [];
            datarow.push("Data Exported in");
            datarow.push(
              '"' +
                moment()
                  .tz(store.getters.getZone)
                  .format("MMM DD, YYYY HH:mm A") +
                ` (${store.getters.getZone})` +
                '"'
            );
            AttendeeData.push(datarow);
            datarow = [];
            datarow.push("Total Booth Views");
            datarow.push(
              '"' + row.data.totBoothViews ? row.data.totBoothViews : 0 + '"'
            );
            AttendeeData.push(datarow);
            datarow = [];
            datarow.push("Total Resource Views");
            datarow.push(
              '"' + row.data.totResourceViews
                ? row.data.totResourceViews
                : 0 + '"'
            );
            AttendeeData.push(datarow);
            datarow = [];
            datarow.push("Total Video Views");
            datarow.push(
              '"' + row.data.totVideoViews ? row.data.totVideoViews : 0 + '"'
            );
            AttendeeData.push(datarow);
            datarow = [];
            datarow.push("Total Business Card Exchanges");
            datarow.push(
              '"' + row.data.totBusinessCardExcahnges
                ? row.data.totBusinessCardExcahnges
                : 0 + '"'
            );
            AttendeeData.push(datarow);
            datarow = [];
            datarow.push("Total Profile Views");
            datarow.push(
              '"' + row.data.totProfileViews
                ? row.data.totProfileViews
                : 0 + '"'
            );
            AttendeeData.push(datarow);
            datarow = [];
            datarow.push("Total Roundtable Visits");
            datarow.push(
              '"' + row.data.totRoundtableVisits
                ? row.data.totRoundtableVisits
                : 0 + '"'
            );
            AttendeeData.push(datarow);
            datarow = [];
            datarow.push("Total Chat Messages");
            datarow.push(
              '"' + row.data.totChatMessages
                ? row.data.totChatMessages
                : 0 + '"'
            );
            AttendeeData.push(datarow);
            datarow = [];
            datarow.push("Total Rep Video Calls");
            datarow.push(
              '"' + row.data.totRepVideoCalls
                ? row.data.totRepVideoCalls
                : 0 + '"'
            );
            AttendeeData.push(datarow);

            if (
              row.data.resourceDownloads &&
              row.data.resourceDownloads.length
            ) {
              AttendeeData.push([]);
              datarow = [];
              datarow.push("Resource Name");
              datarow.push("No of views");
              AttendeeData.push(datarow);

              row.data.resourceDownloads.filter((u) => {
                datarow = [];
                datarow.push('"' + u.resourceName + '"');
                datarow.push('"' + u.downloadCount ? u.downloadCount : 0 + '"');
                AttendeeData.push(datarow);
              });
            }

            if (row.data.userList && row.data.userList.length) {
              AttendeeData.push([]);
              datarow = [];
              datarow.push("First Name");
              datarow.push("Last Name");
              datarow.push("Email");
              datarow.push("Registration Type");
              datarow.push("Company Name");
              datarow.push("Job Title");
              datarow.push("City");
              datarow.push("State");
              datarow.push("ZIP Code");
              datarow.push("Country Code");
              datarow.push("Phone Number");
              datarow.push("Original Registration Date");
              datarow.push("Date of First Login");
              datarow.push("Date of Last Login");
              datarow.push("Business Card Exchanges");
              datarow.push("Total Rep Video Calls");
              datarow.push("Total Company Profile Views");
              datarow.push("Total Video Views");
              datarow.push("Total Resource Downloads");
              datarow.push("Chat Room Messages");
              datarow.push("Total Roundtable Visits");
              AttendeeData.push(datarow);

              row.data.userList.filter((u) => {
                datarow = [];
                datarow.push('"' + u.firstName + '"');
                datarow.push('"' + u.lasttName + '"');
                datarow.push('"' + u.email + '"');
                datarow.push(
                  '"' + u.registrationType ? u.registrationType : "NA" + '"'
                );
                datarow.push('"' + u.company + '"');
                datarow.push('"' + u.jobTitle + '"');
                datarow.push('"' + u.city + '"');
                datarow.push('"' + u.state + '"');
                datarow.push('"' + u.zip + '"');
                datarow.push('"' + u.countryCode ? u.countryCode : "NA" + '"');
                datarow.push('"' + u.phone + '"');
                datarow.push(
                  '"' +
                    moment
                      .utc(u.regisreredOnUTC)
                      .tz(store.getters.getZone)
                      .format("MMM DD, YYYY HH:mm A") +
                    '"'
                );
                datarow.push(
                  '"' +
                    moment
                      .utc(u.firstLoginDtmUTC)
                      .tz(store.getters.getZone)
                      .format("MMM DD, YYYY HH:mm A") +
                    '"'
                );
                datarow.push(
                  '"' +
                    moment
                      .utc(u.lastLoginDtmUTC)
                      .tz(store.getters.getZone)
                      .format("MMM DD, YYYY HH:mm A") +
                    '"'
                );
                datarow.push(
                  '"' + u.hasExchangedBusinessCard
                    ? u.hasExchangedBusinessCard
                    : 0 + '"'
                );
                datarow.push(
                  '"' + u.totRepVideoCalls ? u.totRepVideoCalls : 0 + '"'
                );
                datarow.push(
                  '"' + u.totProfileViews ? u.totProfileViews : 0 + '"'
                );
                datarow.push('"' + u.totVideoViews ? u.totVideoViews : 0 + '"');
                datarow.push(
                  '"' + u.totResourceViews ? u.totResourceViews : 0 + '"'
                );
                datarow.push(
                  '"' + u.totChatMessages ? u.totChatMessages : 0 + '"'
                );
                datarow.push(
                  '"' + u.totRoundtableVisits ? u.totRoundtableVisits : 0 + '"'
                );
                AttendeeData.push(datarow);
              });
            }

            let csvContent = "data:text/csv;charset=utf-8,";
            var dt = new Date().toISOString().slice(0, 10);
            AttendeeData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            var filename =
              vm.expoNameForExport + "_boothStatsExport_" + "_" + dt + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            //link.setAttribute("id", "Participance_RT_" + row.TableId);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
            //---------------------------------------------------------------
          } else {
            vm.showSnackbar("No data available for export", "warning", "top");
          }
        })
        .catch((error) => {
          bus.$emit("toggleLoader", false);
          console.log("error===========", error);
        });
    },

    getBookmark(id, currentExpo) {
      var exhibitors = vm.ExhibitorData.filter(function (item) {
        return item.id == id;
      });
      if (exhibitors.length > 0) {
        if (exhibitors[0].isBookmarked == undefined) {
          exhibitors[0].isBookmarkLoading = true;
        } else {
          return;
        }
      } else {
        return;
      }
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityType: 4,
          entityName: currentExpo.Name,
          entityImage: currentExpo.Image ? currentExpo.Image : "",
          entityId: id,
        },
      };
      try {
        axios({
          method: "post",
          url: vm.APIs.BookmarkAPIConfig.Get,
          data: rqstData,
        })
          .then((bookmarkExists) => {
            if (bookmarkExists.data && bookmarkExists.data.isPublished) {
              exhibitors[0].isBookmarked = true;
            } else {
              exhibitors[0].isBookmarked = false;
            }
            exhibitors[0].isBookmarkLoading = false;

            vm.ExhibitorData = vm.ExhibitorData.filter(function () {
              return true;
            });
          })
          .catch(() => {
            exhibitors[0].isBookmarkLoading = false;
          });
        //vm.ExhibitorData = vm.ExhibitorData.filter(function () {
        //  return true;
        //});
      } catch (e) {
        console.log(e);
        exhibitors[0].isBookmarkLoading = false;
        //vm.ExhibitorData = vm.ExhibitorData.filter(function () {
        //  return true;
        //});
      }
    },
    addBookMark(entityId, entityName, entityImage) {
      if (vm.visitor) {
        //common.openRegistrationDialog();
        vm.goToRegistration();
        return;
      }
      var exhibitors = vm.ExhibitorData.filter(function (item) {
        return item.id == entityId;
      });
      if (exhibitors.length > 0) {
        exhibitors[0].isBookmarkLoading = true;
        vm.ExhibitorData = vm.ExhibitorData.filter(function () {
          return true;
        });
      } else {
        return;
      }
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityType: 4,
          entityName: entityName,
          entityImage: entityImage,
          entityId: entityId,
          entityLink: this.$route.path,
        },
      };
      if (exhibitors[0].isBookmarked) {
        axios({
          method: "post",
          url: vm.APIs.BookmarkAPIConfig.Delete,
          data: rqstData,
        })
          .then(() => {
            exhibitors[0].isBookmarked = false;
            exhibitors[0].isBookmarkLoading = false;
            vm.ExhibitorData = vm.ExhibitorData.filter(function () {
              return true;
            });
          })
          .catch(() => {
            exhibitors[0].isBookmarkLoading = false;
          });
      } else {
        axios({
          method: "post",
          url: vm.APIs.BookmarkAPIConfig.Create,
          data: rqstData,
        })
          .then(() => {
            exhibitors[0].isBookmarked = true;
            exhibitors[0].isBookmarkLoading = false;
            vm.ExhibitorData = vm.ExhibitorData.filter(function () {
              return true;
            });
          })
          .catch(() => {
            exhibitors[0].isBookmarkLoading = false;
          });
      }
    },
    playVideoURL() {
      this.showVideoFlg = true;
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = document.cookie;
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    getBGImage() {
      return {
        backgroundImage: `url("${vm.expoHallTypeBackgroundImage}")`,
      };
    },
    SetBoothBackgroundImage() {
      if (vm.boothSettingsLoaded && vm.boothDetailsLoaded) {
        var result = vm.boothDefaultBackgroundImage;
        if (vm.expoHallTypeBackgroundImage) {
          result = vm.expoHallTypeBackgroundImage;
        } else if (vm.ExpoHallBackgroundImage) {
          result = vm.ExpoHallBackgroundImage;
        }
        if (result) {
          document.getElementById("divTop").style.backgroundImage =
            "url('" + result + "')";
        }
      }
    },
    disposeRoundTableListener() {
      vm.allRoundTables.map(function (item) {
        if (item.listener) {
          item.listener();
        }
        item.listener = null;
      });
    },
    disposeContactListener() {
      if (vm.ExhibitorData.length > 0) {
        if (
          vm.ExhibitorData[0].MappedContacts &&
          vm.ExhibitorData[0].MappedContacts.length > 0
        ) {
          vm.ExhibitorData[0].MappedContacts.map(function (item) {
            if (item.listener) {
              item.listener();
            }
            item.listener = null;
          });
        }
      }
    },
    registerAttendee() {
      if (vm.visitor) {
        //common.openRegistrationDialog();
        vm.goToRegistration();
        return;
      }
    },
    resetScavengerHuntDialog() {
      vm.percentage = 0;
      //setTimeout(() => {
      //  debugger;
      //  var canvasList = document.getElementsByTagName("canvas");
      //  if (canvasList.length > 0) {
      //    var canvas = canvasList[0];
      //    if (canvas.getContext) {
      //      var ctx = canvas.getContext("2d");
      //      ctx.font = "italic 32px sans-serif";
      //      ctx.fillText("HTML5 Canvas Tutorial", 10, 50);
      //    }
      //  }
      //}, 5000);
    },
    updatePoints(percentage) {
      //alert(percentage);
      this.percentage = percentage;
      if (this.percentage > 80) {
        this.percentage = 100;
      }
      if (this.percentage == 100) {
        this.blastConfetti = true;
        this.hideScrachScreen();
      }
    },
    hideScrachScreen() {
      vm.blastConfetti = true;
      //vm.ScavengerHuntGamePlayed = true;
      setTimeout(() => {
        vm.scrachScreen = false;
      }, 3000);
      setTimeout(() => {
        vm.blastConfetti = false;
      }, 3800);
      if (vm.ScavengerHuntDocId) {
        vm.collectLeaderboardPoint(vm.ScavengerHuntDocId, vm.exid);
        setTimeout(() => {
          vm.checkScavengerHuntDetails(vm.exid);
        }, 5000);
      }
      vm.scavengerHuntDialogKey++;
    },
    checkScavengerHuntDetails(exhibitorId) {
      vm.scavengerHuntRandomPosition();
      vm.scavengerHuntDialogKey++;
      vm.percentage = 0;
      vm.scrachScreen = false;
      vm.blastConfetti = false;
      vm.ScavengerHuntGameLoaded = false;
      vm.scavengerHuntDialog = false;
      vm.ScavengerHuntEnabled = false;
      vm.ScavengerHuntGamePlayed = false;
      vm.scrachScreen = true;
      if (exhibitorId) {
        db.collection(vm.event_collectionName)
          .doc("ExhibitorList")
          .collection("Exhibitors")
          .doc(exhibitorId)
          .collection("ScavengerHunt")
          .get()
          .then((querySnapshot) => {
            var docId = "";
            if (querySnapshot.docs.length > 0) {
              docId = querySnapshot.docs[0].id;
              var data = querySnapshot.docs[0].data();
              vm.ScavengerHuntDocId = docId;
              vm.ScavengerHuntCode = data.Code;
              vm.ScavengerHuntName = data.Name;
              if (data.Message) {
                vm.ScavengerHuntMessage = data.Message;
              }
              vm.ScavengerHuntScore = data.Score;
              vm.ScavengerHuntMaxScore = data.MaxScore;
            }
            if (docId) {
              //vm.ScavengerHuntEnabled = true;
              db.collection(vm.event_collectionName)
                .doc("Leaderboard")
                .collection("ScavengerHunt")
                .doc(docId)
                .get()
                .then((doc) => {
                  if (doc.exists) {
                    var data = doc.data();
                    if (data.IsPublished) {
                      vm.ScavengerHuntEnabled = true;
                      if (vm.ScavengerHuntScore == 0) {
                        vm.ScavengerHuntScore = data.Score;
                      }
                      if (vm.ScavengerHuntName == "") {
                        vm.ScavengerHuntScore = data.Name;
                      }
                      if (vm.ScavengerHuntName == "") {
                        vm.ScavengerHuntName = vm.ScavengerHuntNameDefault;
                      }
                      if (vm.ScavengerHuntMessage == "" && data.Message) {
                        vm.ScavengerHuntMessage = data.Message;
                      }
                      if (vm.ScavengerHuntMessage == "") {
                        vm.ScavengerHuntMessage =
                          vm.ScavengerHuntMessageDefault;
                      }
                      if (vm.ScavengerHuntMaxScore == 0) {
                        vm.ScavengerHuntMaxScore = data.MaxScore;
                      }

                      //debugger
                      var instanceId = "OA_UAT";
                      var clientId = "";
                      var client = store.getters.getClient;
                      if (client) {
                        clientId = client[0].id;
                      }
                      var eventId = store.getters.getEvent;
                      var token = store.getters.getToken;
                      let headers = {
                        "content-type": "application/json",
                        Authorization: "Bearer " + token,
                      };
                      let requestData = {
                        key: {
                          clientId: clientId,
                          eventId: eventId,
                          instanceId: instanceId,
                        },
                        data: {
                          userId: vm.uid,
                          scavengeDocId: vm.exid,
                          actionTypeCode: vm.ScavengerHuntDocId,
                        },
                      };
                      axios
                        .post(APIs.GetScavengeScore, requestData, {
                          headers: headers,
                        })
                        .then(async (responseData) => {
                          debugger;
                          vm.ScavengerHuntGameLoaded = true;
                          //console.log(">>>>>>>" + responseData)
                          //alert("PostLeaderboardAction Success");
                          if (responseData && responseData.data) {
                            if (responseData.data.status == 0) {
                              vm.ScavengerHuntGamePlayed = false;
                            } else {
                              if (
                                responseData.data.uscavenge &&
                                responseData.data.uscavenge.score == 0
                              ) {
                                vm.ScavengerHuntGamePlayed = false;
                                vm.ScavengerHuntEnabled = false;
                              } else {
                                vm.ScavengerHuntEnabled = true;
                                vm.ScavengerHuntGamePlayed = true;
                                //vm.ScavengerHuntGamePlayed = false;
                              }
                            }
                          }
                        })
                        .catch(function (error) {
                          vm.ScavengerHuntGameLoaded = true;
                          //alert("PostLeaderboardAction Failed");
                          console.log(
                            "Error on getLeaderboardActions: " + error
                          );
                          //reject({
                          //    Message: error,
                          //    StatusCode: 0,
                          //    status: 0,
                          //});
                        });
                      //db.collection(vm.event_collectionName)
                      //  .doc("AttendeeList")
                      //  .collection("Attendees")
                      //  .doc(vm.uid)
                      //  .get()
                      //  .then((doc) => {
                      //    if (doc.exists) {
                      //      var data = doc.data();
                      //      if (
                      //        data.Leaderboard &&
                      //        data.Leaderboard.Achievements &&
                      //        data.Leaderboard.Achievements.Activities &&
                      //        data.Leaderboard.Achievements.Activities[
                      //          vm.ScavengerHuntDocId
                      //        ]
                      //      ) {
                      //        if (
                      //          vm.ScavengerHuntMaxScore >
                      //          data.Leaderboard.Achievements.Activities[
                      //            vm.ScavengerHuntDocId
                      //          ]
                      //        ) {
                      //          vm.ScavengerHuntGamePlayed = false;
                      //        } else {
                      //          //vm.ScavengerHuntGamePlayed = true;
                      //        }
                      //      } else {
                      //        vm.ScavengerHuntGamePlayed = false;
                      //      }
                      //    }
                      //  })
                      //  .catch((error) => {
                      //    console.log(error);
                      //  });
                    }
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          });
      }
    },
    joinExpoBoothSepcificChat(roomId) {
      if (vm.visitor) {
        //common.openRegistrationDialog();
        vm.goToRegistration();
        return;
      }
      if (roomId) {
        bus.$emit("toggleLoader", true);
        bus.$emit("openExpoChat", roomId);
      }
    },
    getExhibitors: function () {
      vm.Exhibitorlist = [];
      var docRef;
      docRef = db
        .collection(vm.event_collectionName)
        .doc("ExhibitorList")
        .collection("Exhibitors")
        .where("IsPublished", "==", true);
      docRef
        .get()
        .then((querySnapshot) => {
          var ctr = 0;
          var exhibitorIds1 = "";
          querySnapshot.forEach((doc) => {
            var webSite = "";
            if (doc.data().Website !== "") {
              if (doc.data().Website.indexOf("http") < 0) {
                webSite = "http://" + doc.data().Website;
              } else {
                webSite = doc.data().Website;
              }
            }
            var socLinks = doc.data().SocialLinks;
            vm.loopArray(socLinks);
            socLinks = vm.sortedSocialLinks;
            vm.roomId = doc.data().mappedchatgroup
              ? doc.data().mappedchatgroup.id
              : null;
            vm.MappedGroup = doc.data().mappedchatgroup;
            vm.Exhibitorlist.push({
              sino: ctr++,
              id: doc.id,
              Name: doc.data().Name,
              Logo: vm.getCDNUrl(doc.data().Logo),
              Email: doc.data().Email,
              Category: doc.data().Category,
              Type: doc.data().Type,
              BoothNo: doc.data().BoothNo,
              HotspotImageUrL: vm.getCDNUrl(doc.data().HotspotImageURL),
              Website: webSite,
              Profile:
                doc
                  .data()
                  .Profile.replace(/<[^>]*>/g, "\n\r")
                  .substring(0, 300) + "...",
              Phone: doc.data().Phone,
              Image: vm.getCDNUrl(doc.data().Logo),
              SocialLinks: socLinks,
              MappedContacts: doc.data().MappedContacts,
              contactcount: doc.data().MappedContacts.length,
              Files: doc.data().Resources,
              fileLength: doc.data().Resources.length,
              ShowcaseVideoURL: doc.data().ShowcaseVideoURL,
              MappedGroup: doc.data().mappedchatgroup,
              isTooltipVisible: false,
              FullProfile:
                doc
                  .data()
                  .Profile.replace(/<[^>]*>/g, "\n\r")
                  .substring(0, 500) + "...",
            });

            exhibitorIds1 += doc.id + ",";
          });

          var totalCount = vm.Exhibitorlist.length;
          store.commit("addExpoBoothCount", totalCount);
          if (exhibitorIds1 != "") {
            exhibitorIds1 = exhibitorIds1.substring(
              0,
              exhibitorIds1.length - 1
            );
          }
          store.commit("addExbList", exhibitorIds1);

          vm.getPrv(vm.exid);
          vm.getNxt(vm.exid);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onKeyboardArrowPress(event) {
      //event.preventDefault();
      const key = event.key;
      switch (key) {
        case "ArrowLeft":
          // Left pressed
          vm.LoadNext(vm.prv);
          break;
        case "ArrowRight":
          vm.LoadNext(vm.nxt);
          break;
      }
    },
    JoinRepVideoCall(ExhibitorId, chatToId, StreamingClient, Zoom_Detail) {
      $(".tooltip").tooltip("hide");
      if (vm.visitor) {
        //common.openRegistrationDialog();
        vm.goToRegistration();
        return;
      }
      vm.retryType = "e2o";
      vm.tempMeeting = {
        ExhibitorId: ExhibitorId,
        chatToId: chatToId,
        StreamingClient: StreamingClient,
        Zoom_Detail: Zoom_Detail,
      };

      let streamClien = StreamingClient;
      if (streamClien) {
        streamClien = streamClien.trim().toLowerCase();
      }
      if (
        streamClien == "zoom" &&
        Zoom_Detail &&
        Zoom_Detail.id &&
        Zoom_Detail.join_url
      ) {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        var attendeeId = obj.user[0].id;
        var first_name = obj.user[0].fname;
        var last_name = obj.user[0].lname;

        if (Zoom_Detail && Zoom_Detail.id && Zoom_Detail.join_url) {
          if (attendeeId == chatToId) {
            var hlink =
              Zoom_Detail.start_url +
              "&uname=" +
              first_name.trim() +
              "%20" +
              last_name.trim();
            window.open(hlink, "_blank");
            vm.postLeaderboardAction("EBRV");
          } else {
            if (!vm.RestrictedZoomMeetingEnabled) {
              var link =
                Zoom_Detail.join_url +
                "&uname=" +
                first_name.trim() +
                "%20" +
                last_name.trim();
              window.open(link, "_blank");
              vm.postLeaderboardAction("EBRV");
            } else {
              bus.$emit("toggleLoader", true);
              let headers = {
                Authorization: "Bearer " + vm.getSessionToken(),
                "content-type": "application/json",
              };
              let requestData = {
                email: vm.email,
                name: vm.name,
                first_name: vm.firstName,
                last_name: vm.lastName,
                meetingid: Zoom_Detail.id,
                address: "",
                phone: vm.phone,
                industry: "",
                org: vm.company,
                job_title: vm.title,
              };
              axios
                .post(APIs.AddAttendeesToZoom, requestData, {
                  headers: headers,
                })
                .then((response) => {
                  if (
                    response &&
                    response.data &&
                    response.data.status == 0 &&
                    response.data.data.id &&
                    response.data.data.join_url &&
                    response.data.data.join_url != ""
                  ) {
                    bus.$emit("toggleLoader", false);
                    window.open(response.data.data.join_url, "_blank");
                    vm.postLeaderboardAction("EBRV");
                  } else {
                    bus.$emit("toggleLoader", false);
                    vm.retryJoinInZoomPopup();
                  }
                })
                .catch((error) => {
                  bus.$emit("toggleLoader", false);
                  console.log(error);
                  vm.retryJoinInZoomPopup();
                });
            }
          }
        } else {
          alert(vm.zoomErrorMsg);
          vm.hideLoader();
        }
      } else {
        // var obj2 = JSON.parse(window.localStorage.getItem("my-app"));
        // if (
        //   screen.width < 767 &&
        //   obj2.AgoraPlayerBrowserSupportInMobile == false
        // ) {
        //   router.push("/screeninfo");
        // } else if (
        //   screen.width >= 768 &&
        //   screen.width <= 1024 &&
        //   obj2.AgoraPlayerBrowserSupportInIPad == false
        // ) {
        //   router.push("/screeninfo");
        // } else {
        var exhiColForInternalPlayer =
          ExhibitorId + "-" + chatToId.toString() + "_e2o";
        router.push({ path: vm.LiveStageURL + "/" + exhiColForInternalPlayer });
        // }
      }
    },
    GoToTRList(ExhibitorId, ExhibitorName) {
      console.log(ExhibitorName);
      router.push({
        path: "/roundtable/" + ExhibitorId + "/exhibitor",
      });
    },
    JoinRT(tableId) {
      if (vm.visitor) {
        //common.openRegistrationDialog();
        vm.goToRegistration();
        return;
      }
      debugger;
      //alert(tableId);
      //$(".tooltip").tooltip("hide");
      let tables = vm.allRoundTables.filter(function name(table) {
        return table.TableId == tableId && !table.IsTableFull;
      });
      if (tables.length > 0) {
        let table = tables[0];
        if (table.StreamingClient.toLowerCase() == "zoom") {
          vm.retryType = "exrt";
          vm.tempTable = {
            tableId: tableId,
          };
          if (table.Zoom_Detail && table.Zoom_Detail.id) {
            if (vm.uid == table.HostId || vm.uid == table.CoHostId) {
              var hlink =
                table.Zoom_Detail.start_url +
                "&uname=" +
                vm.firstName.trim() +
                "%20" +
                vm.lastName.trim();
              window.open(hlink, "_blank");
              vm.postLeaderboardAction("RTEB");
            } else {
              if (!vm.RestrictedZoomMeetingEnabled) {
                var link =
                  table.Zoom_Detail.join_url +
                  "&uname=" +
                  vm.firstName.trim() +
                  "%20" +
                  vm.lastName.trim();
                window.open(link, "_blank");
                vm.postLeaderboardAction("RTEB");
              } else {
                bus.$emit("toggleLoader", true);
                let headers = {
                  Authorization: "Bearer " + vm.getSessionToken(),
                  "content-type": "application/json",
                };
                let requestData = {
                  email: vm.email,
                  name: vm.name,
                  first_name: vm.firstName,
                  last_name: vm.lastName,
                  meetingid: table.Zoom_Detail.id,
                  address: "",
                  phone: vm.phone,
                  industry: "",
                  org: vm.company,
                  job_title: vm.title,
                };
                axios
                  .post(APIs.AddAttendeesToZoom, requestData, {
                    headers: headers,
                  })
                  .then((response) => {
                    if (
                      response &&
                      response.data &&
                      response.data.status == 0 &&
                      response.data.data.id &&
                      response.data.data.join_url &&
                      response.data.data.join_url != ""
                    ) {
                      bus.$emit("toggleLoader", false);
                      window.open(response.data.data.join_url, "_blank");
                      vm.postLeaderboardAction("RTEB");
                    } else {
                      bus.$emit("toggleLoader", false);
                      vm.retryJoinInZoomPopup();
                    }
                  })
                  .catch((error) => {
                    bus.$emit("toggleLoader", false);
                    console.log(error);
                    vm.retryJoinInZoomPopup();
                  });
              }
            }
          } else {
            alert(vm.zoomErrorMsg);
            vm.rtLoading = false;
          }
        } else if (table.StreamingClient.toLowerCase() == "custom") {
          vm.postLeaderboardAction("RTEB");
          window.open(table.CustomLink, "_blank");
        } else {
          // if (
          //   screen.width < 767 &&
          //   vm.AgoraPlayerBrowserSupportInMobile == false
          // ) {
          //   router.push("/screeninfo");
          // } else if (
          //   screen.width >= 768 &&
          //   screen.width <= 1024 &&
          //   vm.AgoraPlayerBrowserSupportInIPad == false
          // ) {
          //   router.push("/screeninfo");
          // } else {
          router.push({
            path: vm.LiveStageURL + "/" + table.TableId + "_exrt",
          });
          // }
        }
      }
    },
    retryJoinInZoomPopup() {
      $("#RetryJoinInZoom").modal(
        {
          backdrop: "static",
        },
        "show"
      );
    },
    cancelRetryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
    },
    retryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
      if (vm.retryType == "exrt") {
        if (vm.tempTable) {
          vm.JoinRT(vm.tempTable.tableId);
        }
      } else if (vm.retryType == "e2o") {
        if (vm.tempMeeting) {
          vm.JoinRepVideoCall(
            vm.tempMeeting.ExhibitorId,
            vm.tempMeeting.chatToId,
            vm.tempMeeting.StreamingClient,
            vm.tempMeeting.Zoom_Detail
          );
        }
      }
    },
    initContactListener: function () {
      if (
        vm.ExhibitorData.length > 0 &&
        vm.ExhibitorData[0].MappedContacts &&
        vm.ExhibitorData[0].MappedContacts.length > 0
      ) {
        vm.ExhibitorData[0].MappedContacts.map(function (value) {
          //$.each(vm.ExhibitorData[0].MappedContacts, function (index, value) {
          var objusr = JSON.parse(window.localStorage.getItem("my-app"));
          // console.log("loggedin userid:- " + objusr.user[0].id);
          let streamingClient = "Web";
          if (value.StreamingClient) {
            streamingClient = value.StreamingClient;
          }
          var statusClass = "away";
          if (streamingClient.trim().toLowerCase() == "zoom") {
            if (vm.EnableExhibitorRepVideoCall) {
              statusClass = "online";
              value.VideoCallEnable = true;
            }
            value.statusClass = statusClass;
          } else {
            if (objusr.user[0].id === value.AttendeeId) {
              if (vm.EnableExhibitorRepVideoCall) {
                //if loggedin user is REPRESENTATIVE
                //  statusClass = "online";
                //VideoCallEnable = true;
                // $("#spnStatus" + objusr.user[0].id).removeClass();
                // $("#spnStatus" + objusr.user[0].id).addClass(statusClass);

                value.VideoCallEnable = true;
              } else {
                value.VideoCallEnable = false;
              }
            } else {
              //  var statusClass = "away";

              var VideoCallEnable = false;
              // $("#spnStatus" + value.AttendeeId).removeClass();
              // $("#spnStatus" + value.AttendeeId).addClass(statusClass);

              if (vm.EnableExhibitorRepVideoCall) {
                value.VideoCallEnable = VideoCallEnable;
              } else {
                value.VideoCallEnable = vm.EnableExhibitorRepVideoCall;
              }
            }
            value.statusClass = statusClass;

            vm.ExhibitorData = vm.ExhibitorData.filter(function (item) {
              return item.AttendeeId !== 0;
            });
            // vm.ExhibitorData[0].MappedContacts[index].ShowRepActiveStatus =
            //   vm.ShowRepActiveStatus;

            //var col_name = vm.exid + "-" + value.AttendeeId + "_o2o";
            var col_name = vm.exid + "-" + value.AttendeeId + "_e2o"; //418000-221002_o2o

            //var obj = JSON.parse(window.localStorage.getItem("my-app"));
            if (value.listener) {
              value.listener();
              value.listener = null;
            }
            //debugger;
            //alert(value.AttendeeId);
            value.listener = db
              .collection(vm.event_collectionName)
              .doc("UserVideoActivity")
              .collection("ExhibitorMeeting")
              .doc(col_name)
              .collection("Participances")
              .onSnapshot((querySnapshot) => {
                //alert(col_name);
                //debugger;
                //console.log(querySnapshot);
                var listenerStatusClass = "away";
                //alert("ExhibitorMeeting_Participances");
                var CurrentRepresentativeStatus = false;

                if (querySnapshot.docs.length > 0) {
                  var cnt = 0;
                  var exParticipance = [];
                  querySnapshot.forEach((doc) => {
                    var curDoc = doc.data();
                    var obj = new Object();
                    obj.AttendeeId = curDoc.AttendeeId;
                    obj.IsActive = curDoc.IsActive;
                    exParticipance.push(obj);
                    if (curDoc.IsActive) {
                      cnt++;
                    }

                    if (value.AttendeeId == curDoc.AttendeeId) {
                      CurrentRepresentativeStatus = curDoc.IsActive;
                      console.log("value.AttendeeId1  - " + value.AttendeeId);
                      console.log(
                        "CurrentRepresentativeStatus1 - " +
                          CurrentRepresentativeStatus
                      );
                    }
                  });
                  var attIsActive = exParticipance.filter(function (item) {
                    return value.AttendeeId == item.AttendeeId;
                  });
                  if (attIsActive <= 0) {
                    listenerStatusClass = "away";
                    //  $("#lnkVideoCall" + value.AttendeeId).attr("disabled", "true");
                    VideoCallEnable = false;
                  } else {
                    console.log(
                      "CurrentRepresentativeStatus2 - " +
                        CurrentRepresentativeStatus
                    );
                    if (CurrentRepresentativeStatus) {
                      if (cnt >= 2) {
                        listenerStatusClass = "offline"; //busy
                        if (vm.AllowMoreThan1tojoinRepInVideoCall) {
                          VideoCallEnable = true;
                        } else {
                          VideoCallEnable = false;
                        }
                      } else if (cnt < 2) {
                        if (cnt > 0) {
                          listenerStatusClass = "online";
                          VideoCallEnable = true;
                        } else {
                          listenerStatusClass = "away";
                          VideoCallEnable = false;
                        }
                      }
                    } else {
                      listenerStatusClass = "away";
                      VideoCallEnable = false;
                    }
                  }

                  // vm.ExhibitorData[0].MappedContacts.statusClass = listenerStatusClass;
                  // value.statusClass = listenerStatusClass;

                  //++++++++++++++++++++++ video call ICON show/hide (for now - if EnableExhibitorRepVideoCall is false , the video icon will get INACTIVE [irrespective of any status])++++++++++++++++++++++++++++++++++++++++++++
                  if (vm.EnableExhibitorRepVideoCall) {
                    if (vm.uid === value.AttendeeId) {
                      value.VideoCallEnable = true;
                    } else {
                      value.VideoCallEnable = VideoCallEnable;
                    }
                  } else {
                    value.VideoCallEnable = false;
                  }
                  // vm.ExhibitorData[0].MappedContacts[
                  //   index
                  // ].VideoCallEnable = VideoCallEnable;
                  //+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

                  vm.ExhibitorData = vm.ExhibitorData.filter(function (item) {
                    return item.AttendeeId !== 0;
                  });
                }
                //alert(value.AttendeeId);
                //alert(listenerStatusClass);
                $("#spnStatus" + value.AttendeeId).removeClass();
                $("#spnStatus" + value.AttendeeId).addClass(
                  listenerStatusClass
                );
              });
            //.catch(function (error) {
            //  alert("error: " + error);
            //  console.error("ExhibitorMeeting_Participances: ", error);
            //});
          }
        });
      }
    },
    loopArray: function (arr) {
      var obj = [];
      var i;

      for (i = 0; i < arr.length; i++) {
        let socialkeys = Object.keys(arr[i]);
        let socialvaues = Object.values(arr[i]);
        if (socialvaues[0] !== "") {
          if (socialvaues[0].indexOf("http") < 0) {
            socialvaues[0] = "http://" + socialvaues[0];
          }
        }
        obj.push({ key: socialkeys[0], value: socialvaues[0] });
      }
      this.sortedSocialLinks = obj;
      if (this.sortedSocialLinks > 0) {
        this.sortedSocialLinks.sort(function (x, y) {
          let a = x.key.toUpperCase(),
            b = y.key.toUpperCase();
          return a == b ? 0 : a > b ? 1 : -1;
        });
      }
    },
    getDates: function (startDate, endDate) {
      var dates = [],
        currentDate = startDate,
        addDays = function (days) {
          var date = new Date(this.valueOf());
          date.setDate(date.getDate() + days);
          return date;
        };
      while (currentDate <= endDate) {
        dates.push(currentDate);
        currentDate = addDays.call(currentDate, 1);
      }
      return dates;
    },

    InitModal(ReqIndex, parAttendeeId) {
      $("#ReqMeeting" + ReqIndex + " .calendar-wrap").show();
      $("#ReqMeeting" + ReqIndex + " .modal-body-wrapper2").hide();
      $("#ReqMeeting" + ReqIndex + " .modal-body-wrapper3").hide();

      localStorage.setItem("AttendeeId", parAttendeeId);
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      //Receiver id
      this.createAvailableMeetingSlots(parAttendeeId);
      //Sender id
      this.createAvailableMeetingSlots(obj.user[0].id);

      //  this.getAvailableMeetingSlots(parAttendeeId);
    },
    openSchedulePopup(tab) {
      if (vm.visitor) {
        //common.openRegistrationDialog();
        vm.goToRegistration();
        return;
      }
      vm.tab = tab;
      vm.dialog = true;
      debugger;
    },
    closeHandler() {
      vm.dialog = false;
    },
    goToBookAppointment() {
      //alert("E goToBookAppointment");
      //$("#tabExhibitorsSchedule").click();
      vm.tab = "schedule";
    },
    OpenRequestMeeting(data) {
      if (vm.visitor) {
        //common.openRegistrationDialog();
        vm.goToRegistration();
        return;
      }
      vm.requestMeetingKey++;
      vm.requestMeetingFlag = true;
      vm.currentAttendee = data;
      console.log("data=====", data);

      //if (data.ProfilePictureURL) {
      //  var AttendeeImgPath = data.ProfilePictureURL;

      //  if (
      //    AttendeeImgPath != null &&
      //    AttendeeImgPath != "" &&
      //    document.getElementById("ReqAttendeeImage")
      //  ) {
      //    document.getElementById("ReqAttendeeImage").src = AttendeeImgPath;
      //    $("#ReqAttendeeImage").show();
      //  }

      //  if (document.getElementById("ReqdivImgHldText")) {
      //    document.getElementById("ReqdivImgHldText").innerText = "";
      //    $("#ReqdivImgHldText").hide();
      //  }
      //} else {
      //  var Initials = document.getElementById("dvImgeHldText").innerText;
      //  if ($("#ReqAttendeeImage")) {
      //    $("#ReqAttendeeImage").attr("src", "");
      //    $("#ReqAttendeeImage").hide();
      //  }
      //  if (document.getElementById("ReqdivImgHldText")) {
      //    document.getElementById("ReqdivImgHldText").innerHTML =
      //      "<h4>" + Initials + "</h4>";
      //    $("#ReqdivImgHldText").show();
      //  }
      //}

      //if (document.getElementById("ReqAttendeeName")) {
      //  document.getElementById("ReqAttendeeName").innerText = data.Name;
      //}
      //if (document.getElementById("ReqAttendeeNameh4")) {
      //  document.getElementById("ReqAttendeeNameh4").innerText = data.Name;
      //}
      //if (document.getElementById("ReqAttendeeTitle")) {
      //  document.getElementById("ReqAttendeeTitle").innerText =
      //    data.Designation;
      //}
      //if (document.getElementById("ReqAttendeeCompany")) {
      //  document.getElementById("ReqAttendeeCompany").innerText = data.Company;
      //}
      //if (data.Email) {
      //  if (document.getElementById("ReqAttendeeEmail")) {
      //    document.getElementById("ReqAttendeeEmail").href = data.Email;
      //    if (
      //      document.getElementById("ReqAttendeeEmail").href.indexOf("mailto") <
      //      0
      //    ) {
      //      $("#ReqAttendeeEmail").text(data.Email);
      //      document.getElementById("ReqAttendeeEmail").href =
      //        "mailto:" + document.getElementById("ReqAttendeeEmail").href;
      //    }
      //    $("#ReqAttendeeEmail").parent().show();
      //  } else {
      //    $("#ReqAttendeeEmail").parent().hide();
      //  }
      //} else {
      //  $("#ReqAttendeeEmail").parent().hide();
      //}

      //if (data.Phone) {
      //  if (document.getElementById("ReqAttendeePhone")) {
      //    document.getElementById("ReqAttendeePhone").href = data.Phone;
      //    if (
      //      document.getElementById("ReqAttendeePhone").href.indexOf("tel") < 0
      //    ) {
      //      $("#ReqAttendeePhone").text(data.Phone);
      //      document.getElementById("ReqAttendeePhone").href =
      //        "tel:" + document.getElementById("ReqAttendeePhone").href;
      //    }
      //    $("#ReqAttendeePhone").parent().show();
      //  } else {
      //    $("#ReqAttendeePhone").parent().hide();
      //  }
      //} else {
      //  $("#ReqAttendeePhone").parent().hide();
      //}
      //if ($("#ReqAttendeeWebsite")) {
      //  $("#ReqAttendeeWebsite").parent().hide();
      //}
      $("#aFacebok").hide();
      $("#aTwitter").hide();
      $("#aLikedin").hide();
      $("#hdnAttendeeId").val(data.AttendeeId);
      var hdnattendeeId = data.AttendeeId;
      var ComponentClass = Vue.extend(RequestMeeting);
      var instance = new ComponentClass({
        propsData: {
          attendeeId: hdnattendeeId,
          showDatePicker: true,
          attendee: data,
        },
      });
      instance.$mount();
      $("#myModal2").hide();
      $(".modal-backdrop").hide();
    },

    createAvailableMeetingSlots: function (attendeeId) {
      var availableSlot = [];
      var AvailabilityFromTime;
      var AvailabilityToTime;
      var AvailableMeetingSlotsId;
      // var AvailableMeetingSlots=[];

      if (this.MeetingSettings.AvailabilityFromTime != null) {
        AvailabilityFromTime = Math.round(
          this.MeetingSettings.AvailabilityFromTime / 3600
        );
      }
      if (this.MeetingSettings.AvailabilityToTime != null) {
        AvailabilityToTime = Math.round(
          this.MeetingSettings.AvailabilityToTime / 3600
        );
      }
      //
      availableSlot.push(
        moment(AvailabilityFromTime, ["h:mm A"]).format("hh:mm A")
      );

      var StartSlotTime = moment(AvailabilityFromTime, ["h:mm A"]);
      var EndSlotTime = moment(AvailabilityToTime, ["h:mm A"]);

      for (let i = AvailabilityFromTime; StartSlotTime < EndSlotTime; i++) {
        let time = moment(availableSlot[i - AvailabilityFromTime], ["h:mm A"])
          .add(this.MeetingSettings.Slot, "minutes")
          .format("hh:mm A");

        availableSlot.push(time);
        StartSlotTime = moment(time, ["h:mm A"]);
      }

      var MSobj = JSON.parse(window.localStorage.getItem("my-app"));

      var MeetingStartDate = new Date();
      var MeetingEndDate = new Date(
        MSobj.MeetingSettings[0].EndDate.seconds * 1000
      );

      var dates = this.getDates(MeetingStartDate, MeetingEndDate);
      //
      dates.forEach(function (MeetingsDate) {
        console.log(MeetingsDate);

        for (let i = 0; i < availableSlot.length - 1; i++) {
          //

          AvailableMeetingSlotsId =
            moment(MeetingsDate).format("MMMDD") +
            "_" +
            availableSlot[i] +
            "_" +
            availableSlot[i + 1];

          vm.SaveAvailableMeetingSlots(attendeeId, AvailableMeetingSlotsId);
        }
      });
    },
    SaveAvailableMeetingSlots: function (attendeeId, AvailableMeetingSlotsId) {
      var AvailableMeetingSlots = "AvailableMeetingSlots";
      var MeetingTime = AvailableMeetingSlotsId.split("_");

      var MdocRef = db
        .collection(vm.event_collectionName)
        .doc("AttendeeList")
        .collection("Attendees")
        .doc(attendeeId)
        .collection(AvailableMeetingSlots)
        .doc(AvailableMeetingSlotsId);

      MdocRef.get()
        .then(function (doc) {
          if (!doc.exists) {
            //

            var docObj = new Object();
            docObj.AvailableMeetingSlotsId = AvailableMeetingSlotsId;
            docObj.StartDate = MeetingTime[0];
            docObj.StartDatetime = MeetingTime[1];
            docObj.EndDateTime = MeetingTime[2];

            MdocRef.set(docObj)
              .then(function () {
                console.log("AvailableMeetingSlots Created ");
              })
              .catch(function (error) {
                console.error("Error AvailableMeetingSlots: ", error);
              });
          }
        })
        .catch(function (error) {
          console.error("Error creating AvailableMeetingSlots: ", error);
        });
    },
    getExhibitorDetails: function () {
      vm.requestMeetingFlag = false;
      vm.boothDetailsLoaded = false;
      vm.checkScavengerHuntDetails(vm.exid);
      vm.collectLeaderboardPoint("EXBV");
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      vm.disposeContactListener();
      vm.disposeRoundTableListener();
      vm.allRoundTables = [];
      vm.ExhibitorFiles = [];
      vm.ExhibitorData = [];
      vm.ExhibitorLinks = [];
      vm.showBoothEditButton = false;
      vm.isPodiumEnabled = false;

      vm.expoHallTypeBackgroundImage = "";
      db.collection(vm.event_collectionName) //"OA_UAT_C1592010308300E1592010479212") //OA_UAT_C1591205467009E1591206650065")
        .doc("ExhibitorList")
        .collection("Exhibitors")
        .doc(obj.selExhibitorID)
        //.doc("ExhibitorId", "==", obj.selExhibitorID)
        //.where("ExhibitorId", "==", "418000")
        .get()
        .then((doc) => {
          vm.disposeContactListener();
          vm.disposeRoundTableListener();
          vm.allRoundTables = [];
          vm.ExhibitorFiles = [];
          vm.ExhibitorData = [];
          vm.ExhibitorLinks = [];
          var expoName = null;
          var expoId = null;
          if (doc.exists) {
            debugger;
            $(".aPointer").css("border", "1px solid red");
            var socLinks = doc.data().SocialLinks;

            if (doc.data().Type && doc.data().Type.BackgroundImg) {
              vm.expoHallTypeBackgroundImage = vm.getCDNUrl(
                doc.data().Type.BackgroundImg
              );
            }
            //if (doc.data().Type != undefined) {
            //  if (
            //    doc.data().Type.BackgroundImg != null &&
            //    doc.data().Type.BackgroundImg.length > 0
            //  ) {
            //    vm.expoHallTypeBackgroundImage = vm.getCDNUrl(
            //      doc.data().Type.BackgroundImg
            //    );
            //    //document.getElementById("divTop").style.backgroundImage =
            //    //  vm.expoHallTypeBackgroundImage;
            //  }
            //  //else {
            //  //  vm.expoHallTypeBackgroundImage = vm.ExpoHallBackgroundImage
            //  //    ? vm.ExpoHallBackgroundImage
            //  //    : "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FSymposium%20Exhibitor%20Booth%2Fexpo-bg.jpg?alt=media&token=3eb488b8-32fd-4fae-8d49-b35a4e9a3ded";
            //  //  document.getElementById("divTop").style.backgroundImage =
            //  //    vm.expoHallTypeBackgroundImage;
            //  //}
            //}
            ////else {
            ////  vm.expoHallTypeBackgroundImage = vm.ExpoHallBackgroundImage
            ////    ? vm.ExpoHallBackgroundImage
            ////    : "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FSymposium%20Exhibitor%20Booth%2Fexpo-bg.jpg?alt=media&token=3eb488b8-32fd-4fae-8d49-b35a4e9a3ded";
            ////  document.getElementById("divTop").style.backgroundImage =
            ////    vm.expoHallTypeBackgroundImage;
            ////}
            this.loopArray(socLinks);
            socLinks = this.sortedSocialLinks;
            this.showcaseVideoUrl = doc.data().ShowcaseVideoURL;
            var replaceTxt = null;
            if (doc.data().PodiumDetails) {
              vm.podiumTitle = doc.data().PodiumDetails.Title
                ? doc.data().PodiumDetails.Title
                : null;
              if (vm.podiumTitle) {
                vm.isPodiumEnabled = true;
              }
              vm.podiumDescription = doc.data().PodiumDetails.Description
                ? doc.data().PodiumDetails.Description
                : null;
              vm.ctaLink = doc.data().PodiumDetails.CTALink
                ? doc.data().PodiumDetails.CTALink
                : null;
              vm.knowMoreLink = doc.data().PodiumDetails.KnowMoreLink
                ? doc.data().PodiumDetails.KnowMoreLink
                : null;
            } else {
              vm.podiumTitle = null;
              vm.podiumDescription = null;
              vm.ctaLink = null;
              vm.knowMoreLink = null;
            }

            if (doc.data().ShowcaseVideoURL) {
              replaceTxt = doc
                .data()
                .HtmlCode.replace(
                  /title="Video"/g,
                  "id='expo-video-tile' title='Video' "
                );
            } else {
              // Remove the anchor with title="Video"
              replaceTxt = doc
                .data()
                .HtmlCode.replace(/<a[^>]*title="Video"[^>]*>.*?<\/a>/g, "");
            }

            vm.roomId = doc.data().mappedchatgroup
              ? doc.data().mappedchatgroup.id
              : null;
            vm.MappedGroup = doc.data().mappedchatgroup;
            expoName = doc.data().Name;
            vm.expoNameForExport = doc.data().Name;
            expoId = doc.id;
            this.ExhibitorData.push({
              id: doc.id,
              Name: doc.data().Name,
              Logo: this.getCDNUrl(doc.data().Logo),
              Email: doc.data().Email,
              Category: doc.data().Category,
              Type: doc.data().Type,
              HtmlCode: doc.data().HtmlCode ? replaceTxt : "",
              BoothNo: doc.data().BoothNo,
              HotspotImageUrL: this.getCDNUrl(doc.data().HotspotImageURL),
              Website: doc.data().Website,
              Profile: doc.data().Profile,
              Phone: doc.data().Phone,
              Image: this.getCDNUrl(doc.data().Logo),
              SocialLinks: socLinks,
              MappedContacts: doc.data().MappedContacts
                ? doc.data().MappedContacts
                : [],
              MappedGroup: doc.data().mappedchatgroup
                ? doc.data().mappedchatgroup
                : [],
              MappedRoundTables: doc.data().MappedRoundTables
                ? doc.data().MappedRoundTables
                : [],
              contactcount: doc.data().MappedContacts.length,
              Files: doc.data().Resources,
              fileLength: doc.data().Resources.length,
              resourceLinkLength:
                doc.data().ResourcesLink != undefined
                  ? doc.data().ResourcesLink.length
                  : 0,
              ShowcaseVideoURL: doc.data().ShowcaseVideoURL,
              isTooltipVisible: false,
              FullProfile:
                doc
                  .data()
                  .Profile.replace(/<[^>]*>/g, "\n\r")
                  .substring(0, 500) + "...",
            });
            vm.ExhibitorData.map(function (item) {
              vm.getBookmark(item.id, item);
            });

            this.ExhibitorFiles = [];
            for (let i = 0; i < this.ExhibitorData[0].Files.length; i++) {
              var arr;
              var arr2;
              var filePath;

              if (
                this.ExhibitorData[0].Files[i].includes(
                  "firebasestorage.googleapis.com"
                )
              ) {
                //var filePath = this.ExhibitorData[0].Files[i].replace("%2F", "/");
                arr = this.ExhibitorData[0].Files[i].split("%2F");
                //var arr = filePath.split("/");

                arr2 = arr[arr.length - 1]
                  .replace(/%20/g, " ")
                  .replace(/%26/g, "")
                  .replace(".pdf", "")
                  .replace(".xlsx", "")
                  .replace(".pptx", "")
                  .replace(".docx", "")
                  .replace(".mp4", "")
                  .split("?");
              } else {
                filePath = this.ExhibitorData[0].Files[i].replace("%2F", "/");
                //var arr = this.ExhibitorData[0].Files[i].split("%2F");
                arr = filePath.split("/");

                arr2 = arr[arr.length - 1]
                  .replace(/%20/g, " ")
                  .replace(/%26/g, "")
                  .replace(".pdf", "")
                  .replace(".xlsx", "")
                  .replace(".pptx", "")
                  .replace(".docx", "")
                  .replace(".mp4", "")
                  .split("?");
              }

              this.ExhibitorFiles.push({
                Filename: decodeURI(arr2[0]),
                Url: this.ExhibitorData[0].Files[i],
              });
            }
            this.ExhibitorLinks = doc.data().ResourcesLink;

            if (this.ExhibitorData[0].Website !== "") {
              if (this.ExhibitorData[0].Website.indexOf("http") < 0) {
                this.ExhibitorData[0].Website =
                  "http://" + this.ExhibitorData[0].Website;
              }
            }
            for (
              let i = 0;
              i < this.ExhibitorData[0].MappedContacts.length;
              i++
            ) {
              console.log(
                "expo log====",
                this.ExhibitorData[0].MappedContacts[i]
              );
              if (!this.ExhibitorData[0].MappedContacts[i].ProfilePictureURL) {
                this.ExhibitorData[0].MappedContacts[i].ProfilePictureURL = "";
              }
              if (this.ExhibitorData[0].MappedContacts[i].Name) {
                this.ExhibitorData[0].MappedContacts[i].NameInitial =
                  common.getInitials(
                    this.ExhibitorData[0].MappedContacts[i].Name
                  );
              }

              if (
                vm.ExhibitorData[0].MappedContacts[i].Email ==
                vm.$store.state.user[0].Email
              ) {
                vm.showBoothEditButton = true;
              }
            }

            vm.tableTopic.ExhibitorId = "";
            vm.tableTopic.ExhibitorName = "";
            vm.tableTopic.TopicId = "";
            vm.tableTopic.TopicName = "";
            vm.tableTopic.TopicLogo = "";

            if (doc.data().RoundTableTopic) {
              vm.tableTopic.ExhibitorId = doc.id;
              vm.tableTopic.ExhibitorName = doc.data().Name;
              vm.tableTopic.TopicId = doc.data().RoundTableTopic.TopicId
                ? doc.data().RoundTableTopic.TopicId
                : "";
              vm.tableTopic.TopicName = doc.data().RoundTableTopic.TopicName
                ? doc.data().RoundTableTopic.TopicName
                : "";
              vm.tableTopic.TopicLogo = doc.data().RoundTableTopic.TopicLogo
                ? doc.data().RoundTableTopic.TopicLogo
                : "";
            }

            var i;
            for (
              i = 0;
              i < this.ExhibitorData[0].MappedRoundTables.length;
              i++
            ) {
              this.getRoundTable(
                this.ExhibitorData[0].MappedRoundTables[i].TableId
              );
            }

            if (
              this.ExhibitorData[0].MappedRoundTables.length == 0 &&
              !vm.tableTopic.TopicId
            ) {
              $("#dvMainRoundTable").hide();
              $("#round-table-tooltip").hide();
            } else {
              $("#dvMainRoundTable").show();
              $("#round-table-tooltip").show();
            }
            vm.JoinTheConversationText =
              vm.JoinTheConversationTextFormat.replace(
                "{BoothName}",
                vm.ExhibitorData[0].Name
              );

            if (vm.ExhibitorData[0].Phone && vm.ExhibitorData[0].Website) {
              vm.JoinTheConversationText =
                vm.JoinTheConversationText +
                "You can also contact us on " +
                '<a :href="tel:' +
                vm.ExhibitorData[0].Phone +
                '">' +
                vm.ExhibitorData[0].Phone +
                "</a>" +
                "or visit " +
                '<a target="_blank" href="' +
                vm.ExhibitorData[0].Website +
                '">' +
                vm.ExhibitorData[0].Website +
                "</a>";
            } else if (vm.ExhibitorData[0].Phone) {
              vm.JoinTheConversationText =
                vm.JoinTheConversationText +
                "You can also contact us on " +
                '<a :href="tel:' +
                vm.ExhibitorData[0].Phone +
                '">' +
                vm.ExhibitorData[0].Phone +
                "</a>";
            } else if (vm.ExhibitorData[0].Website) {
              vm.JoinTheConversationText =
                vm.JoinTheConversationText +
                "You can also visit us at " +
                '<a target="_blank" href="' +
                vm.ExhibitorData[0].Website +
                '">' +
                vm.ExhibitorData[0].Website +
                "</a>";
            }

            if (this.ExhibitorData[0].ShowcaseVideoURL === "") {
              $("a[title$='Video']").hide();
            } else {
              $("a[title$='Video']").show();
            }

            if (this.ExhibitorData[0].contactcount === 0) {
              $("a[title$='Start Conversation']").hide();
            } else {
              $("a[title$='Start Conversation']").show();
            }
            if (
              this.ExhibitorData[0].fileLength === 0 &&
              this.ExhibitorData[0].resourceLinkLength === 0
            ) {
              $("a[title$='Collateral']").hide();
            } else {
              $("a[title$='Collateral']").show();
            }
            store.commit("addNavProtectedExbList", {
              id: expoId,
              name: expoName,
              nav: vm.nav,
            });
            var navProtectedExbList = vm.$store.getters.getNavProtectedExbList;
            var visitedExpo = navProtectedExbList.filter(function (item) {
              return item.id == expoId;
            });
            if (visitedExpo.length > 0 && visitedExpo[0].nav) {
              vm.protectNav = true;
              vm.nav = visitedExpo[0].nav;
            }
            var url =
              "/exhibitorsview/" + expoId + "/" + expoName.replace(/%20/g, "_");
            if (vm.protectNav) {
              url += "/" + (vm.nav ? vm.nav : "booth");
            }
            router.push(url.replace(/ /g, "_"));

            //interval = setInterval(() => {
            //	vm.initContactListener();
            //}, 1000);
            vm.initContactListener();
          }
          vm.boothDetailsLoaded = true;
          //if (vm.boothSettingsLoaded) {
          //  vm.SetBoothBackgroundImage();
          //}
        })
        .catch((error) => {
          console.log(error);
          vm.boothDetailsLoaded = true;
        });
    },
    ExchangeBusinessCard: function (option) {
      vm.businessCardSending = true;
      let headers = {
        Authorization: "Bearer " + vm.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
        data: {
          userId: vm.uid,
          exhibitorId: vm.exid,
          msg: $("#txtMsgArea").val(),
        },
      };
      axios
        .post(vm.APIs.Exchangebusinesscard, requestData, {
          headers: headers,
        })
        .then((response) => {
          vm.businessCardSending = false;
          if (option == "mobile") {
            vm.closeDiv("exampleModalCenter");
          } else {
            vm.closeDiv("dvexchangeCard");
          }
          vm.showSnackbar(
            vm.$t("expoview.bussinesscardexchangesuccess"),
            "info",
            "top"
          );
          console.log(response);
          vm.collectLeaderboardPoint("EXBC");
        })
        .catch((error) => {
          if (option == "mobile") {
            vm.closeDiv("exampleModalCenter");
          } else {
            vm.closeDiv("dvexchangeCard");
          }
          console.log(error);
          vm.showSnackbar(
            vm.$t("expoview.bussinesscardexchangefail"),
            "error",
            "top"
          );
          vm.businessCardSending = false;
        });
    },
    setFirebaseAppsettings: function () {
      var docRef = db.collection("OA_UAT").doc("OnAirAppSettings");
      docRef.get().then(function (doc) {
        if (doc.exists) {
          vm.GlobalKeysData.BroadcastID = doc.data().AppIDRTC;
          vm.GlobalKeysData.BroadcastCertificate = doc.data().CertificateRTC;
          vm.GlobalKeysData.BroadcastSpeakerApiUrl = doc.data().SpeakerTokenURL;
          vm.GlobalKeysData.BroadcastAttendeeApiUrl =
            doc.data().AttendeeTokenURL;
          vm.GlobalKeysData.BroadcastStartURL = doc.data().BroadcastBaseURL;
          vm.GlobalKeysData.BroadcastViewURL = doc.data().AudienceBaseURL;
          vm.GlobalKeysData.BroadcastvalidityHours =
            doc.data().TokenValidityHours;
          vm.GlobalKeysData.ChannelPrefix = doc.data().ChannelPrefix;
          vm.GlobalKeysData.videoParamsEncryptURL = doc.data().EncryptionURL;
        }
      });
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },
    hideLoader: function () {
      //if (timerLoader != null) {
      clearTimeout(this.timerLoader);
      // alert("outside");
      if ($("#divLoading") != null) {
        //alert("inside");
        $("#divLoading").hide();
      }
      //}
    },
    AddAnalitics: function (btnName, action) {
      debugger;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          debugger;
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              analytics.AddUserAction(
                vm.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          analytics.AddUserAction(
            vm.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler(event) {
      if (event.target.id == "expo-video-tile") {
        vm.collectLeaderboardPoint("EBWV");
      }
      // event.target is the clicked element object
      this.AddAnalitics(event, "click");
    },
    closeDiv(val) {
      // var src = $("#frmVideo").attr("src");
      // $("#frmVideo").attr("src", "");
      // $("#frmVideo").attr("src", src);
      if (val == "dvVideo") {
        this.showcaseVideoUrl = this.showcaseVideoUrl
          ? this.showcaseVideoUrl + "?autoplay=0"
          : "";
      }

      // $(".youtube-video")[0].contentWindow.postMessage(
      //   '{"event":"command","func":"stopVideo","args":""}',
      //   "*"
      // );
      // $("#frmVideo.youtube-video")[0].contentWindow.postMessage(
      //   '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      //   "*"
      // );
      $("#dvSocial").hide();
      $("#" + val).hide();
    },
    showDiv(val) {
      if (
        (val == "dvexchangeCard" || val == "exampleModalCenter") &&
        vm.visitor
      ) {
        //common.openRegistrationDialog();
        vm.goToRegistration();
        return;
      } else {
        $("#" + val).show();
        if (val == "exampleModalCenter") {
          //$("#exampleModalCenter").show();
          $("#exampleModalCenter").addClass("show");
        }
      }
    },
    LoadNext(id) {
      if (vm.protectNav) {
        return;
      }
      //this.loadscripts();
      vm.exid = id;
      vm.showVideoFlg = false;
      vm.setFirebaseAppsettings();
      vm.showLoader();
      if (vm.exid !== undefined) {
        if (vm.exid !== "") {
          store.commit("addExhibitorID", vm.exid);
        } else {
          router.push({ name: "ExhibitorsHall" });
        }
      } else {
        router.push({ name: "ExhibitorsHall" });
      }
      this.getExhibitorDetails();
      // this.openVideoModal();
      this.openVideoModal = false;
      vm.hideLoader();
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
      this.getPrv(id);
      this.getNxt(id);
      // let items = vm.Exhibitorlist.filter(function (item) {
      //   return item.id == id;
      // });
      // let name = "";
      // if (items.length > 0) {
      //   name = items[0].Name;
      // }
      // name = name.replace(/ /g, "_");
      // router.push("/exhibitorsview/" + id + "/" + name);
    },
    getPrv(id) {
      var selID;
      var arr;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      arr = obj.exbList.split(",");

      if (id !== undefined) {
        if (id !== "") {
          store.commit("addExhibitorID", id);
          selID = id;
        } else {
          selID = obj.selExhibitorID;
        }
      } else {
        selID = obj.selExhibitorID;
      }

      console.log(arr);
      console.log("currindex " + arr.indexOf(selID));
      if (arr.indexOf(selID) > 0) {
        console.log("prv " + arr[arr.indexOf(selID) - 1]);
        this.prv = arr[arr.indexOf(selID) - 1];
        return arr[arr.indexOf(selID) - 1];
      } else {
        console.log("prv " + arr[arr.length - 1]);
        this.prv = arr[arr.length - 1];
        return arr[arr.length - 1];
      }
    },
    getNxt(id) {
      var selID;
      var arr;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      arr = obj.exbList.split(",");

      if (id !== undefined) {
        if (id !== "") {
          store.commit("addExhibitorID", id);
          selID = id;
        } else {
          selID = obj.selExhibitorID;
        }
      } else {
        selID = obj.selExhibitorID;
      }

      if (arr.indexOf(selID) < arr.length - 1) {
        console.log("nxt " + arr[arr.indexOf(selID) + 1]);
        this.nxt = arr[arr.indexOf(selID) + 1];
        return arr[arr.indexOf(selID) + 1];
      } else {
        console.log("nxt " + arr[0]);
        this.nxt = arr[0];
        return arr[0];
      }
    },
    getRoundTable(id) {
      //id = "729000";
      vm.disposeRoundTableListener();
      vm.allRoundTables = [];
      if (vm.allRoundTables.length == 0) {
        $("#dvMainRoundTable").hide();
        $("#round-table-tooltip").hide();
      } else {
        $("#dvMainRoundTable").show();
        $("#round-table-tooltip").show();
      }
      db.collection(vm.event_collectionName)
        .doc("RoundTableList")
        .collection("RoundTables")
        .doc(id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            let table = doc.data();
            if (table.IsPublished) {
              table.Capacity = isNaN(table.Capacity) ? 12 : table.Capacity;
              table.Occupied = isNaN(table.Occupied)
                ? 0
                : table.Occupied < 0
                ? 0
                : table.Occupied;
              table.HostId = "";
              if (table.Host && table.Host.length > 0) {
                table.HostId = table.Host[0].AttendeeId;
              }
              table.CoHostId = "";
              if (table.CoHost) {
                table.CoHostId = table.CoHost.AttendeeId;
              }
              table.AttendeeType = 4;
              if (table.HostId == vm.uid) {
                table.AttendeeType = 1;
              } else if (table.CoHostId == vm.uid) {
                table.AttendeeType = 3;
              } else {
                var attendees = table.MappedAttendees.filter(function (
                  attendee
                ) {
                  return attendee.AttendeeId == vm.uid;
                });
                if (attendees.length > 0) {
                  table.AttendeeType = 3;
                }
              }
              if (!table.StreamingClient) {
                table.StreamingClient = "";
              }
              if (table.StreamingClient) {
                table.StreamingClient = table.StreamingClient.trim();
              }
              if (!table.StreamingClientLink) {
                table.StreamingClientLink = "";
              }
              if (table.StreamingClientLink) {
                table.StreamingClientLink = table.StreamingClientLink.trim();
              }
              table.TableType = 1;
              if (table.StreamingClient.toLowerCase() == "zoom") {
                //table.Capacity = 300;
                table.TableType = 0;
              }
              table.MePresent = false;
              table.HostPresent = false;
              //table.CoHostPresent = false;
              table.IsTableFull = false;
              table.JoinButtonLabel = vm.rtSettings.SeatGrabText;
              table.JoinButtonClass = "";
              if (
                table.AttendeeType < 4 ||
                !table.PreAssigned ||
                table.SpectatorEnabled
              ) {
                table.ShowHeader = true;
                table.ShowSeatAvailability = true;
                table.ShowFooter = true;
                vm.allRoundTables.push(table);
                if (!(vm.tableTopic && vm.tableTopic.TopicId)) {
                  vm.initTableListener();
                }
              }
            }
          }
        }) //querySnapshot.forEach(doc =>  ENDING PART
        .catch((error) => {
          console.log(error);
        });
    },
    initTableListener: function () {
      vm.allRoundTables.map(function name(table) {
        if (table.StreamingClient.toLowerCase() == "zoom") {
          table.listener = db
            .collection(vm.event_collectionName)
            .doc("RoundTableList")
            .collection("RoundTables")
            .doc(table.TableId)
            .onSnapshot((doc) => {
              var table = doc.data();
              var tables = vm.allRoundTables.filter(function (t) {
                return t.TableId == table.TableId;
              });
              if (tables.length > 0) {
                tables[0].Occupied = table.Occupied;
                if (tables[0].Occupied < tables[0].Capacity) {
                  tables[0].IsTableFull = false;
                  tables[0].JoinButtonLabel = vm.rtSettings.SeatGrabText;
                  tables[0].JoinButtonClass = "";
                } else {
                  tables[0].IsTableFull = true;
                  tables[0].JoinButtonLabel = vm.rtSettings.TableFullText;
                  tables[0].JoinButtonClass = "rt-no-slots";
                }
              }
            });
        } else {
          var col_name =
            "/" +
            vm.event_collectionName +
            "/RoundTableList/RoundTables/" +
            table.TableId +
            "/Participances";
          table.listener = db
            .collection(col_name)
            .onSnapshot((querySnapshot) => {
              var members = [];
              var tableId;
              querySnapshot.forEach((doc) => {
                var participant = doc.data();
                tableId = participant.TableId;
                let attendeeType = 1;
                if (participant.AttendeeType) {
                  attendeeType = participant.AttendeeType;
                }
                if (
                  participant.IsActive &&
                  attendeeType > 0 &&
                  attendeeType < 4
                ) {
                  members.push(participant);
                }
              });
              vm.updateTable(tableId, members);
            });
        }
      });
    },
    updateTable: function (tableId, members) {
      let tables = vm.allRoundTables.filter(function (table) {
        return table.TableId == tableId;
      });
      if (tables.length > 0) {
        //alert("" + tableId);
        let table = tables[0];
        //if (table.TableId == "4124000") {
        //  debugger;
        //}
        table.Occupied = members.length;
        var ids = members.filter(function (member) {
          return member.AttendeeId == table.HostId;
        });
        if (ids.length > 0) {
          table.HostPresent = true;
          //} else if (table.HostId != vm.uid) {
          //  table.Occupied++;
        }
        if (table.Occupied > table.Capacity) {
          table.Occupied = table.Capacity;
        }
        //ids = members.filter(function (member) {
        //  return member.AttendeeId == table.CoHostId;
        //});
        //if (ids.length > 0) {
        //  table.CoHostPresent = true;
        //}
        ids = members.filter(function (member) {
          return member.AttendeeId == vm.uid;
        });
        if (ids.length > 0) {
          table.MePresent = true;
        }
        ids = members.filter(function (member) {
          return (
            member.AttendeeId != table.HostId &&
            //member.AttendeeId != table.CoHostId &&
            member.AttendeeId != vm.uid
          );
        });
        let vacant = table.Capacity;
        if (table.HostId != vm.uid) {
          vacant--;
        }
        //if (table.CoHostId) {
        //  vacant--;
        //}
        vacant -= ids.length;
        table.JoinButtonLabel = vm.rtSettings.SeatGrabText;
        table.JoinButtonClass = "";
        table.IsTableFull = false;
        if (table.HostId == vm.uid) {
          //Join As Host
          //} else if (table.CoHostId == vm.uid) {
          //  //Join As CoHost
        } else if (table.PreAssigned) {
          if (table.AttendeeType == 3) {
            //Join As Speaker
          } else if (table.SpectatorEnabled) {
            //Join As Audience
            table.JoinButtonLabel = vm.rtSettings.AudienceViewText;
            table.JoinButtonClass = "rt-spectate";
          }
        } else if (table.MePresent) {
          //Already Joined
        } else if (vacant > 0) {
          //Join As Speaker
        } else if (table.SpectatorEnabled) {
          //Join As Audience
          table.JoinButtonLabel = vm.rtSettings.AudienceViewText;
          table.JoinButtonClass = "rt-spectate";
          //alert("spectate");
        } else {
          table.IsTableFull = true;
          table.JoinButtonLabel = vm.rtSettings.TableFullText;
          table.JoinButtonClass = "rt-no-slots";
        }
        vm.allRoundTables = vm.allRoundTables.filter(function () {
          return true;
        });
      }
    },
    readCookieForVideo: function (name) {
      var nameEQ = encodeURIComponent(name) + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
          return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
      return null;
    },
    callAjaxService: function (
      serviceUrl,
      requestData,
      cacheName,
      refreshCache,
      callBackFunction
    ) {
      //alert(JSON.stringify(requestData));
      var e2mToken =
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySUQiOiIxNDQzMDUiLCJzeXN0ZW1UeXBlIjoiNiIsIm5iZiI6MTU5MTY0ODU4NywiZXhwIjoxNTkxNjUwMzg3LCJpYXQiOjE1OTE2NDg1ODcsImlzcyI6InNlbGYiLCJhdWQiOiIqIn0.aTEXVwBOM2AU3oHHyWTzJ6EP4UmsHiBc7Wrqpv9xNEY"; // JSON.parse(sessionStorage.getItem('e2mt'));
      var settings = {
        url:
          "https://he96zdju46.execute-api.us-east-1.amazonaws.com/PRD/" +
          serviceUrl,
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
          Authorization: "2c560485-d443-46e5-9f50-7a5535b24931",
          OS: "WEB",
          eToken: e2mToken,
        },
        data: JSON.stringify(requestData),
      };

      $.ajaxSetup({
        url: serviceUrl,
        beforeSend: function () {},
        complete: function () {
          //alert('4');
        },
      });
      $.ajax(settings)
        .done(function (response) {
          //alert(JSON.stringify(response));
          callBackFunction(response);
        })
        .fail(function (xhr) {
          var errorMessage = xhr.status + ": " + xhr.statusText;
          console.log(errorMessage);
        });
    },
    hideModal: function () {
      this.$refs["my-modal"].hide();
    },
    CloseModal: function () {
      $("#modalOpenBroadcast").modal("hide");
      $("#iframeBroadcast").attr("src", "");
    },
    toggleModal: function () {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["my-modal"].toggle("#toggle-btn");
    },
    getEncryptedVideoURLParams: function (
      videoParamsEncryptURL,
      VideoBaseURL,
      TokenValidityHours,
      ChannelID,
      UserID,
      SessionTitle,
      clientId,
      callBackFunction
    ) {
      // alert("getEncryptedVideoURLParams");
      console.log(
        "qString - channelName - " +
          ChannelID.toString() +
          " userId- " +
          parseInt(UserID) +
          " validityHours - " +
          parseInt(TokenValidityHours) +
          " isScreen - 0" +
          " sname - " +
          SessionTitle.toString() +
          " clientID - " +
          clientId
      );

      var qString = {
        channelName: ChannelID.toString(),
        userId: parseInt(UserID),
        validityHours: parseInt(TokenValidityHours),
        isScreen: 0,
        sname: SessionTitle.toString(),
        clientId: clientId,
      };
      var encParam = "";
      var videoURL = VideoBaseURL;

      $.ajax({
        url: videoParamsEncryptURL,
        headers: {
          "Content-Type": "application/json",
        },
        beforeSend: function () {
          //vm.showLoader();
        },
        type: "POST",
        dataType: "json",
        data: JSON.stringify(qString),
        success: function (data) {
          //vm.hideLoader();
          if (typeof data != "undefined") {
            let lStatusCode = 0;
            lStatusCode = data.status;
            if (lStatusCode == 0) {
              encParam = data.result;
              videoURL = videoURL + "?vt=" + encParam;
              callBackFunction(videoURL, UserID);
              console.log("Get Encrypt URL API Call Success");
            } else {
              //vm.hideLoader();
              alert("Error in opening roundtable. Please retry. ");
              // console.log("Encrypted URL not found in API Call");
              //alert("URL decode has been failed before starting OnAir");
            }
          } else {
            //vm.hideLoader();
            alert("Error in opening roundtable. Please retry. ");
            //console.log("Encrypted URL not found in API Call");
            //alert("URL decode has been failed before starting OnAir");
          }
        },
        error: function () {
          //vm.hideLoader();
          alert("Error in opening roundtable. Please retry. ");
          //console.log("Error in Get Encrypt URL API Call");
          //alert("URL decode has been failed before starting OnAir");
        },
      });
    },
    updateSinglTable: function (tableId, members, iAmInTheTable) {
      // var cnt = members.length;
      //console.log(cnt);
      debugger;
      var img = "";
      var tables = vm.allRoundTables.filter(function (table) {
        return table.id == tableId;
      });
      if (tables.length > 0) {
        //alert("" + tableId);
        var table = tables[0];

        //let table = vm.allRoundTables[i];
        var Capacity = table.Capacity;
        var filteredIds = members.filter(function (value) {
          return value.AttendeeId != table.hostId && value.IsActive == true;
        });
        var cnt = filteredIds.length + 1;

        /*============================================================================================================================================== */
        if (cnt < 1) {
          cnt = 1;
        } else if (cnt > Capacity) {
          cnt = Capacity;
        }
        //==================================================
        //alert("Capacity " + Capacity);
        if (filteredIds.length == members.length) {
          //host inactive
          if (cnt == undefined || cnt <= 0) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 1) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 2) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F02.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 3) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F03.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 4) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F04.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 5) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F05.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 6) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F06.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 7) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F07.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 8) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F08.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 9) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F09.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 10) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F10.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 11) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F11.jpg?alt=media&token=802d8c4a-0c26-4493-a111-dc95d659b6a5";
          } else if (cnt == 12) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F12.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
          } else if (cnt == 13) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F13.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
          } else if (cnt == 14) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F14.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
          } else if (cnt == 15) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F15.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
          } else if (cnt >= 16) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
              Capacity +
              "%2F16.jpg?alt=media";
          }
        } else {
          //host active
          if (cnt == undefined || cnt <= 0) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 1) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 2) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F02.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 3) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F03.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 4) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F04.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 5) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F05.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 6) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F06.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 7) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F07.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 8) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F08.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 9) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F09.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 10) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F10.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
          } else if (cnt == 11) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F11.jpg?alt=media&token=1d49ccca-4d81-4d53-bf95-b635598bc0a8";
          } else if (cnt == 12) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F12.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
          } else if (cnt == 13) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F13.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
          } else if (cnt == 14) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F14.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
          } else if (cnt == 15) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F15.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
          } else if (cnt >= 16) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
              Capacity +
              "%2F16.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
          }
        }

        var tableLabel = "GRAB A SEAT";
        var LabelCss = "grab-a-seat";
        var showTable = false;
        var tableFull = false;
        //alert(table.IsHost);
        if (table.IsHost) {
          //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
          //Join As Speaker
          showTable = true;
        } else if (table.PreAssigned) {
          if (table.IsMappedasAttendee) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Speaker

            showTable = true;
          } else if (table.SpectatorEnabled) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Audience
            showTable = true;
            tableLabel = "SPECTATE";
            LabelCss = "spectate";
          }
        } else if (iAmInTheTable) {
          showTable = true;
        } else if (cnt < table.Capacity) {
          //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
          //Join As Speaker
          showTable = true;
        } else if (table.SpectatorEnabled) {
          //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
          //Join As Audience
          showTable = true;
          tableLabel = "SPECTATE";
          LabelCss = "spectate";
        } else {
          showTable = true;
          tableFull = true;
          tableLabel = "TABLE FULL";
          LabelCss = "table-full";
        }
        //alert(tableLabel);
        /*========================================================================================================== */
        table.IsTblVisible = showTable && table.topicVisibility;
        table.IsVisible = showTable;
        table.IsTableFull = tableFull;
        table.tableLabel = tableLabel;
        table.imgsrc = vm.getCDNUrl(img);
        table.LabelCss = LabelCss;
      }
    },
    getParticipance: function (table) {
      //var arrparticipance = [];
      table.participantList = [];
      db.collection(vm.event_collectionName)
        .doc("RoundTableList")
        .collection("RoundTables")
        .doc(table.id)
        .collection("Participances")
        //.where("IsActive", "==", true)
        .get()
        .then((querySnapshot) => {
          //
          var filteredIds = querySnapshot.docs.filter(function (value) {
            return (
              value.data().AttendeeId != table.hostId &&
              value.data().IsActive == true
            );
          });
          //alert(table.Name + " - " + filteredIds.length);
          var cnt = filteredIds.length + 1;
          /*=================================================================================== */

          /*======================================================================================== */
          var img = "";
          if (cnt == undefined || cnt == 0) {
            img = "https://e2monairuat.e2m.live/Images/06.png";
          } else if (cnt == 1) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FRound%20Tables%2F01.jpg?alt=media";
          } else if (cnt == 2) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FRound%20Tables%2F02.jpg?alt=media";
          } else if (cnt == 3) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FRound%20Tables%2F03.jpg?alt=media";
          } else if (cnt == 4) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FRound%20Tables%2F04.jpg?alt=media";
          } else if (cnt == 5) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FRound%20Tables%2F05.jpg?alt=media";
          } else if (cnt == 6) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FRound%20Tables%2F06.jpg?alt=media";
          }
          table.imgsrc = vm.getCDNUrl(img);

          /*====================================================================================================== */

          var tableLabel = "GRAB A SEAT";
          var showTable = false;
          if (table.PreAssigned) {
            if (table.IsMappedasAttendee) {
              //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
              //Join As Speaker

              showTable = true;
            } else if (table.SpectatorEnabled) {
              //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
              //Join As Audience
              showTable = true;
              tableLabel = "SPECTATE";
            }
          } else if (cnt < table.Capacity) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Speaker
            showTable = true;
          } else if (table.SpectatorEnabled) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Audience
            showTable = true;
            tableLabel = "SPECTATE";
          } else {
            tableLabel = "TABLE FULL";
          }
          table.tableLabel = tableLabel;
          /*========================================================================================================== */
          if (showTable) {
            vm.allRoundTables.push(table);
          }
        });
    },
    getSettings: function () {
      this.selectExpoMenu();
      db.collection(vm.event_collectionName)
        .doc("Settings")
        .collection("Exhibitor")
        .doc("ExhibitorSettings")
        .get()
        .then((doc) => {
          if (doc.exists) {
            vm.scavengerHuntBooths = doc.data().ScavengerHuntBooths || [];
            vm.scavengerHuntRandomBoothEnabled =
              doc.data().ScavengerHuntRandomBoothEnabled || false;
            vm.scavengerHuntMinBooths = doc.data().ScavengerHuntMinBooths || 0;
            vm.scavengerHuntMaxBooths = doc.data().ScavengerHuntMaxBooths || 0;
            vm.CheckScavengerHuntForMe();
            if (doc.data().LockExhibitorBoothSetup) {
              vm.disableEditBtn = doc.data().LockExhibitorBoothSetup;
            }
            // this.ExhibitorSettings.push(
            //   {
            //     AllowAttendeeMeetingWithExhibitors : doc.data().AllowAttendeeMeetingWithExhibitors,
            //     DisplayExhibitorContactsOnBooths:doc.data().DisplayExhibitorContactsOnBooths,
            //     DisplayRoundtablesforExpoBooths:doc.data().DisplayRoundtablesforExpoBooths,
            //     EnableChatOrEmailwithExhibitor:doc.data().EnableChatOrEmailwithExhibitor,
            //     EnableEnhancedExpoMode : doc.data().EnableEnhancedExpoMode,
            //     EnableExhibitorFilterAndSearchOption:doc.data().EnableExhibitorFilterAndSearchOption,
            //     EnableExhibitorShowcaseVideo:doc.data().EnableExhibitorShowcaseVideo,
            //     IsEnhancedHotspotting:doc.data().IsEnhancedHotspotting,
            //     ShowExhibitorCollateralsForDownload:doc.data().ShowExhibitorCollateralsForDownload
            //   }
            // )

            //---------For innitial page load get the settings for VIDEO----------
            //
            vm.EnableExhibitorRepVideoCall =
              doc.data().EnableExhibitorRepVideoCall;
            vm.AllowMoreThan1tojoinRepInVideoCall =
              doc.data().AllowMoreThan1tojoinRepInVideoCall;
            vm.ShowRepActiveStatus = doc.data().ShowRepActiveStatus;
            // if (doc.data().JoinTheConversationText) {
            //   vm.JoinTheConversationTextFormat =
            //     doc.data().JoinTheConversationText;
            // }
            vm.AllowRequestMeetingInExpoHall =
              doc.data().AllowRequestMeetingInExpoHall;
            //else {
            //  vm.JoinTheConversationText =
            //    "Welcome to {BoothName} Our Reps are here to assist you. You can also contact us on {phone} or visit {BoothWebsite}";
            //}
            // Welcome to {{ item.Name }}! Our Reps are here to assist
            //                         you. You can also contact us on
            //                         <a :href="'tel:' + item.Phone">{{ item.Phone }}</a> or
            //                         visit
            //                         <a :href="item.Website">{{ item.Website }}</a>
            //vm.JoinTheConversationText = vm.JoinTheConversationTextFormat.replace(
            //  "{BoothName}",
            //  vm.ExhibitorData[0].Name
            //)
            //  .replace(
            //    "{phone}",
            //    '<a :href="tel:' +
            //      vm.ExhibitorData[0].Phone +
            //      '">' +
            //      vm.ExhibitorData[0].Phone +
            //      "</a>"
            //  )
            //  .replace(
            //    "{BoothWebsite}",
            //    '<a target="_blank" href="' +
            //      vm.ExhibitorData[0].Website +
            //      '">' +
            //      vm.ExhibitorData[0].Website +
            //      "</a>"
            //  );

            // alert(
            //   "vm.EnableExhibitorRepVideoCall - " +
            //     vm.EnableExhibitorRepVideoCall
            // );
            // if (vm.AllowMoreThan1tojoinRepInVideoCall) {
            //   vm.VideoCallEnable = true;
            // } else {
            //   vm.VideoCallEnable = false;
            // }
            //--------------------------------------------------------------------
            //alert(doc.data().ExpoHallBackgroundImage);
            if (doc.data().ExpoHallBackgroundImage) {
              vm.ExpoHallBackgroundImage = vm.getCDNUrl(
                doc.data().ExpoHallBackgroundImage
              );
              //}
              //else {
              //  vm.ExpoHallBackgroundImage =
              //    "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FSymposium%20Exhibitor%20Booth%2Fexpo-bg.jpg?alt=media&token=3eb488b8-32fd-4fae-8d49-b35a4e9a3ded";
              //}
            }
            //else {
            //  vm.ExpoHallBackgroundImage =
            //    "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FSymposium%20Exhibitor%20Booth%2Fexpo-bg.jpg?alt=media&token=3eb488b8-32fd-4fae-8d49-b35a4e9a3ded";
            //}

            //alert(vm.ExpoHallBackgroundImage);
            vm.allowBusinessCardExchange =
              doc.data().AllowBusinessCardExchange == true;
            // alert(doc.data().AllowBusinessCardExchange);
            // if (vm.allowBusinessCardExchange == true) {
            //   $("#divBusinessCard").show();
            //   console.log(
            //     "getSettings divBusinessCard showing------------------"
            //   );
            // } else {
            //   $("#divBusinessCard").hide();
            //   console.log(
            //     "getSettings divBusinessCard hiding------------------"
            //   );
            // }
            if (doc.data().AllowAppointmentInExpoDetails) {
              $("#btnAppointment").show();
            } else {
              $("#btnAppointment").hide();
            }
            if (doc.data().AllowGroupChatInExpoDetails) {
              $("#btnJoinChat").show();
            } else {
              $("#btnJoinChat").hide();
            }

            if (doc.data().EnableExhibitorShowcaseVideo == false) {
              $("a[title$='Video']").hide();
            } else {
              $("a[title$='Video']").show();
            }

            if (doc.data().DisplayExhibitorContactsOnBooths == false) {
              $("a[title$='Start Conversation']").hide();
            } else {
              $("a[title$='Start Conversation']").show();
            }

            if (doc.data().ShowExhibitorCollateralsForDownload == false) {
              $("a[title$='Collateral']").hide();
            } else {
              $("a[title$='Collateral']").show();
            }

            if (doc.data().EnableChatOrEmailwithExhibitor == false) {
              $(".openBroadcast").hide();
              vm.turnONOFFContactsEmailChat = false;
            } else {
              $(".openBroadcast").show();
              vm.turnONOFFContactsEmailChat = true;
            }

            if (doc.data().AllowAttendeeMeetingWithExhibitors == false) {
              $(".reqMeeting").hide();
            } else {
              $(".reqMeeting").show();
            }
            if (doc.data().AllowAttendeeChatWithExhibitors == false) {
              $(".reqChat").hide();
              $("#dvMainRoundTable").removeClass("one-to-one-present");
            } else {
              $("#dvMainRoundTable").addClass("one-to-one-present");
              $(".reqChat").show();
            }

            if (doc.data().DisplayRoundtablesforExpoBooths == false) {
              if (document.getElementById("dvMainRoundTable").parentElement) {
                document.getElementById("dvMainRoundTable").style.visibility =
                  "hidden";
                $("#round-table-tooltip").hide();
              }
            } else {
              if (document.getElementById("dvMainRoundTable").parentElement) {
                document.getElementById("dvMainRoundTable").style.visibility =
                  "visible";
                $("#round-table-tooltip").show();
              }
            }

            if (
              doc.data().EnableExhibitorAutoPlayBoothVideo == false ||
              doc.data().EnableExhibitorAutoPlayBoothVideo == undefined
            ) {
              this.openVideoModal = false;
            } else {
              this.openVideoModal = true;
            }

            vm.showAerialView = doc.data().AllowAerialView;
            if (doc.data().AllowbirdView) {
              //alert(doc.data().AllowbirdView)
              vm.showBirdView = doc.data().AllowbirdView;
            } else {
              vm.showBirdView = false;
            }
          }
          vm.initContactListener();
          vm.boothSettingsLoaded = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // clearRefresh: function () {
    //   clearInterval(interval);
    //   this.removeSelection();
    // },
    selectExpoMenu: function () {
      if ($("#liexhibitor")) {
        $("#liexhibitor")
          .find("a:first")
          .addClass("router-link-exact-active router-link-active");
        //$("#liexhibitor").first().addClass("active");
      }
    },
    removeSelection: function () {
      if ($("#liexhibitor")) {
        $("#liexhibitor")
          .find("a:first")
          .removeClass("router-link-exact-active router-link-active");
      }
    },
    OpenOneToOneChat(data) {
      if (vm.visitor) {
        //common.openRegistrationDialog();
        vm.goToRegistration();
        return;
      }
      var roomList = [];

      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var loggedInUserId = obj.user[0].id;
      var listRef = db
        .collection(vm.event_collectionName)
        .doc("group-chat")
        .collection("chat-rooms")
        .where("userIdList", "array-contains", loggedInUserId);
      listRef.get().then((querySnapshot) => {
        roomList = [];
        querySnapshot.forEach((doc) => {
          if (
            doc.data().userIdList &&
            doc.data().userIdList.length == 2 &&
            doc.data().userIdList.includes(data.AttendeeId)
          ) {
            roomList.push({
              roomId: doc.data().id,
              roomName: doc.data().name ? doc.data().name.trim() : "",
              createdBy: doc.data().createdByUserId,
              roomMembers: doc.data().userIdList,
              lastMessage: doc.data().lastMsg,
              createdDateTime: doc.data().createdDateTime.seconds,
              lastActiveTime: doc.data().lastActivityDtm.seconds,
              iconUrl: vm.getCDNUrl(doc.data().iconUrl),
            });
          }
        });
        if (roomList.length > 0) {
          roomList.map((room) => {
            if (
              room.roomMembers.length == 2 &&
              room.roomMembers.includes(data.AttendeeId)
            ) {
              data.roomId = room.roomId;
              data.roomName = room.roomName;
              data.createdBy = room.createdBy;
              data.roomMembers = room.roomMembers;
              data.lastMessage = room.lastMessage;
              data.createdDateTime = room.createdDateTime;
              data.lastActiveTime = room.lastActiveTime;
              data.iconUrl = room.iconUrl;
              bus.$emit("toggleLoader", true);
              bus.$emit("openExpoIndividualChat", data);
            } else {
              bus.$emit("toggleLoader", true);
              bus.$emit("openExpoIndividualChat", data);
            }
          });
        } else {
          bus.$emit("toggleLoader", true);
          bus.$emit("openExpoIndividualChat", data);
        }
      });
    },
    checkSettingFlagValue() {
      db.collection(vm.event_collectionName)
        .doc("EventInfo")
        .get()
        .then((doc) => {
          if (doc.exists) {
            var docs = doc.data();
            if (docs.Plugins && docs.Plugins.OneToOneChat != undefined) {
              this.defaultChatMsg = docs.Plugins.OneToOneChat.defaultChatMsg;
            }
          }
        })
        .catch((error) => {
          console.log("Error getting documents:", error);
        });
    },
    openListPopup() {
      var x = document.getElementById("float-chat-pannel");
      if (x.style.display === "none") {
        x.style.display = "block";
        bus.$emit("toggleChatIcon", true);
      }
    },
    downloadBrocheures() {
      vm.collectLeaderboardPoint("DREB");
    },
    collectLeaderboardPoint(actionTypeCode, docId) {
      vm.postLeaderboardAction(actionTypeCode, docId);
      if (docId && vm.expoNameForExport) {
        vm.AddEventAnalytics({
          pageName: "/exhibitorsview/" + docId + "/" + vm.expoNameForExport,
          action: "Gamification",
          actionType: "",
          actionLabel: "Play",
        });
      }
    },
    Register(boothId, eventShortName, eventFullName) {
      if (!vm.hasValidAuth({ auth_type: 1 })) {
        return;
      }
      debugger;
      vm.registering = true;
      var user = vm.getSessionUserProfile();
      if (user && user.UserId && user.Email != "visitor@e2m.live") {
        let headers = {
          "Content-Type": "application/json",
        };
        var requestData = {};

        requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: vm.clientId,
          },
          PrimaryData: {
            //UserId: user.UserId,
            FirstName: user.FirstName,
            LastName: user.LastName,
            Email: user.Email,
            Phone: user.Phone,
            Company: user.Company,
            Designation: user.Designation,
            ProfileImageURL: user.ProfileImageURL,
            "Event Short Name": eventShortName,
            "Event Full Name": eventFullName,
          },
          MetaData: {},
        };
        axios
          .post(APIs.AddToSpreadsheet, requestData, { headers: headers })
          .then(function (res) {
            debugger;
            vm.registering = false;
            if (res.data.status == 0) {
              vm.eventRegSuccessDialog = true;
              console.log("res-----", res);
            }
          })
          .catch(() => {
            vm.registering = false;
            console.log("error");
          });
      } else {
        vm.registering = false;
        let eventId = vm.getEventId();
        router.push(
          "/?&event_id=" +
            eventId +
            "&redirect_url=/exhibitorsview/" +
            boothId +
            "/" +
            eventShortName
        );
      }
    },
    goToRegistration() {
      if (!vm.hasValidAuth({ auth_type: 1 })) {
        return;
      }
      //ExhibitorData[0].id, ExhibitorData[0].Name, podiumTitle
      bus.$emit("toggleLoader", true);
      //vm.clickOpenOption();
      let eventId = vm.getEventId();
      if (vm.clientId && eventId) {
        let redirect_url =
          "/exhibitorsview/" +
          vm.ExhibitorData[0].id +
          "/" +
          vm.ExhibitorData[0].Name;
        vm.getCheckoutFormJson(
          vm.clientId,
          eventId,
          1,
          true,
          redirect_url,
          true
        );
      }
    },
  },
};
</script>
